
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7R96I", function(module, exports) {
$parcel$export(module.exports, "SignupPage", function () { return $a9da468d6e1d7d51$export$a2f4b65ede167ce5; });

var $7VQPk = parcelRequire("7VQPk");

var $PZFk0 = parcelRequire("PZFk0");
const $a9da468d6e1d7d51$export$a2f4b65ede167ce5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $PZFk0.SignupPageTemplate), {});

});
parcelRegister("PZFk0", function(module, exports) {
$parcel$export(module.exports, "SignupPageTemplate", function () { return $ff930e1e2c5ab266$export$7f87cfb81bb27126; });
/* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7NyFd = parcelRequire("7NyFd");

var $gPKCY = parcelRequire("gPKCY");

var $2WL8B = parcelRequire("2WL8B");

var $3dtkR = parcelRequire("3dtkR");

var $7GVWk = parcelRequire("7GVWk");

var $1Q6XY = parcelRequire("1Q6XY");

var $22G6d = parcelRequire("22G6d");

var $cxW2A = parcelRequire("cxW2A");

var $2gCne = parcelRequire("2gCne");

var $1ka2O = parcelRequire("1ka2O");

var $e4ax9 = parcelRequire("e4ax9");

var $lSXuE = parcelRequire("lSXuE");

var $cm5a1 = parcelRequire("cm5a1");

var $bIqzQ = parcelRequire("bIqzQ");

var $ds3R2 = parcelRequire("ds3R2");
const $ff930e1e2c5ab266$export$7f87cfb81bb27126 = ({ featureFlags: featureFlags })=>{
    const location = (0, $1ka2O.useLocation)();
    const { bundle: useProductIntentBundle } = (0, $3dtkR.useProductIntent)(location.href);
    const { product: product, bundle: bundle, edition: edition, migrationSourceUuid: migrationSourceUuid, layout: layout } = (0, $cxW2A.getQueryParams)(location.search);
    if ((0, $ds3R2.handleSignupRouteRedirects)({
        product: product,
        bundle: bundle
    })) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ff930e1e2c5ab266$export$51898f39b04ffae9, {
        bundle: useProductIntentBundle,
        edition: edition,
        layout: layout,
        featureFlags: {
            ...(0, $22G6d.defaultFeatureFlags),
            ...featureFlags
        },
        migrationSourceUuid: migrationSourceUuid
    });
};
const $ff930e1e2c5ab266$export$51898f39b04ffae9 = ({ bundle: bundle, edition: edition, layout: layout, featureFlags: featureFlags, migrationSourceUuid: migrationSourceUuid })=>{
    (0, $7NyFd.useUFOComponentExperience)((0, $gPKCY.ufoEventPaidSignupLandingPageLoad));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($ff930e1e2c5ab266$var$SignUpComponent, {
                bundleOverride: bundle,
                editionOverride: edition,
                layout: layout,
                featureFlags: {
                    ...(0, $22G6d.defaultFeatureFlags),
                    ...featureFlags
                },
                migrationSourceUuid: migrationSourceUuid
            })
        })
    });
};
// TODO: Temporary fix for hot-120109
const $ff930e1e2c5ab266$var$SignUpComponent = ({ layout: layout = 'first-impressions', migrationSourceUuid: migrationSourceUuid })=>{
    const { user: userProfile } = (0, $7GVWk.useUserContext)();
    const isDeveloperBundle = (0, $2WL8B.useDeveloperBundleIntent)();
    const ProductSignupComponent = (0, $bIqzQ.useProductSignupComponent)();
    const countryCode = // @ts-ignore
    typeof window !== 'undefined' ? window.countryCode : undefined;
    const blockedLocales = [
        'RU',
        'BY'
    ];
    (0, $1oC0p.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $2gCne.getLocalStorage)((0, $1Q6XY.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $1Q6XY.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    if (countryCode && blockedLocales.includes(countryCode)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e4ax9.ErrorLocale), {
        locale: countryCode
    });
    if (userProfile.requestInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
    if (isDeveloperBundle) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cm5a1.DeveloperBundleSignup), {});
    // Render product-specific signup component if conditions are met
    if (layout !== 'standalone' && !migrationSourceUuid && ProductSignupComponent) return /*#__PURE__*/ (0, $7VQPk.jsx)(ProductSignupComponent, {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
};

});
parcelRegister("cxW2A", function(module, exports) {
$parcel$export(module.exports, "FIRST_IMPRESSIONS_LAYOUT", function () { return $6f67151914a5cca6$export$fe242ee9cf24682a; });
$parcel$export(module.exports, "getQueryParams", function () { return $6f67151914a5cca6$export$e2de15bbd9edf9c6; });
const $6f67151914a5cca6$export$fe242ee9cf24682a = 'first-impressions';
const $6f67151914a5cca6$export$e2de15bbd9edf9c6 = (search)=>{
    const params = new URLSearchParams(search);
    const edition = params.get('edition') ?? 'free';
    const migrationSourceUuid = params.get('migrationSourceUuid') ?? undefined;
    const developer = params.get('developer') ?? undefined;
    let bundle = params.get('bundle');
    let layout = $6f67151914a5cca6$export$fe242ee9cf24682a;
    const product = params.get('product');
    const isN2NParam = params.get('n2n') === 'true';
    if (bundle) ;
    else if (product?.includes(',')) bundle = '';
    else switch(product){
        case 'jira-servicedesk.ondemand':
            bundle = 'jira-service-management';
            break;
        case 'confluence.ondemand':
            bundle = 'confluence';
            break;
        case 'jira-product-discovery':
            bundle = 'jira-product-discovery';
            break;
        case 'jira-servicedesk.ondemand,jira-software.ondemand':
            bundle = 'jira-service-management-jira-software';
            break;
        case 'jira-software.ondemand':
        default:
            bundle = 'jira-software';
            break;
    }
    if (migrationSourceUuid || developer) layout = 'default';
    return {
        bundle: bundle,
        edition: edition,
        isN2NParam: isN2NParam,
        layout: layout,
        product: product,
        migrationSourceUuid: migrationSourceUuid,
        developer: developer
    };
};

});

parcelRegister("e4ax9", function(module, exports) {
$parcel$export(module.exports, "ErrorLocale", function () { return $62425de461105a94$export$33e78fd3ecccdefd; });
/* error-locale.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3RaC6 = parcelRequire("3RaC6");

var $5YGzb = parcelRequire("5YGzb");
const $62425de461105a94$export$33e78fd3ecccdefd = ({ locale: locale })=>{
    const intl = (0, $8e22h.default)();
    const localeErrorHeader = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.localeErrorHeader',
        defaultMessage: 'We stand with Ukraine'
    });
    const localeErrorButtonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.localeErrorButtonText',
        defaultMessage: 'Learn more'
    });
    const localeErrorMessage = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.localeErrorMessage',
        defaultMessage: 'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        createAnalyticsEvent({
            event: 'blocked',
            action: 'blocked',
            actionSubject: 'signUp',
            actionSubjectId: 'signUpForm',
            product: 'marketing',
            blockType: 'geoIP',
            blockValue: locale
        }).fire('signup');
    }, [
        createAnalyticsEvent,
        locale
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "error-locale",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _y3gn1h6o _p12f1m00 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _bfhk1hxd _1e0c1txw _4t3iuuw1 _1bah1h6o _6rthqslr _1bsb1osq _p12f1mjv"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                children: localeErrorHeader
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: localeErrorMessage
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                appearance: "link",
                href: "https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine",
                children: localeErrorButtonText
            })
        ]
    });
};
const $62425de461105a94$var$containerCss = null;
const $62425de461105a94$var$logoContainerCss = null;

});

parcelRegister("lSXuE", function(module, exports) {
$parcel$export(module.exports, "SignupDefault", function () { return $a285ab61339779a4$export$f40c117d87f58af; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $gfjAv = parcelRequire("gfjAv");

var $3dtkR = parcelRequire("3dtkR");

var $22G6d = parcelRequire("22G6d");

var $cxW2A = parcelRequire("cxW2A");

var $cJEN6 = parcelRequire("cJEN6");

var $j2b52 = parcelRequire("j2b52");

var $hfzfc = parcelRequire("hfzfc");

var $4X0dO = parcelRequire("4X0dO");

var $1ka2O = parcelRequire("1ka2O");

var $imwOb = parcelRequire("imwOb");

const $a285ab61339779a4$var$SignUpLayoutContainer = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("6JEoq")));
const $a285ab61339779a4$export$f40c117d87f58af = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const labels = (0, $cJEN6.useLabelsLocalized)((0, $22G6d.defaultLabels));
    const { layout: layout } = (0, $cxW2A.getQueryParams)(location?.search ?? '');
    const { bundle: bundle, edition: edition } = (0, $3dtkR.useProductIntent)(location.href);
    const intl = (0, $8e22h.default)();
    const treatmentLabels = (0, $1oC0p.useMemo)(()=>(0, $imwOb.getBitbucketSignupPrValueTreatmentLabels)(labels, intl), [
        intl,
        labels
    ]);
    const renderSignup = (0, $1oC0p.useCallback)((signupLabels)=>// @ts-expect-error missing attributes
        /*#__PURE__*/ (0, $7VQPk.jsx)($a285ab61339779a4$var$SignUpLayoutContainer, {
            layout: layout,
            allowSignupWithGoogle: true,
            allowSignupWithAllSocialOptions: true,
            bundleOverride: bundle,
            editionOverride: edition,
            productData: (0, $22G6d.defaultProductData),
            enableFreeBreachTest: true,
            labels: signupLabels,
            firstImpressionsImageUrls: (0, $22G6d.firstImpressionsImageUrls),
            featureFlags: (0, $22G6d.defaultFeatureFlags)
        }), [
        bundle,
        edition,
        layout
    ]);
    const renderExperiment = (0, $1oC0p.useCallback)((isEnabled)=>renderSignup(isEnabled ? treatmentLabels : labels), [
        labels,
        renderSignup,
        treatmentLabels
    ]);
    const isFirstImpressionsLayout = layout === (0, $cxW2A.FIRST_IMPRESSIONS_LAYOUT);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
            intentType: "form",
            productKey: bundle,
            edition: edition,
            children: isFirstImpressionsLayout ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfzfc.ExperimentView), {
                experiment: (0, $4X0dO.experiments).twcg2271BitbucketSignupPrValue,
                render: renderExperiment
            }) : renderSignup(labels)
        })
    });
};

});
parcelRegister("cJEN6", function(module, exports) {
$parcel$export(module.exports, "useLabelsLocalized", function () { return $f49fc1258632453e$export$80220bbf3ed08337; });

var $8e22h = parcelRequire("8e22h");
function $f49fc1258632453e$export$80220bbf3ed08337(labels) {
    const intl = (0, $8e22h.default)();
    return Object.assign({}, labels, {
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText',
            defaultMessage: 'Trusted by over 65,000 teams worldwide'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI',
            defaultMessage: 'Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI',
            defaultMessage: '{newline}Access all features{newline}Scale agile practices{newline}Consolidate workflows{newline}Plan, track, and release'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI',
            defaultMessage: 'Access all features{newline}Scale agile practices{newline}Consolidate workflows{newline}Plan, track, and release'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence',
            defaultMessage: 'Trusted by over 75,000 teams worldwide'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare',
            defaultMessage: 'Simplify your status reporting'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence',
            defaultMessage: 'Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence',
            defaultMessage: 'Access all features{newline}Kickstart team collaboration{newline}Capture all the knowledge{newline}Build admirable content'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence',
            defaultMessage: 'Access all features{newline}Kickstart team collaboration{newline}Capture all the knowledge{newline}Build admirable content'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD',
            defaultMessage: 'Powering high-velocity service teams'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI',
            defaultMessage: 'Access all features{newline}Resolve issues as a team{newline}Quickly answer common questions{newline}Automate incident management'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery',
            defaultMessage: 'Transform product ideas into business impact'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery',
            defaultMessage: 'Capture ideas and data from anywhere{newline}Prioritize the work that will make an impact{newline}Keep stakeholders informed and engaged{newline}Fully integrated with Jira Software for delivery'
        }, {
            newline: '{newline}'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket',
            defaultMessage: 'Included build minutes and Git LFS\nNative Jira integration\nEasily extensible\nSecure & reliable'
        }),
        'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket': intl.formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket',
            defaultMessage: 'Source code management & CI/CD'
        })
    });
}

});

parcelRegister("imwOb", function(module, exports) {
$parcel$export(module.exports, "getBitbucketSignupPrValueTreatmentLabels", function () { return $f5e8aa8230b1fea3$export$c7026a9ae223085; });

var $iW2OD = parcelRequire("iW2OD");
const $f5e8aa8230b1fea3$export$c7026a9ae223085 = (labels, intl)=>({
        ...labels,
        [(0, $iW2OD.BITBUCKET_PR_VALUE_HEADING_LABEL)]: intl.formatMessage((0, $iW2OD.bitbucketSignupPrValueMessages).heading),
        [(0, $iW2OD.BITBUCKET_PR_VALUE_FEATURES_LABEL)]: [
            intl.formatMessage((0, $iW2OD.bitbucketSignupPrValueMessages).aiPullRequestDescriptions),
            intl.formatMessage((0, $iW2OD.bitbucketSignupPrValueMessages).codeReviewWorkflow),
            intl.formatMessage((0, $iW2OD.bitbucketSignupPrValueMessages).jiraUpdates),
            intl.formatMessage((0, $iW2OD.bitbucketSignupPrValueMessages).builtInCiCd)
        ].join('\n')
    });

});
parcelRegister("iW2OD", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_PR_VALUE_HEADING_LABEL", function () { return $12c837b9d1cd56a6$export$7d1567812bcfa717; });
$parcel$export(module.exports, "BITBUCKET_PR_VALUE_FEATURES_LABEL", function () { return $12c837b9d1cd56a6$export$67d5af79e1f98d16; });
$parcel$export(module.exports, "bitbucketSignupPrValueMessages", function () { return $12c837b9d1cd56a6$export$399cbe48d232089a; });

var $fnHPc = parcelRequire("fnHPc");
const $12c837b9d1cd56a6$export$7d1567812bcfa717 = 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket';
const $12c837b9d1cd56a6$export$67d5af79e1f98d16 = 'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket';
const $12c837b9d1cd56a6$export$399cbe48d232089a = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'BitbucketSignupPrValue.heading',
        defaultMessage: 'Ship better pull requests, faster'
    },
    aiPullRequestDescriptions: {
        id: 'BitbucketSignupPrValue.aiPullRequestDescriptions',
        defaultMessage: 'Draft clear pull request descriptions with AI'
    },
    codeReviewWorkflow: {
        id: 'BitbucketSignupPrValue.codeReviewWorkflow',
        defaultMessage: 'Review code and resolve feedback in one workflow'
    },
    jiraUpdates: {
        id: 'BitbucketSignupPrValue.jiraUpdates',
        defaultMessage: 'Keep Jira updated from branches, commits, and PRs'
    },
    builtInCiCd: {
        id: 'BitbucketSignupPrValue.builtInCiCd',
        defaultMessage: 'Secure, reliable CI/CD built in'
    }
});

});


parcelRegister("6JEoq", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("cOEDe"),
    $eao4m("4sqCM"),
    $eao4m("cle9L"),
    $eao4m("bFVA4"),
    $eao4m("748A0")
]).then(()=>parcelRequire('fPNim'));

});
parcelRegister("eao4m", function(module, exports) {
"use strict";

function $a504ab8c5934a050$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hwrhg")).resolve(id));
}
module.exports = $a504ab8c5934a050$var$load;

});
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});




parcelRegister("cm5a1", function(module, exports) {
$parcel$export(module.exports, "DeveloperBundleSignup", function () { return $106e3f373cce20a6$export$51e4e1afc260cf9b; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $2WL8B = parcelRequire("2WL8B");

var $eRzlV = parcelRequire("eRzlV");

var $e9I0Z = parcelRequire("e9I0Z");

var $lSXuE = parcelRequire("lSXuE");

var $ibCWp = parcelRequire("ibCWp");

var $gGwJ3 = parcelRequire("gGwJ3");
const $106e3f373cce20a6$export$51e4e1afc260cf9b = ()=>{
    const isLoggedIn = (0, $2WL8B.useLoggedIn)();
    if (isLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gGwJ3.DeveloperBundleTemplate), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ibCWp.CreateYourAccount), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Login: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {}),
                getContinueUrl: ()=>`${(0, $eRzlV.getWacIntegrationUrl)()}/try/cloud/signup?developer=true`
            })
        ]
    });
};

});
parcelRegister("e9I0Z", function(module, exports) {
$parcel$export(module.exports, "NoCreditCardRequired", function () { return $404708b4b88503b2$export$fcb2a6b9b0e7a09a; });
/* no-credit-card-required.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $404708b4b88503b2$export$fcb2a6b9b0e7a09a = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _k48pbfng _1dyzt94y _19pkzwfg _2hwxidpf _otyrzwfg _18u0idpf _y3gn1h6o _1p1dangw"
        ]),
        children: formatMessage({
            id: 'WacSignupForm.FirstImpressions.noCreditCardRequiredFooter',
            defaultMessage: 'No credit card required'
        })
    });
};
const $404708b4b88503b2$var$noCreditCardRequiredCss = null;

});

parcelRegister("ibCWp", function(module, exports) {
$parcel$export(module.exports, "CreateYourAccount", function () { return $63ad44f61e729be2$export$bbe60781f289f93; });
/* create-your-account.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $63ad44f61e729be2$export$bbe60781f289f93 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
        className: (0, $2jatx.default)([
            "_1wyb1k92 _k48pbfng _1dyznl7k _vwz4cjiy _1pfhidpf _6rth1ul9"
        ]),
        children: "Create your account"
    });
const $63ad44f61e729be2$var$headingCss = null;

});

parcelRegister("gGwJ3", function(module, exports) {
$parcel$export(module.exports, "DeveloperBundleTemplate", function () { return $4d3329a383b0b54a$export$c86b9a922e24a7b5; });
/* developer-bundle-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $5YGzb = parcelRequire("5YGzb");

var $kbpa7 = parcelRequire("kbpa7");
const $4d3329a383b0b54a$export$c86b9a922e24a7b5 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _1rjc1k92"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                    size: "large",
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_izbqj0fz _1e0c1txw _2lx21sxn _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1whb _ccaej0fz _1lp7vrvc _14b512er"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0q1k8s _u5f31k8s _n3td1k8s _19bv1k8s _1ako1wto _c7s71wto _4puv1wto _1r3v1wto"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1wyb8pqr _k48pbfng _vwz413ei _6rth1j6v _1pfhidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "WacSignupForm.sideInfoHeaderBundleDeveloperMode",
                                    defaultMessage: "Cloud Developer Bundle"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_179rj0fz _1wyb1k8s _k48pbfng _1dyznl7k _vwz4ye00 _6rth1k8s _1pfh1k92 _85i56mu8"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "WacSignupHeader.cloudStandard",
                                    defaultMessage: "Cloud Standard"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "signup.developerBundle.sideInfoMessage",
                                defaultMessage: "<p>You are signing up for free development sites of Atlassian cloud products. This gives you access to the standard versions of Jira Software, Jira Service Management, and Confluence, which are free forever.</p><p>Free development sites are intended to be used for development and testing purposes only and have the usage limits noted below. Atlassian does not offer support for free development sites and reserves the right to delete such sites at any time without notice. Atlassian monitors the usage of such development sites and may cancel any site being used in an unauthorized or unintended manner.</p><ul><li>Confluence: 5 users free</li><li>Jira Software: 5 users free</li><li>Service Collection: 1 agent free</li><li>All products: Up to 250 GB of file storage</li><li>All products: Advanced permissions</li></ul>",
                                values: $4d3329a383b0b54a$var$renderHtml
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0q1k8s _u5f31k8s _n3td1k8s _19bv1k8s _1ako1wto _c7s71wto _4puv1wto _1r3v1wto"
                        ]),
                        children: children
                    })
                ]
            })
        ]
    });
const $4d3329a383b0b54a$var$renderHtml = {
    p: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: chunks
        }),
    ul: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                "_ca0qebcm _u5f3idpf _n3tdud5o _19bv1k92"
            ]),
            children: chunks
        }),
    li: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            className: (0, $2jatx.default)([
                "_ect41vau _1wybimiu _2mzuglyw _6rth1skh _kqswh2mm _18cr1554 _1kt9b3bt _cfu11o8l _kfgtw1gv _iajm1skh _z5wtj24u _1cs8stnw _1mp4w1gv"
            ]),
            style: {
                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
            },
            children: chunks
        })
};
const $4d3329a383b0b54a$var$columnCss = null;
const $4d3329a383b0b54a$var$headerCss = null;
const $4d3329a383b0b54a$var$headingCss = null;
const $4d3329a383b0b54a$var$subHeadingCss = null;
const $4d3329a383b0b54a$var$liCss = null;
const $4d3329a383b0b54a$var$rowCss = null;
const $4d3329a383b0b54a$var$ulCss = null;

});


parcelRegister("bIqzQ", function(module, exports) {
$parcel$export(module.exports, "useProductSignupComponent", function () { return $8fe8a0596e6585c9$export$2c26e027ccfa3cfb; });

var $fcO7r = parcelRequire("fcO7r");

var $7GVWk = parcelRequire("7GVWk");

var $ebLge = parcelRequire("ebLge");

var $lSyjH = parcelRequire("lSyjH");

var $iLlOX = parcelRequire("iLlOX");

var $kUuAX = parcelRequire("kUuAX");

var $gxozr = parcelRequire("gxozr");

var $j6bad = parcelRequire("j6bad");

var $d8Fm9 = parcelRequire("d8Fm9");

var $g57i2 = parcelRequire("g57i2");

var $03fSi = parcelRequire("03fSi");

var $pdokA = parcelRequire("pdokA");
const $8fe8a0596e6585c9$var$PRODUCT_MAPPINGS = {
    [(0, $fcO7r.ProductKey).JIRA_SOFTWARE]: (0, $kUuAX.JiraSignup),
    [(0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT]: (0, $j6bad.JsmSignup),
    [(0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY]: (0, $gxozr.JpdSignup),
    [(0, $fcO7r.ProductKey).DEVAI]: (0, $iLlOX.DevAiSignup),
    [(0, $fcO7r.ProductKey).COMPASS]: (0, $ebLge.CompassSignup),
    [(0, $fcO7r.ProductKey).CONFLUENCE]: (0, $lSyjH.ConfluenceSignup),
    [(0, $fcO7r.ProductKey).LOOM]: (0, $d8Fm9.LoomSignup),
    [(0, $fcO7r.ProductKey).SERVICE_COLLECTION]: (0, $g57i2.ServiceCollectionSignup),
    [(0, $fcO7r.ProductKey).STATUSPAGE]: (0, $03fSi.StatuspageSignup),
    [(0, $fcO7r.ProductKey).TEAMWORK_COLLECTION]: (0, $pdokA.TeamworkCollectionSignup)
};
const $8fe8a0596e6585c9$export$2c26e027ccfa3cfb = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    if (product && product.key in $8fe8a0596e6585c9$var$PRODUCT_MAPPINGS) return $8fe8a0596e6585c9$var$PRODUCT_MAPPINGS[product.key];
    return null;
};

});
parcelRegister("ebLge", function(module, exports) {
$parcel$export(module.exports, "CompassSignup", function () { return $58400deb6e1bd352$export$c5c064e8c4b75cfc; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $lSXuE = parcelRequire("lSXuE");

var $6zvvP = parcelRequire("6zvvP");
const $58400deb6e1bd352$export$c5c064e8c4b75cfc = ()=>{
    const loggedOut = (0, $2WL8B.useLoggedOut)();
    if (loggedOut) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6zvvP.LoggedOut), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
};

});
parcelRegister("6zvvP", function(module, exports) {
$parcel$export(module.exports, "LoggedOut", function () { return $0e2271507ee97089$export$98c2fc75a8b753f; });
/* logged-out.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $6KUQg = parcelRequire("6KUQg");

var $3lcPU = parcelRequire("3lcPU");

var $2WL8B = parcelRequire("2WL8B");

var $hnmMQ = parcelRequire("hnmMQ");

var $e9I0Z = parcelRequire("e9I0Z");
const $0e2271507ee97089$export$98c2fc75a8b753f = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const standard = (0, $2WL8B.useStandardIntent)();
    const premium = (0, $2WL8B.usePremiumIntent)();
    const productEditionText = premium ? formatMessage({
        id: 'WacSignupHeader.cloudPremium',
        defaultMessage: 'Cloud Premium'
    }) : standard ? formatMessage({
        id: 'WacSignupHeader.cloudStandard',
        defaultMessage: 'Cloud Standard'
    }) : formatMessage({
        id: 'WacSignupHeader.cloudFree',
        defaultMessage: 'Cloud Free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96/Compass_SignUpPage_Illo%20(5).svg',
                alt: ''
            }
        }),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.CompassLogo), {
                size: "xlarge",
                appearance: "inverse"
            }, "compass")
        ],
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCompass',
            defaultMessage: 'Create a better developer experience with Compass'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeCompass',
            defaultMessage: 'Reduce context switching with a comprehensive software catalog{newline}Keep your architecture reliable, performant, and secure with scorecards and metrics{newline}Connect your existing tools and data and create custom integrations for a bespoke developer experience'
        }).replace(/\n/g, '{newline}') // replace all newlines with a placeholder so we can split on it
        .replace(/&rsquo;/g, "\u2019") // replace the &rsquo; with an actual apostrophe
        .split('{newline}'),
        showAtlassianLogo: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybviql _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard',
                    defaultMessage: 'Start now'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Login: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
            })
        ]
    });
};
const $0e2271507ee97089$var$headingCss = null;

});
parcelRegister("3lcPU", function(module, exports) {
$parcel$export(module.exports, "BlueWaveTemplate", function () { return $714b4424af37041e$export$a1c646a51ab27cd4; });
/* blue-wave-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5YGzb = parcelRequire("5YGzb");

var $kbpa7 = parcelRequire("kbpa7");
const $714b4424af37041e$export$a1c646a51ab27cd4 = ({ illustration: illustration, productEditionText: productEditionText, productLogos: productLogos, socialProofLogos: socialProofLogos, tagline: tagline, valueProps: valueProps, showAtlassianLogo: showAtlassianLogo = true, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1itk16y6 _12vemgnk _1e0c1txw _2lx21bp4 _zulpckbl _1q51gktf _1j96gktf _jvmrgktf _k0msgktf _1b7pgktf _9szs1f51"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_gy1p1tcg _1e0c1txw _1n261g80 _1p571y44 _1xdi1ule _1ii71ule _l9z01osq _4x201osq _1ytiidpf _6q26idpf _7yhb1wug _gncu1wug _1bdkidpf _ujqdidpf _24rc1wug _t7bl1wug"
                        ]),
                        children: productLogos
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_syaz1afi _ect41vau _1wybgktf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: productEditionText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp14no _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1wud _1bsb1osq _1lp71gnb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1afi _1e0c1txw _2lx21bp4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1osq _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsbc1vo _1bah1yb4 _zs121wa3 _11ur1wa3 _1o7p7vkz _1rnl7vkz _epkxftgi _zg7p1wm2 _oqiczwfg _1rmjzwfg _cjbtzwfg _pnmbzwfg"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: [
                            children,
                            showAtlassianLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bah1h6o _6rthidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                                    appearance: "brand",
                                    size: "xsmall"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: [
                            illustration && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bah1h6o _6rthftgi _bna7194s"
                                ]),
                                children: illustration
                            }),
                            tagline && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wybgktf _k48p4jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: tagline
                            }),
                            socialProofLogos && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_syazp4k8 _1e0c1txw _1bah1h6o"
                                ]),
                                style: {
                                    "--_1aetymw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light500'))
                                },
                                children: socialProofLogos
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _1bah1h6o"
                                ]),
                                children: valueProps && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                    className: (0, $2jatx.default)([
                                        "_k48pb4wl _24bq1noq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bozg7vkz _1eg6ftgi _1xnlidpf _53osftgi _138kidpf"
                                    ]),
                                    children: valueProps.map((prop, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            children: prop
                                        }, index))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $714b4424af37041e$var$atlassianLogoCss = null;
const $714b4424af37041e$var$containerCss = null;
const $714b4424af37041e$var$contentColumnCss = null;
const $714b4424af37041e$var$formColumnCss = null;
const $714b4424af37041e$var$headerCss = null;
const $714b4424af37041e$var$illustrationCss = null;
const $714b4424af37041e$var$mainCss = null;
const $714b4424af37041e$var$productEditionTextCss = null;
const $714b4424af37041e$var$productLogosCss = null;
const $714b4424af37041e$var$socialProofCss = null;
const $714b4424af37041e$var$taglineCss = null;
const $714b4424af37041e$var$valuePropsContainerCss = null;
const $714b4424af37041e$var$valuePropsCss = null;

});



parcelRegister("lSyjH", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSignup", function () { return $030b4f00014c3ff4$export$50998478fcad0009; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $i0twc = parcelRequire("i0twc");

var $fdqaj = parcelRequire("fdqaj");
const $030b4f00014c3ff4$export$50998478fcad0009 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i0twc.LoggedInConfluence), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fdqaj.LoggedOutConfluence), {});
};

});
parcelRegister("i0twc", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluence", function () { return $37522fcf1159371b$export$7899443e35ffdb87; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $4UZOR = parcelRequire("4UZOR");

var $4crer = parcelRequire("4crer");

var $b1Nfb = parcelRequire("b1Nfb");
const $37522fcf1159371b$export$7899443e35ffdb87 = ()=>{
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b1Nfb.LoggedInConfluenceStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4crer.LoggedInConfluencePremium), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4UZOR.LoggedInConfluenceFree), {});
};

});
parcelRegister("4UZOR", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceFree", function () { return $6f9a777da583035a$export$6f1d4f9d0052bd8d; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $gBuNn = parcelRequire("gBuNn");

var $gXFZc = parcelRequire("gXFZc");

var $9bvys = parcelRequire("9bvys");

var $iZWrX = parcelRequire("iZWrX");
const $6f9a777da583035a$export$6f1d4f9d0052bd8d = ()=>{
    const cohort = (0, $2WL8B.useCohort)(true);
    if (cohort === 'current-product-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXFZc.CurrentProductUser), {});
    if (cohort === 'current-product-joinable-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gBuNn.CurrentProductJoinableUser), {});
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZWrX.NewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9bvys.ExistingUser), {});
    return null;
};

});
parcelRegister("gBuNn", function(module, exports) {
$parcel$export(module.exports, "CurrentProductJoinableUser", function () { return $09524eb4a944b7bc$export$805d233848710db8; });
/* current-product-joinable-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $bGrkd = parcelRequire("bGrkd");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $3rmYt = parcelRequire("3rmYt");

var $emciF = parcelRequire("emciF");
const $09524eb4a944b7bc$export$805d233848710db8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.ConfluenceOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3rmYt.JoinableSitesText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};
const $09524eb4a944b7bc$var$containerCss = null;

});
parcelRegister("dpXXQ", function(module, exports) {
$parcel$export(module.exports, "Headings", function () { return $f820610526cd255b$export$68f204e81c0385d; });
/* headings.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $f820610526cd255b$export$68f204e81c0385d = ({ main: main, sub: sub })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulpu2gc _ct361wug _6rthpxbi _1i4q1hna _y3gn1h6o _1nmz1hna"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syazi7uo _ect41vau _1wybzwfg _k48p1fw0 _vwz410nf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                },
                children: main
            }),
            sub && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazi7uo _1wybdlk8 _vwz419ii _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: sub
            })
        ]
    });
};
const $f820610526cd255b$var$headerCss = null;
const $f820610526cd255b$var$mainHeadingCss = null;
const $f820610526cd255b$var$subHeadingCss = null;

});

parcelRegister("3rmYt", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesText", function () { return $34c0d410eeb22b80$export$cbb826910c56c503; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $34c0d410eeb22b80$export$cbb826910c56c503 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.siteActivation.joinableSites.subheader",
        defaultMessage: "Select where you\u2019d like to get started."
    });

});

parcelRegister("emciF", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackText", function () { return $1ad6827e78c91041$export$42bca95ad2a8a353; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");
const $1ad6827e78c91041$export$42bca95ad2a8a353 = ()=>{
    const { user: user } = (0, $7GVWk.useUserContext)();
    if (!user.isUserLoggedIn) return null;
    const name = (0, $5AtlP.getFirstName)(user.name);
    return name.length ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
        values: {
            name: name,
            scribbleSpan: $1ad6827e78c91041$var$scribbleSpan
        }
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.welcomeBackNoName",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back",
        values: {
            scribbleSpan: $1ad6827e78c91041$var$scribbleSpan
        }
    });
};
const $1ad6827e78c91041$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $2jatx.default)([
                    "_lswuuol8 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $1ad6827e78c91041$var$accentImageCss = null;
const $1ad6827e78c91041$var$scribbleSpanCss = null;

});


parcelRegister("gXFZc", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $08f23d2382f4063a$export$ef5a5fe6477555d4; });
/* current-product-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $dRayu = parcelRequire("dRayu");

var $emciF = parcelRequire("emciF");
const $08f23d2382f4063a$export$ef5a5fe6477555d4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.ConfluenceOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRayu.ReturnToProductText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};
const $08f23d2382f4063a$var$containerCss = null;

});
parcelRegister("dRayu", function(module, exports) {
$parcel$export(module.exports, "ReturnToProductText", function () { return $471c7b16ecc1ac9f$export$b5b45e1eb7f09cb2; });
/* return-to-product-subheading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $471c7b16ecc1ac9f$export$b5b45e1eb7f09cb2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "return-to-product-modal.header.text",
        defaultMessage: "Pick up where you left off."
    });
const $471c7b16ecc1ac9f$export$3fa7fda86d069ee0 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($471c7b16ecc1ac9f$export$b5b45e1eb7f09cb2, {})
    });
const $471c7b16ecc1ac9f$var$subHeaderCss = null;

});


parcelRegister("9bvys", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $234824d14f3ee171$export$706672462bf25099; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $izdHQ = parcelRequire("izdHQ");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $234824d14f3ee171$export$706672462bf25099 = ()=>{
    const useContactExpandCohortLogic = (0, $2WL8B.useIsConfluenceContactCompanyExpandEligible)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-3467-signup-with-image-overlay",
        group: "isTreatment",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.ConfluenceOverlayTemplate), {
            size: "sm",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForTenUsersText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    useContactExpandCohortLogic: useContactExpandCohortLogic
                })
            ]
        })
    });
};

});
parcelRegister("eccoL", function(module, exports) {
$parcel$export(module.exports, "SubHeading", function () { return $ea892e1354a7f52e$export$210dc657affc8afd; });
$parcel$export(module.exports, "FreeForTenUsersText", function () { return $ea892e1354a7f52e$export$e91e80344617a92a; });
$parcel$export(module.exports, "FreeForThreeCreatorsText", function () { return $ea892e1354a7f52e$export$e86fe653dd1ca66d; });
$parcel$export(module.exports, "FreeToGetStartedText", function () { return $ea892e1354a7f52e$export$1aa2d8670bb6a2e9; });
$parcel$export(module.exports, "PickUpWhereYouLeftOffText", function () { return $ea892e1354a7f52e$export$aac741cc615e29fa; });
$parcel$export(module.exports, "SitesAreSharedSpacesText", function () { return $ea892e1354a7f52e$export$83898237d89e9cbe; });
$parcel$export(module.exports, "WorkspacesAreWhereText", function () { return $ea892e1354a7f52e$export$64724b649b2ac792; });
$parcel$export(module.exports, "YourPlanIncludesText", function () { return $ea892e1354a7f52e$export$8fa34d2f714b2985; });
/* sub-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $ea892e1354a7f52e$export$210dc657affc8afd = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkftgi _2hwxidpf _otyr7vkz _18u0idpf _y3gn1h6o"
        ]),
        children: children
    });
const $ea892e1354a7f52e$var$subheadingCss = null;
const $ea892e1354a7f52e$export$e91e80344617a92a = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
    });
const $ea892e1354a7f52e$export$e86fe653dd1ca66d = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signupForm.accountCreation.subHeaderText.jpd.freeForThreeCreators",
        defaultMessage: "It's free for up to 3 creators - no credit card needed."
    });
const $ea892e1354a7f52e$export$1aa2d8670bb6a2e9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signupForm.accountCreation.subHeaderText.jpd.freeToGetStarted",
        defaultMessage: "It's free to get started - no credit card needed."
    });
const $ea892e1354a7f52e$export$aac741cc615e29fa = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "return-to-product-modal.header.text",
        defaultMessage: "Pick up where you left off."
    });
const $ea892e1354a7f52e$export$83898237d89e9cbe = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "LoomTemplate.loggedInHero.subheader",
        defaultMessage: "Sites are shared spaces to organize work, teams, and projects."
    });
const $ea892e1354a7f52e$export$64724b649b2ac792 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.serviceCollection.newUser",
        defaultMessage: "Workspaces are where people organize teams, work, and projects."
    });
const $ea892e1354a7f52e$export$8fa34d2f714b2985 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.serviceCollection.newUser",
        defaultMessage: "Your plan includes Jira Service Management, Customer Service Management, Assets, and Rovo. Free for up to 3 agents."
    });

});


parcelRegister("iZWrX", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $b90d8b7f9f54a765$export$17cbb676e2e98676; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $izdHQ = parcelRequire("izdHQ");

var $69EgE = parcelRequire("69EgE");

var $dpXXQ = parcelRequire("dpXXQ");
const $b90d8b7f9f54a765$export$17cbb676e2e98676 = ()=>{
    const confluenceWorkspaceText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader",
        defaultMessage: "This is the URL for your team to access Confluence. Most people use their team or company name."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-3467-signup-with-image-overlay",
        group: "isTreatment",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.ConfluenceOverlayTemplate), {
            size: "sm",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69EgE.CreateAWorkspaceText), {}),
                    sub: confluenceWorkspaceText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};

});
parcelRegister("69EgE", function(module, exports) {
$parcel$export(module.exports, "CreateAWorkspaceText", function () { return $c84b49b7df2afd1d$export$7cbf1c55898449b7; });
/* create-a-workspace-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $c84b49b7df2afd1d$export$7cbf1c55898449b7 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "signup.createAWorkspace",
                defaultMessage: "Create a workspace"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 57 52",
                className: (0, $2jatx.default)([
                    "_lswuuol8 _4t3i1ex1 _u7co1y44 _rjxp1muf _kqswstnw _1bsb1mcy"
                ]),
                style: {
                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                    })
                ]
            })
        ]
    });
const $c84b49b7df2afd1d$export$e5bbc44a458bfe26 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
        className: (0, $2jatx.default)([
            "_1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($c84b49b7df2afd1d$export$7cbf1c55898449b7, {})
    });
const $c84b49b7df2afd1d$var$accentImageCss = null;
const $c84b49b7df2afd1d$var$accentImageParentCss = null;
const $c84b49b7df2afd1d$var$headingCss = null;

});



parcelRegister("4crer", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluencePremium", function () { return $393ac0d8e7afb9d7$export$b95b7dbaa2ce1828; });

var $7VQPk = parcelRequire("7VQPk");

var $88ieO = parcelRequire("88ieO");

var $8e22h = parcelRequire("8e22h");
const $393ac0d8e7afb9d7$export$b95b7dbaa2ce1828 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $88ieO.LoggedInConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("88ieO", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceBlueWaveTemplate", function () { return $1a19e7a8f5e6338b$export$92826040495825a8; });
/* logged-in-confluence-blue-wave-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $3lcPU = parcelRequire("3lcPU");

var $bGrkd = parcelRequire("bGrkd");

var $bs458 = parcelRequire("bs458");

var $33py5 = parcelRequire("33py5");

var $jgBbG = parcelRequire("jgBbG");

var $2HR6E = parcelRequire("2HR6E");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $4hd0c = parcelRequire("4hd0c");

var $e9I0Z = parcelRequire("e9I0Z");

var $9Zmgh = parcelRequire("9Zmgh");

var $3SMzf = parcelRequire("3SMzf");

var $kzyzK = parcelRequire("kzyzK");

var $7tN5i = parcelRequire("7tN5i");
const $1a19e7a8f5e6338b$export$92826040495825a8 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    // Upgradeable Standard Sites Experiment
    const existingSites = (0, $kzyzK.useGetExistingSites)();
    const siteActivationContent = existingSites ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {
        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3SMzf.SubmitButtonMessageNext), {})
    }) : undefined;
    const useContactExpandCohortLogic = (0, $2WL8B.useIsConfluenceContactCompanyExpandEligible)();
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    if (!user.isUserLoggedIn || !cohort) return null;
    const showingReturnToProduct = cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER || cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER;
    const username = (0, $5AtlP.getFirstName)(user.name);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7tN5i.HubspotDockerTwilioGoPro), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence',
            defaultMessage: 'Trusted by over 75,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence',
            defaultMessage: 'Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content'
        }, {
            newline: '{newline}'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg',
                alt: ''
            }
        }),
        showAtlassianLogo: !showingReturnToProduct,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi _6rthckbl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "WacSignupForm.signupFormPersonalizedGreeting",
                        defaultMessage: "Welcome back, {username}",
                        values: {
                            username: username
                        }
                    })
                }),
                !showingReturnToProduct && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hd0c.InputEmail), {
                    email: user.email
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    existingSites: existingSites,
                    useContactExpandCohortLogic: useContactExpandCohortLogic,
                    UpgradeEligibleUser: siteActivationContent,
                    CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                    CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                    WeekOneUser: siteActivationContent ?? null,
                    ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                        SitePicker: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_84yz1wa3 _eeia15se _5pvqc4v4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {})
                        }),
                        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Zmgh.SubmitButtonExistingUser), {})
                    })
                }),
                !showingReturnToProduct && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
            ]
        })
    });
};
const $1a19e7a8f5e6338b$var$containerCss = null;
const $1a19e7a8f5e6338b$var$siteActivationHeadingCss = null;
const $1a19e7a8f5e6338b$var$sitePickerCss = null;

});
parcelRegister("4hd0c", function(module, exports) {
$parcel$export(module.exports, "InputEmail", function () { return $058ba9561f756edd$export$497a6aaf7dad75ee; });
/* input-email.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $3RaC6 = parcelRequire("3RaC6");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $kbpa7 = parcelRequire("kbpa7");
const $058ba9561f756edd$export$497a6aaf7dad75ee = ({ email: email })=>{
    return email ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                isDisabled: true,
                name: "email",
                label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _ect4z4z1 _1wybdlk8 _k48p1nn1"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.nameSite.inputEmailLabel",
                        defaultMessage: "Work email"
                    })
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1cgv7vkz _1b7z1nn1 _jxt4z4z1 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszrftgi"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            type: "text",
                            ...fieldProps,
                            value: email
                        })
                    })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                appearance: "link",
                onClick: ()=>{
                    window.location.href = (0, $gZgIU.getSwitchAccountUrl)();
                },
                className: (0, $2jatx.default)([
                    "_18zrgrf3"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1wyb8oy7 _syazrbzz"
                    ]),
                    style: {
                        "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.nameSite.switchAccountText",
                        defaultMessage: "Sign in with a different Atlassian account"
                    })
                })
            })
        ]
    }) : null;
};
const $058ba9561f756edd$var$inputCss = null;
const $058ba9561f756edd$var$labelCss = null;
const $058ba9561f756edd$var$switchAccountCss = null;
const $058ba9561f756edd$var$switchAccountInnerCss = null;

});

parcelRegister("9Zmgh", function(module, exports) {
$parcel$export(module.exports, "SubmitButtonExistingUser", function () { return $261065fa0ad4016f$export$e9e0ae87001e8e1b; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $261065fa0ad4016f$export$e9e0ae87001e8e1b = ()=>{
    const intl = (0, $8e22h.default)();
    const submitMessage = intl.formatMessage({
        id: 'WacSignupForm.FirstImpressions.submitButtonLabel',
        defaultMessage: 'Agree'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});

parcelRegister("3SMzf", function(module, exports) {
$parcel$export(module.exports, "SubmitButtonMessageNext", function () { return $cf073f3bd8b9bbb0$export$eab894fbb6777d1c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $cf073f3bd8b9bbb0$export$eab894fbb6777d1c = ()=>{
    const intl = (0, $8e22h.default)();
    const submitMessage = intl.formatMessage({
        id: 'WacSignupForm.upgradeButtonText.messageNext',
        defaultMessage: 'Next'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});

parcelRegister("kzyzK", function(module, exports) {
$parcel$export(module.exports, "useGetExistingSites", function () { return $90341b7d62e42b72$export$f04b45a3c19b7cf; });

var $1oC0p = parcelRequire("1oC0p");

var $2WL8B = parcelRequire("2WL8B");
function $90341b7d62e42b72$export$f04b45a3c19b7cf() {
    const isStandardToPremiumUpgradeEligible = (0, $2WL8B.useIsStandardToPremiumUpgradeEligible)();
    const upgradeableStandardSites = (0, $2WL8B.useUpgradableStandardSites)();
    const upgradableSites = (0, $2WL8B.useUpgradableSites)();
    return (0, $1oC0p.useMemo)(()=>{
        return isStandardToPremiumUpgradeEligible ? [
            ...upgradeableStandardSites ?? [],
            ...upgradableSites ?? []
        ] : undefined;
    }, [
        isStandardToPremiumUpgradeEligible,
        upgradeableStandardSites,
        upgradableSites
    ]);
}

});

parcelRegister("7tN5i", function(module, exports) {
$parcel$export(module.exports, "HubspotDockerTwilioGoPro", function () { return $383785e8d08db092$export$7314c49b0f4c7701; });

var $7VQPk = parcelRequire("7VQPk");
const $383785e8d08db092$export$7314c49b0f4c7701 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.1 13.87v5.11h-4.7v-5.11H8.18v12.2h2.22v-4.93h4.7v4.93h2.23v-12.2H15.1zM24.46 22.13a1.85 1.85 0 1 1-3.69 0v-5.22h-2.11v5.23a4 4 0 0 0 7.91 0v-5.23h-2.11v5.22ZM40.13 17.44A1.3 1.3 0 0 1 41.62 16a3.21 3.21 0 0 1 2 1.05L45 15.47a4.33 4.33 0 0 0-3.24-1.59c-2.29 0-4 1.35-4 3.58 0 4.12 5 2.81 5 5.13a1.45 1.45 0 0 1-1.48 1.34 2.58 2.58 0 0 1-2.23-1.25l-1.54 1.59a4.54 4.54 0 0 0 3.65 1.82c2.18 0 3.93-1.35 3.93-3.48 0-4.61-5.05-3.18-5-5.17M71.37 24.13c-1.24 0-1.6-.54-1.6-1.37v-3.67h1.94v-1.85h-1.94v-2.45l-2.14 1v7.46c0 1.91 1.32 2.87 3.12 2.87a5.83 5.83 0 0 0 .84-.06l.53-1.92h-.75M32.51 17A3.27 3.27 0 0 0 30 18v-4h-2.1v7.4a4.44 4.44 0 0 0 4.28 4.69 4.63 4.63 0 0 0 4.72-4.56A4.47 4.47 0 0 0 32.51 17m0 7a2.4 2.4 0 1 1 2.4-2.4A2.39 2.39 0 0 1 32.5 24M55.51 21.42a4.64 4.64 0 0 0-4.72-4.57 4.46 4.46 0 0 0-4.28 4.7V29h2.12v-4a3.26 3.26 0 0 0 2.48 1 4.49 4.49 0 0 0 4.4-4.55m-2 0A2.4 2.4 0 1 1 51.1 19a2.39 2.39 0 0 1 2.4 2.41"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.33 16.82v-2.11a1.62 1.62 0 0 0 .94-1.46v-.05a1.61 1.61 0 0 0-1.62-1.62A1.61 1.61 0 0 0 60 13.2v.05a1.62 1.62 0 0 0 .94 1.46v2.11a4.62 4.62 0 0 0-2.18 1L53 13.28a1.76 1.76 0 0 0 .06-.46 1.84 1.84 0 1 0-1.84 1.83 1.89 1.89 0 0 0 .9-.24l5.68 4.42a4.63 4.63 0 0 0 .07 5.2l-1.77 1.73a1.23 1.23 0 0 0-.42-.07 1.51 1.51 0 1 0 1.5 1.51 1.54 1.54 0 0 0-.06-.43l1.71-1.71a4.62 4.62 0 0 0 5.61-7.33 4.68 4.68 0 0 0-2.11-.91m-.71 6.93A2.37 2.37 0 1 1 64 21.38a2.37 2.37 0 0 1-2.37 2.37"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M205.15 15.36h-3a.15.15 0 0 0-.14.14v1.75a.15.15 0 0 0 .14.13h3a.15.15 0 0 0 .14-.13V15.5c.03-.07-.04-.14-.14-.14Zm0 2.61h-5.82a.27.27 0 0 0-.21.13l-.79 2.9v.14L197.4 18a.23.23 0 0 0-.21-.13h-2.26a.28.28 0 0 0-.2.13l-.86 2.85v.14-.07l-.34-1.41-.38-1.4a.22.22 0 0 0-.21-.14h-4.56v-2.44a.17.17 0 0 0-.2-.14l-2.88.9c-.1 0-.14.06-.14.13V18h-.75a.14.14 0 0 0-.14.13v2.2a.14.14 0 0 0 .14.13h.75v2.68c0 1.88 1 2.78 2.92 2.78a4.6 4.6 0 0 0 2.05-.45v-2.29c0-.11-.1-.14-.17-.14a1.83 1.83 0 0 1-.82.17c-.52 0-.79-.2-.79-.79v-2H190a.15.15 0 0 0 .13-.14v-1.8l2.16 7.17a.26.26 0 0 0 .21.13h2.4a.28.28 0 0 0 .2-.13l1-3.19.52 1.64.48 1.51a.22.22 0 0 0 .2.14h2.4a.3.3 0 0 0 .21-.14l2.19-7.2v7.2a.15.15 0 0 0 .14.14h2.91a.15.15 0 0 0 .14-.14v-7.47a.15.15 0 0 0-.14-.17Zm3.85-2.61h-3a.15.15 0 0 0-.14.14v10.11a.15.15 0 0 0 .14.14h3a.15.15 0 0 0 .14-.14V15.5a.15.15 0 0 0-.14-.14Zm3.88 0h-3a.15.15 0 0 0-.14.14v1.75a.15.15 0 0 0 .14.13h3a.15.15 0 0 0 .14-.13V15.5a.198.198 0 0 0-.19-.14Zm0 2.61h-2.91a.14.14 0 0 0-.14.13v7.51a.15.15 0 0 0 .14.14h2.91a.15.15 0 0 0 .14-.14v-7.47a.15.15 0 0 0-.23-.14Zm4.84-.18a4.19 4.19 0 0 0-4.39 4.08 4.38 4.38 0 0 0 8.74 0 4.15 4.15 0 0 0-4.44-4.08Zm1.23 4.08a1.25 1.25 0 0 1-1.23 1.34 1.31 1.31 0 0 1-1.27-1.37 1.25 1.25 0 0 1 1.23-1.34 1.32 1.32 0 0 1 1.18 1.37ZM173.57 12a8.57 8.57 0 1 0 8.57 8.57 8.57 8.57 0 0 0-8.57-8.57Zm0 14.88a6.31 6.31 0 1 1 6.31-6.31 6.29 6.29 0 0 1-6.31 6.31Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "175.7",
                cy: "18.45",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "175.7",
                cy: "22.7",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "171.45",
                cy: "22.7",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "171.45",
                cy: "18.45",
                r: "1.78"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M258.39 17.53c1.32 0 1.95-.23 1.95-.69v-2.28c0-.46-.63-.69-1.95-.69h-2.83c-1.32 0-1.95.22-1.95.68v2.29c0 .46.63.68 1.95.68Zm0 1.09h-2.83q-3.54 0-3.54-1.86v-2.12c0-1.25 1.18-1.86 3.54-1.86h2.83c2.37 0 3.55.61 3.55 1.86v2.12c0 1.24-1.18 1.86-3.55 1.86Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M288.78 17.53h-2.84c-1.32 0-1.95-.23-1.95-.69v-2.28c0-.46.63-.69 1.95-.69h2.84c1.32 0 1.94.23 1.94.69v2.28c0 .46-.62.69-1.94.69Zm0 1.09q3.54 0 3.54-1.86v-2.12c0-1.25-1.18-1.86-3.54-1.86h-2.84c-2.36 0-3.54.61-3.54 1.86v2.12q0 1.86 3.54 1.86Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M250.38 16.73v-1.47c0-.31-.19-.46-.59-.46h-3.46a.6.6 0 0 0 0 1.19h2.37v.79c0 .23-.31.46-.82.6a4.23 4.23 0 0 1-1.12.12H243c-1.52 0-2.28-.25-2.28-.76V13c0-.5.92-.73 2.73-.73h1.07c.41 0 .61-.18.61-.55s-.2-.55-.61-.55h-1.53a7.61 7.61 0 0 0-2.5.36c-.86.29-1.44.81-1.44 1.48v3.72c0 .7.47 1.2 1.41 1.52a8 8 0 0 0 2.53.35h3.82a6.58 6.58 0 0 0 2.37-.38c.83-.33 1.25-.83 1.25-1.5"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M273.44 14.08c0 .6-.74.78-2.21.78h-5.94v-2.57h5.94c1.47 0 2.21.17 2.21.77Zm.23-2.58a8.78 8.78 0 0 0-2.44-.31h-7.15a.49.49 0 0 0-.48.48v6.46c0 .32.2.49.59.49h.5c.38 0 .59-.17.59-.49V16h6a7.62 7.62 0 0 0 2.51-.35c.92-.33 1.39-.87 1.39-1.61v-1.2c-.05-.59-.54-1.04-1.51-1.34Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M280.69 12.78a6.84 6.84 0 0 0-2.95.33 1.63 1.63 0 0 0-1.17 1.47v3.57c0 .31.19.47.57.47h.48c.37 0 .57-.16.57-.47v-3.57c0-.51.62-.72 1.84-.72h.69c.4 0 .59-.19.59-.54s-.21-.54-.62-.54"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M239 28.02h11.57v-7.58H239v7.58z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.92 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M266.83 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M280.75 28.02h11.57v-7.58h-11.57v7.58z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M117.38 16a.63.63 0 0 0-.66.61v3.19a3.52 3.52 0 0 0-5 .54 3.62 3.62 0 0 0-.77 2.22 3.53 3.53 0 1 0 7 .12v-6a.67.67 0 0 0-.18-.47.78.78 0 0 0-.49-.18m-.84 7.4a2.21 2.21 0 0 1-1.17 1.18 2.26 2.26 0 0 1-1.73 0 2.13 2.13 0 0 1-1.15-1.17 2.21 2.21 0 0 1 0-1.71 2.13 2.13 0 0 1 1.15-1.17 2.26 2.26 0 0 1 1.73 0 2.15 2.15 0 0 1 1.17 1.18 2.07 2.07 0 0 1 0 1.69"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M124.74 20.06a3.56 3.56 0 1 0 1.05 2.61v-.12a3.75 3.75 0 0 0-.27-1.36 3.52 3.52 0 0 0-.78-1.13m-.45 3.33a2.2 2.2 0 0 1-.48.69 2.29 2.29 0 0 1-.69.47 2.26 2.26 0 0 1-1.73 0 2.18 2.18 0 0 1-1.17-1.16 2.2 2.2 0 0 1 1.17-2.89 2.35 2.35 0 0 1 1.73 0 2.2 2.2 0 0 1 .69.48 2.52 2.52 0 0 1 .48.69 2.32 2.32 0 0 1 0 1.72"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M139.32 19.66a.73.73 0 0 0-.2-.46 1.21 1.21 0 0 0-.22-.15 1 1 0 0 0-.25-.05.8.8 0 0 0-.36.09l-3.76 2.45v-4.88a.65.65 0 0 0-.18-.46.69.69 0 0 0-.47-.2.66.66 0 0 0-.66.65v8.75a.65.65 0 0 0 .18.46.64.64 0 0 0 .93 0 .62.62 0 0 0 .19-.46v-2.27l.76-.49 2.91 3.27a.59.59 0 0 0 .43.16.55.55 0 0 0 .26-.05.58.58 0 0 0 .21-.15 1.59 1.59 0 0 0 .15-.21 1 1 0 0 0 0-.25.76.76 0 0 0-.17-.46l-2.7-3 2.63-1.71a.57.57 0 0 0 .27-.54"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M128.39 21a2.34 2.34 0 0 1 .71-.48 2.48 2.48 0 0 1 .86-.17 2.13 2.13 0 0 1 .76.13 2.17 2.17 0 0 1 .68.41.64.64 0 0 0 .42.15.59.59 0 0 0 .48-.19.67.67 0 0 0 .19-.47.64.64 0 0 0-.23-.5A3.4 3.4 0 0 0 130 19a3.54 3.54 0 1 0 2.29 6.22.66.66 0 0 0 .21-.49.63.63 0 0 0-.61-.65.73.73 0 0 0-.43.13 2.28 2.28 0 0 1-.66.41 2 2 0 0 1-.76.14 2.18 2.18 0 0 1-.86-.18 2.1 2.1 0 0 1-.71-.47 2.23 2.23 0 0 1 0-3.14"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.41 19.47a1.28 1.28 0 0 0-.44-.27 2.4 2.4 0 0 0-.59-.13 4 4 0 0 0-.6 0 3.41 3.41 0 0 0-1.18.21 3.77 3.77 0 0 0-1 .57v-.13a.65.65 0 0 0-.69-.62.64.64 0 0 0-.63.62v5.74a.67.67 0 0 0 .69.63.65.65 0 0 0 .63-.63v-2.9a2.16 2.16 0 0 1 .17-.86 2 2 0 0 1 .48-.69 2.52 2.52 0 0 1 .69-.48 2.31 2.31 0 0 1 .86-.17 2.57 2.57 0 0 1 .87.15.64.64 0 0 0 .28.07.53.53 0 0 0 .25 0 .51.51 0 0 0 .21-.15.66.66 0 0 0 .15-.21 1 1 0 0 0 .05-.25.62.62 0 0 0-.18-.45"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.29 21.19A3.58 3.58 0 0 0 143 19a3.52 3.52 0 0 0-3.53 3.52 3.53 3.53 0 0 0 3.53 3.56 3.48 3.48 0 0 0 2.3-.85.77.77 0 0 0 .15-.16.68.68 0 0 0-.16-.93.67.67 0 0 0-.82.08l-.09.09a1.81 1.81 0 0 1-.63.36 1.91 1.91 0 0 1-.75.12 2.15 2.15 0 0 1-.71-.11 2.57 2.57 0 0 1-.62-.31 1.94 1.94 0 0 1-.49-.5 1.9 1.9 0 0 1-.31-.62h5a.67.67 0 0 0 .47-.19.54.54 0 0 0 .18-.46 4.08 4.08 0 0 0-.25-1.4m-5.39.72a1.7 1.7 0 0 1 .3-.62 2.08 2.08 0 0 1 1.12-.81 2 2 0 0 1 .69-.11 2 2 0 0 1 .69.11 2.27 2.27 0 0 1 1.42 1.43Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.77 17.47a3.18 3.18 0 0 0-2-.5 4.93 4.93 0 0 0-1 .09 3.78 3.78 0 0 0-1.7-2.55l-.35-.2-.22.32a4.4 4.4 0 0 0-.61 1.42 3.31 3.31 0 0 0 .4 2.64 4.63 4.63 0 0 1-1.75.43H86.88a.73.73 0 0 0-.75.73 11.41 11.41 0 0 0 .69 4 6.09 6.09 0 0 0 2.4 3.15 10.55 10.55 0 0 0 5.25 1.13 15.84 15.84 0 0 0 2.91-.27 12 12 0 0 0 3.81-1.38 10.6 10.6 0 0 0 2.59-2.12 14.3 14.3 0 0 0 2.54-4.36h.22a3.67 3.67 0 0 0 2.68-1 2.94 2.94 0 0 0 .7-1l.09-.3Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M88.34 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.19.19 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.24 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.19.19 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M94.2 18.65h2.1a.19.19 0 0 0 .19-.18v-1.89a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.11 18.65h2.1a.19.19 0 0 0 .19-.18v-1.89a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.24 16h2.1a.2.2 0 0 0 .18-.19v-1.93a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.2.2 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M94.2 16h2.1a.21.21 0 0 0 .19-.19v-1.93a.19.19 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.11 16h2.1a.21.21 0 0 0 .19-.19v-1.93a.2.2 0 0 0-.19-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.11 13.26h2.1a.2.2 0 0 0 .19-.19v-1.88a.2.2 0 0 0-.19-.19h-2.1a.2.2 0 0 0-.19.19v1.88a.19.19 0 0 0 .19.19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M100.05 18.65h2.1a.19.19 0 0 0 .18-.18v-1.89a.19.19 0 0 0-.18-.18h-2.1a.19.19 0 0 0-.19.18v1.89a.18.18 0 0 0 .19.18"
            })
        ]
    });

});



parcelRegister("b1Nfb", function(module, exports) {
$parcel$export(module.exports, "LoggedInConfluenceStandard", function () { return $511ad0290608640a$export$fc75c0072efce545; });

var $7VQPk = parcelRequire("7VQPk");

var $88ieO = parcelRequire("88ieO");

var $8e22h = parcelRequire("8e22h");
const $511ad0290608640a$export$fc75c0072efce545 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $88ieO.LoggedInConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudStandard',
            defaultMessage: 'Cloud Standard'
        })
    });
};

});


parcelRegister("fdqaj", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluence", function () { return $7632c30d8585423c$export$503b52f3bcb382d7; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $kEZzl = parcelRequire("kEZzl");

var $exxpJ = parcelRequire("exxpJ");

var $jcWk4 = parcelRequire("jcWk4");
const $7632c30d8585423c$export$503b52f3bcb382d7 = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    switch(edition){
        case 'premium':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $exxpJ.LoggedOutConfluencePremium), {});
        case 'standard':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jcWk4.LoggedOutConfluenceStandard), {});
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kEZzl.LoggedOutConfluenceFree), {});
    }
};

});
parcelRegister("kEZzl", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluenceFree", function () { return $162c7ce0cf4b323b$export$7bfce75e49986fcd; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $gwyhT = parcelRequire("gwyhT");

var $izdHQ = parcelRequire("izdHQ");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $it3hk = parcelRequire("it3hk");
const $162c7ce0cf4b323b$export$7bfce75e49986fcd = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "logged-out-confluence-free",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2409-v2-cobranding-signup",
            group: "test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                experimentKey: "jfind-1192-signup-button-update-cfind",
                group: "test",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                    experimentKey: "cfind-3467-signup-with-image-overlay",
                    group: "isTreatment",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.ConfluenceOverlayTemplate), {
                        size: "sm",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
                                    productName: "Confluence"
                                }),
                                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForTenUsersText), {})
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                                Submit: null
                            })
                        ]
                    })
                })
            })
        })
    });
};

});
parcelRegister("fvoZ8", function(module, exports) {
$parcel$export(module.exports, "JPDGetStartedText", function () { return $5503cbca95fef9cc$export$ab39967f91ba9358; });
$parcel$export(module.exports, "JSMGetStartedText", function () { return $5503cbca95fef9cc$export$63600f80ebb24e46; });
$parcel$export(module.exports, "JSMCrossflowGetStartedText", function () { return $5503cbca95fef9cc$export$40dcd735805d280f; });
$parcel$export(module.exports, "GetStartedText", function () { return $5503cbca95fef9cc$export$df2224c359c9c454; });
$parcel$export(module.exports, "GetStartedHeading", function () { return $5503cbca95fef9cc$export$32ef2fbdeab4d330; });
/* get-started-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $5503cbca95fef9cc$export$ab39967f91ba9358 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader.jpd",
        defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with{br}Jira Product Discovery",
        values: {
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            scribbleSpan: $5503cbca95fef9cc$var$scribbleSpan
        }
    });
const $5503cbca95fef9cc$export$1c65fb7cfb572551 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($5503cbca95fef9cc$export$a8a3e93435678ff9, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($5503cbca95fef9cc$export$ab39967f91ba9358, {})
    });
};
const $5503cbca95fef9cc$export$63600f80ebb24e46 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader.jpd",
        defaultMessage: "<scribbleSpan>Get started</scribbleSpan> with{br}Service Collection",
        values: {
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            scribbleSpan: $5503cbca95fef9cc$var$scribbleSpan
        }
    });
const $5503cbca95fef9cc$export$40dcd735805d280f = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader.jsmCrossflow",
        defaultMessage: "<scribbleSpan>Get</scribbleSpan> Service Collection to{br} start using Jira Service Management",
        values: {
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            scribbleSpan: $5503cbca95fef9cc$var$scribbleSpan
        }
    });
const $5503cbca95fef9cc$export$df2224c359c9c454 = ({ productName: productName })=>productName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader",
        defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with {productName}",
        values: {
            scribbleSpan: $5503cbca95fef9cc$var$scribbleSpan,
            productName: productName
        }
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader.noProductName",
        defaultMessage: "Get <scribbleSpan>started</scribbleSpan>",
        values: {
            scribbleSpan: $5503cbca95fef9cc$var$scribbleSpan
        }
    });
const $5503cbca95fef9cc$export$32ef2fbdeab4d330 = ({ productName: productName })=>/*#__PURE__*/ (0, $7VQPk.jsx)($5503cbca95fef9cc$export$a8a3e93435678ff9, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($5503cbca95fef9cc$export$df2224c359c9c454, {
            productName: productName
        })
    });
const $5503cbca95fef9cc$export$a8a3e93435678ff9 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
        className: (0, $2jatx.default)([
            "_syazi7uo _ect41vau _1wybzwfg _k48p1fw0 _vwz410nf _18s8vjyi _y3gn1h6o"
        ]),
        style: {
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
        },
        children: children
    });
};
const $5503cbca95fef9cc$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $2jatx.default)([
                    "_lswuuol8 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $5503cbca95fef9cc$var$accentImageCss = null;
const $5503cbca95fef9cc$var$scribbleSpanCss = null;
const $5503cbca95fef9cc$var$h1Css = null;
/**
 * preserves the product name on one line when possible, but doesn't overflow the container (which white-space: nowrap would do)
 *
 * Get started with Jira: one line
 * Get started with Service Collection: two lines
 * Get started with Service Collection Ultra Premium Edition Plus: three lines
 */ // @ts-ignore
const $5503cbca95fef9cc$var$productNameCss = null;

});

parcelRegister("it3hk", function(module, exports) {
$parcel$export(module.exports, "InputSubmitButton", function () { return $50f3a465e96a61aa$export$8a1669598804b0aa; });
/* submit-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $6nMZs = parcelRequire("6nMZs");

var $cGEBM = parcelRequire("cGEBM");

var $1EGiz = parcelRequire("1EGiz");

var $fYkNv = parcelRequire("fYkNv");

var $eLTGI = parcelRequire("eLTGI");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $50f3a465e96a61aa$export$8a1669598804b0aa = ()=>{
    const intl = (0, $8e22h.default)();
    const { formError: formError, hasSubmitted: hasSubmitted, isReadyForInvalid: isReadyForInvalid, isSubmitting: isSubmitting, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    // Deferred-exposure experiment (spark_recommend_work_email_signup): enroll and
    // expose only users whose email is heading toward a personal-domain (evaluated
    // live as they type), and render the treatment nudge for the enrolled
    // treatment arm. `notifyEmailSubmitted` is called on submit-button click (see
    // below) so the hook can fire its `emailChanged` conversion event before the
    // page redirects. See use-recommend-work-email-nudge for details.
    const { showNudge: showWorkEmailNudge, notifyEmailSubmitted: notifyEmailSubmitted } = (0, $eLTGI.useRecommendWorkEmailNudge)({
        email: email
    });
    // Experiment-independent baseline: track every user who enters a personal
    // email (regardless of enrollment / arm), to size the total personal-email
    // population. See use-personal-email-entered for details.
    (0, $1EGiz.usePersonalEmailEntered)({
        email: email
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $gM7M2.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const buttonText = intl.formatMessage({
        id: 'signupForm.accountCreation.signupButton',
        defaultMessage: 'Sign up'
    });
    const helperText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperText',
        defaultMessage: 'Using a work email helps find teammates and boost collaboration.'
    });
    const placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    const errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    const labelText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    const productName = (0, $7GVWk.useUserContext)().product?.key;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvresu3 _1bah1yb4 _zulpftgi _6rth7vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _7hwbi2wt _1osle4h9 _tx14t94y _1bjadkaa _kj1xidpf _62vcmccc _1heu1kw7 _1rwq1t4y _125x1syg _17rn1kw7 _1t2q1kw7 _1q9pbfng _12vqewfl _1vyiewfl _1p1fidpf _d78pglyw"
                        ]),
                        style: {
                            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                            "aria-required": true,
                            isRequired: true,
                            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1o8l _p12f9wyc _1bsb1kdj"
                                ]),
                                children: labelText
                            }),
                            name: "email",
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        isValid === true && "_olzh1cso _1osl1vex _tx14idpf",
                                        isValid === false && "_olzh1wfy _1osl1vex _tx14idpf"
                                    ]),
                                    style: {
                                        "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                        ...fieldProps,
                                        autoComplete: "email",
                                        "aria-describedby": "account_creation_email_help_text",
                                        elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                            valid: isValid
                                        }),
                                        onBlur: ()=>setIsReadyForInvalid(true),
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            setTypeAheadEmail(e.target.value);
                                            fieldProps.onChange(e);
                                        },
                                        placeholder: placeholderText,
                                        testId: "email_field",
                                        type: "email",
                                        value: email
                                    })
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            type: "submit",
                            // Fire the experiment's `emailChanged` conversion event
                            // synchronously on click, before the form's submit handler
                            // redirects the page. The hook self-gates (nudged user +
                            // previously-personal + valid business email), so this is a
                            // no-op for everyone else, including clicks with an invalid email.
                            onClick: ()=>notifyEmailSubmitted(email),
                            isDisabled: isSubmitting || hasSubmitted && !formError,
                            isLoading: isSubmitting || hasSubmitted && !formError,
                            dataEventProps: {
                                'data-product-key': productName,
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'signup',
                                'data-label': 'sign-up',
                                'data-label-english': 'Sign up'
                            },
                            className: (0, $2jatx.default)([
                                "_2rkoi2wt _1wybdlk8 _4t3i4vtr _o5721q9c _ect41kw7 _1ul91wug _1rjcftgi"
                            ]),
                            children: buttonText
                        })
                    })
                ]
            }),
            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "account_creation_email_help_text",
                role: "alert",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o _1wybepq8 _vwz4bs82 _syaznbxb"
                ]),
                style: {
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                },
                children: errorMessageText
            }) : showWorkEmailNudge ? null : helperText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "account_creation_email_help_text",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o _1wybepq8 _vwz4bs82 _tzy4txnc"
                ]),
                style: {
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                },
                children: helperText
            }) : null,
            showWorkEmailNudge && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fYkNv.RecommendWorkEmailNudge), {})
        ]
    });
};
const $50f3a465e96a61aa$var$containerCss = null;
const $50f3a465e96a61aa$var$inputCss = null;
const $50f3a465e96a61aa$var$labelChildCss = null;
const $50f3a465e96a61aa$var$buttonCss = null;
const $50f3a465e96a61aa$var$supportingText = null;
const $50f3a465e96a61aa$var$helpTextCss = null;
const $50f3a465e96a61aa$var$errorMessageCss = null;
const $50f3a465e96a61aa$var$inputInvalidCss = null;
const $50f3a465e96a61aa$var$inputValidCss = null;

});
parcelRegister("1EGiz", function(module, exports) {
$parcel$export(module.exports, "usePersonalEmailEntered", function () { return $37bec8ba10fbf488$export$9ef12c24b5bb3359; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $gM7M2 = parcelRequire("gM7M2");

var $bZfqV = parcelRequire("bZfqV");

var $dtubO = parcelRequire("dtubO");
const $37bec8ba10fbf488$export$9ef12c24b5bb3359 = ({ email: email })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // One-shot guard: only the first transition into "valid personal email
    // entered" is recorded, so later edits (or clearing the field) do not re-fire.
    const hasFiredRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFiredRef.current && (0, $gM7M2.emailIsValid)(email) && (0, $bZfqV.isPersonalDomain)(email)) {
            hasFiredRef.current = true;
            (0, $dtubO.firePersonalEmailEnteredAnalytics)({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        email,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("bZfqV", function(module, exports) {
$parcel$export(module.exports, "isPersonalDomain", function () { return $f017e48f66fe418c$export$fb4ff965f818da6; });
$parcel$export(module.exports, "isLikelyPersonalDomain", function () { return $f017e48f66fe418c$export$96ba2fba6748f863; });
$parcel$export(module.exports, "isBusinessDomain", function () { return $f017e48f66fe418c$export$7d0830a28936a458; });

var $gM7M2 = parcelRequire("gM7M2");
/**
 * Common free / personal email providers. When a user signs up with an address
 * on one of these domains we treat it as a "personal" (non-work) email and can
 * nudge them toward using a work email instead.
 *
 * This list mirrors the intent of the data-side `signup_domain_type = 'PERSONAL'`
 * classification. It is intentionally conservative — only well-known consumer
 * providers are included so we don't mis-flag small-company domains.
 */ const $f017e48f66fe418c$var$PERSONAL_EMAIL_DOMAINS = new Set([
    // Google
    'gmail.com',
    'googlemail.com',
    // Microsoft
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    // Yahoo
    'yahoo.com',
    'yahoo.co.uk',
    'yahoo.co.in',
    'ymail.com',
    'rocketmail.com',
    // Apple
    'icloud.com',
    'me.com',
    'mac.com',
    // Privacy-focused
    'proton.me',
    'protonmail.com',
    'pm.me',
    'tutanota.com',
    'tuta.io',
    // Other common consumer providers
    'aol.com',
    'gmx.com',
    'gmx.net',
    'mail.com',
    'zoho.com',
    'yandex.com',
    'yandex.ru',
    'fastmail.com',
    'hey.com'
]);
const $f017e48f66fe418c$export$fb4ff965f818da6 = (email = '')=>{
    const [localPart, domain, ...rest] = email.trim().toLowerCase().split('@');
    // Require a well-formed "local@domain" shape with exactly one "@" and a
    // non-empty local part before classifying the domain.
    if (!localPart || !domain || rest.length > 0) return false;
    return $f017e48f66fe418c$var$PERSONAL_EMAIL_DOMAINS.has(domain);
};
const $f017e48f66fe418c$export$96ba2fba6748f863 = (email = '')=>{
    const [localPart, domain, ...rest] = email.trim().toLowerCase().split('@');
    // Need a non-empty local part, at least one domain character, and exactly
    // one "@" before we attempt to classify.
    if (!localPart || !domain || rest.length > 0) return false;
    // Require the *complete* domain (including the TLD, e.g. "gmail.com") to match
    // a known personal provider. We intentionally do NOT match on the leading
    // label alone, so the nudge only fires once the user has typed the full
    // domain — e.g. "ada@gmail" does not qualify, but "ada@gmail.com" does.
    return $f017e48f66fe418c$var$PERSONAL_EMAIL_DOMAINS.has(domain);
};
const $f017e48f66fe418c$export$7d0830a28936a458 = (email = '')=>{
    // Trim before validating so this helper is whitespace-tolerant like its
    // sibling `isPersonalDomain` (the underlying `emailIsValid` uses an anchored
    // regex and does not tolerate surrounding whitespace on its own).
    const trimmed = email.trim();
    return (0, $gM7M2.emailIsValid)(trimmed) && !$f017e48f66fe418c$export$fb4ff965f818da6(trimmed);
};

});

parcelRegister("dtubO", function(module, exports) {
$parcel$export(module.exports, "firePersonalEmailEnteredAnalytics", function () { return $3d00417e624ef389$export$fa70ab3752c6bf58; });
const $3d00417e624ef389$export$2348bc7995c8f659 = 'signupPersonalEmail';
const $3d00417e624ef389$export$fa70ab3752c6bf58 = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent({
        eventType: 'track',
        actionSubject: $3d00417e624ef389$export$2348bc7995c8f659,
        action: 'entered',
        attributes: {
            domainType: 'personal-domain'
        }
    }).fire();
};

});


parcelRegister("fYkNv", function(module, exports) {
$parcel$export(module.exports, "RecommendWorkEmailNudge", function () { return $fd4e54b69fddeba6$export$753180ab38ba4dbd; });
/* recommend-work-email-nudge.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cNamI = parcelRequire("cNamI");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");
const $fd4e54b69fddeba6$export$753180ab38ba4dbd = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "status",
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulp1crf _4cvr1y6m _1pfhftgi _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rkoftgi _bfhk1bjw _ect4z4z1"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1o9zidpf _syazu5k9"
                ]),
                style: {
                    "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNamI))), {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1y44"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1wyb8oy7 _k48pni7l _vwz419ii _syazlkxj"
                        ]),
                        style: {
                            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm),
                            "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "signupForm.accountCreation.recommendWorkEmail.title",
                            defaultMessage: "Get more from Jira with a work email"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1wyb8oy7 _vwz4bs82 _syaz1qc2"
                        ]),
                        style: {
                            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm),
                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "signupForm.accountCreation.recommendWorkEmail.body",
                            defaultMessage: "Unlock AI, automation, and a shared workspace your whole team can find and join."
                        })
                    })
                ]
            })
        ]
    });
};
const $fd4e54b69fddeba6$var$calloutCss = null;
const $fd4e54b69fddeba6$var$iconCss = null;
const $fd4e54b69fddeba6$var$contentCss = null;
const $fd4e54b69fddeba6$var$titleCss = null;
const $fd4e54b69fddeba6$var$bodyCss = null;

});

parcelRegister("eLTGI", function(module, exports) {
$parcel$export(module.exports, "useRecommendWorkEmailNudge", function () { return $b20e82695bdc6425$export$8013cfc12274b808; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $bZfqV = parcelRequire("bZfqV");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $c5eWx = parcelRequire("c5eWx");
const $b20e82695bdc6425$export$8013cfc12274b808 = ({ email: email })=>{
    const experiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).recommendWorkEmailSignup);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // Only treat the user as enrolled once Statsig has actually resolved their
    // arm. `type === 'enrolled'` alone is true as soon as the (synchronous)
    // targeting cohort is known, but the bucketed parameter value can still be
    // resolving — during that window `getExperimentValue` returns undefined and
    // the hook falls back to `defaultValue` (false) with `usingDefault: true`.
    // A comment elsewhere in the codebase puts it succinctly: "usingDefault is
    // equivalent to not being enrolled in Statsig".
    //
    // Gating on `usingDefault === false` avoids a race that would unbalance the
    // experiment: a treatment user whose bucket has not resolved yet would
    // otherwise fire an exposure as the default (control) value before latching
    // the treatment UI. Because this gate is independent of which arm the user
    // is in, it keeps control/treatment exposure symmetric.
    //
    // Narrow to a single resolved-enrolled reference so downstream reads of
    // `value` / `fireExposure` are type-safe (the hook returns a discriminated
    // union whose not-enrolled / indeterminate arms lack those fields).
    const resolvedExperiment = experiment.type === 'enrolled' && experiment.usingDefault === false ? experiment : undefined;
    // Eligible = enrollment is fully resolved AND the domain typed so far is a
    // known personal provider. Evaluated on every keystroke — no dependency on
    // blur/validation.
    const isEligible = resolvedExperiment !== undefined && (0, $bZfqV.isLikelyPersonalDomain)(email);
    // Fire the exposure event exactly once, for both arms, on first eligibility.
    // `resolvedExperiment` is checked here both to guard the one-shot ref and to
    // narrow the discriminated union so `fireExposure` is type-safe (TypeScript
    // does not carry the narrowing from `isEligible`, which is a plain boolean).
    const hasFiredExposureRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (isEligible && resolvedExperiment && !hasFiredExposureRef.current) {
            resolvedExperiment.fireExposure();
            hasFiredExposureRef.current = true;
        }
    }, [
        isEligible,
        resolvedExperiment
    ]);
    // Show the nudge for the enrolled treatment arm once eligible — and then keep
    // it shown. The nudge intentionally "latches": once the user's email is
    // confidently personal we surface the recommendation and leave it in place
    // even if they subsequently edit or clear the field, so it doesn't flicker
    // away mid-correction.
    const hasShownNudgeRef = (0, $1oC0p.useRef)(false);
    if (isEligible && resolvedExperiment !== undefined && resolvedExperiment.value === true) hasShownNudgeRef.current = true;
    const showNudge = hasShownNudgeRef.current;
    // Fire the `recommendWorkEmailNudge shown` UI event exactly once, the first
    // time the treatment nudge is surfaced. Exposure fires for both arms at the
    // eligibility point, so this event is what identifies, within that exposed
    // population, the treatment users who were actually shown the nudge. It is
    // naturally scoped to personal-domain treatment users because `showNudge`
    // only latches on for the resolved treatment arm once the email is a
    // confident personal domain — the nudge-display logic above is unchanged.
    const hasFiredShownRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (showNudge && !hasFiredShownRef.current) {
            hasFiredShownRef.current = true;
            (0, $c5eWx.fireNudgeShownAnalytics)({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        showNudge,
        createAnalyticsEvent
    ]);
    // Track whether the user has *ever* held a complete, valid personal email
    // while mounted. This is the "did they start on a personal address" history
    // that makes a later business email at submit time a genuine switch.
    //
    // `hasEverBeenPersonalRef` starts as `false` and is only ever set to `true`
    // (never cleared) — and only *after* an effect run has observed a valid,
    // complete personal address. It deliberately does NOT trust the initial /
    // seeded prop value (which may be a prefilled type-ahead email), so the first
    // render can never, by itself, establish the "was personal" baseline. Only
    // setting it (never clearing) means an intervening cleared/partial value does
    // not erase the fact that the user had entered a personal email — so the
    // switch is still counted even via an indirect path (personal -> clear ->
    // business). Requiring a *complete* personal address also stops partially-
    // typed input between keystrokes from spuriously establishing the baseline.
    const hasEverBeenPersonalRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $bZfqV.isPersonalDomain)(email)) hasEverBeenPersonalRef.current = true;
    }, [
        email
    ]);
    // Fire the `recommendWorkEmailNudge emailChanged` track event exactly once,
    // when a nudged user who entered a personal email at some point this session
    // then *submits* the form with a business email. This is the direct
    // "converted to a work email after the nudge, and went through with it" signal.
    //
    // This is exposed as an imperative callback (rather than fired from an effect
    // reacting to a submit flag) because the signup submit handler redirects the
    // page via `window.location.assign` almost immediately. An effect that fires
    // on a re-render triggered by submit would race the navigation and often not
    // run / flush in time. The consumer instead calls this synchronously from the
    // submit-button click — the same in-gesture timing as the other analytics
    // events that already fire just before the redirect — so the event dispatches
    // before the page tears down.
    //
    // Gating: `hasShownNudgeRef` keeps it scoped to users who were actually
    // nudged; `hasEverBeenPersonalRef` ensures they had entered a personal email
    // first; and `isBusinessDomain(submittedEmail)` confirms the email they are
    // submitting with is a valid business domain. `hasFiredEmailChangedRef`
    // guarantees at most one fire per session (e.g. across submit retries). All
    // state is read from refs so the callback is stable and always sees current
    // values.
    const hasFiredEmailChangedRef = (0, $1oC0p.useRef)(false);
    const notifyEmailSubmitted = (0, $1oC0p.useCallback)((submittedEmail)=>{
        const switchedFromPersonalToBusiness = hasEverBeenPersonalRef.current && (0, $bZfqV.isBusinessDomain)(submittedEmail);
        if (hasShownNudgeRef.current && !hasFiredEmailChangedRef.current && switchedFromPersonalToBusiness) {
            hasFiredEmailChangedRef.current = true;
            (0, $c5eWx.fireNudgeEmailChangedAnalytics)({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        showNudge: showNudge,
        notifyEmailSubmitted: notifyEmailSubmitted
    };
};

});
parcelRegister("c5eWx", function(module, exports) {
$parcel$export(module.exports, "fireNudgeShownAnalytics", function () { return $c09bfd10da3f76c5$export$5c3b56249c99ecf3; });
$parcel$export(module.exports, "fireNudgeEmailChangedAnalytics", function () { return $c09bfd10da3f76c5$export$5c9fc82ee40941bd; });
const $c09bfd10da3f76c5$export$c675659b298e914d = 'recommendWorkEmailNudge';
const $c09bfd10da3f76c5$export$5c3b56249c99ecf3 = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent({
        eventType: 'ui',
        actionSubject: $c09bfd10da3f76c5$export$c675659b298e914d,
        action: 'shown',
        attributes: {
            domainTypeAtNudge: 'personal-domain'
        }
    }).fire();
};
const $c09bfd10da3f76c5$export$5c9fc82ee40941bd = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent({
        eventType: 'track',
        actionSubject: $c09bfd10da3f76c5$export$c675659b298e914d,
        action: 'emailChanged',
        attributes: {
            fromDomainType: 'personal-domain',
            toDomainType: 'business-domain'
        }
    }).fire();
};

});




parcelRegister("exxpJ", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluencePremium", function () { return $00d7ffabe0d06bc3$export$1ffaa19e2ed0b38d; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aq3TK = parcelRequire("aq3TK");
const $00d7ffabe0d06bc3$export$1ffaa19e2ed0b38d = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aq3TK.LoggedOutConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("aq3TK", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluenceBlueWaveTemplate", function () { return $93cd1616a0ee0f21$export$5959bca4f1448999; });
/* logged-out-confluence-blue-wave-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $6KUQg = parcelRequire("6KUQg");

var $4qMMD = parcelRequire("4qMMD");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $3lcPU = parcelRequire("3lcPU");

var $hnmMQ = parcelRequire("hnmMQ");

var $e9I0Z = parcelRequire("e9I0Z");

var $7tN5i = parcelRequire("7tN5i");
const $93cd1616a0ee0f21$export$5959bca4f1448999 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7tN5i.HubspotDockerTwilioGoPro), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence',
            defaultMessage: 'Trusted by over 75,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence',
            defaultMessage: 'Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg',
                alt: ''
            }
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp7vkz _6rthckbl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb14no _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: formatMessage({
                        id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading',
                        defaultMessage: 'Start now'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyb7vkz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: formatMessage({
                        id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence',
                        defaultMessage: '7-day free trial for up to 50,000 users'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Submit: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {
                                buttonText: formatMessage({
                                    id: 'WacSignupForm.startButtonTextChooseSignup',
                                    defaultMessage: 'Continue'
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
                        ]
                    }),
                    Separator: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {
                        separatorText: formatMessage({
                            id: 'WacSignupForm.socialSignUpOr',
                            defaultMessage: 'OR'
                        })
                    }),
                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                        providers: {
                            google: formatMessage({
                                id: 'WacSignupForm.socialSignUpButtonContinueWithGoogle',
                                defaultMessage: 'Continue with Google'
                            })
                        }
                    })
                })
            ]
        })
    });
};
const $93cd1616a0ee0f21$var$containerCss = null;
const $93cd1616a0ee0f21$var$siteActivationHeadingCss = null;
const $93cd1616a0ee0f21$var$subheaderCss = null;

});


parcelRegister("jcWk4", function(module, exports) {
$parcel$export(module.exports, "LoggedOutConfluenceStandard", function () { return $f668dd51e0b492ab$export$32193c0ac4b4fb45; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aq3TK = parcelRequire("aq3TK");
const $f668dd51e0b492ab$export$32193c0ac4b4fb45 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aq3TK.LoggedOutConfluenceBlueWaveTemplate), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudStandard',
            defaultMessage: 'Cloud Standard'
        })
    });
};

});



parcelRegister("iLlOX", function(module, exports) {
$parcel$export(module.exports, "DevAiSignup", function () { return $32d138d700b166cc$export$dca868915a34f0ef; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $ivoA6 = parcelRequire("ivoA6");

var $6f7YY = parcelRequire("6f7YY");
const $32d138d700b166cc$export$dca868915a34f0ef = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ivoA6.LoggedInDevAI), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6f7YY.LoggedOutDevAI), {});
};

});
parcelRegister("ivoA6", function(module, exports) {
$parcel$export(module.exports, "LoggedInDevAI", function () { return $0c983ee44332ca1c$export$13f56d3e273e1527; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $fJ4or = parcelRequire("fJ4or");

var $8Oqaw = parcelRequire("8Oqaw");
const $0c983ee44332ca1c$export$13f56d3e273e1527 = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    if (edition === 'free' && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).enableRovoDevBetaSignup)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJ4or.LoggedInDevAIFree), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Oqaw.LoggedInRovoDevStandard), {});
};

});
parcelRegister("fJ4or", function(module, exports) {
$parcel$export(module.exports, "LoggedInDevAIFree", function () { return $2c25a4b50a76b8d5$export$670d83e033e97606; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $bztSC = parcelRequire("bztSC");

var $64a2R = parcelRequire("64a2R");
const $2c25a4b50a76b8d5$export$670d83e033e97606 = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $64a2R.LoggedInDevAIFreeNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bztSC.LoggedInDevAIFreeExistingSitesUser), {});
    return null;
};

});
parcelRegister("bztSC", function(module, exports) {
$parcel$export(module.exports, "LoggedInDevAIFreeExistingSitesUser", function () { return $23be75dcd9e7ef0a$export$bd3a7e49877d234e; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $8AXar = parcelRequire("8AXar");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $69SrI = parcelRequire("69SrI");

var $g1l9J = parcelRequire("g1l9J");

var $hd7qA = parcelRequire("hd7qA");

var $6mUhM = parcelRequire("6mUhM");
const $23be75dcd9e7ef0a$export$bd3a7e49877d234e = ()=>{
    const intl = (0, $8e22h.default)();
    const subHeaderText = intl.formatMessage({
        id: 'BxpUiSignup.nameSite.cobrandedExistingUserSubHeader',
        defaultMessage: 'Join the free beta program'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
            ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1l9J.SignupFormWithPaymentSwitcher), {
                header: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6mUhM.WelcomeBackHeading), {})
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                            ]),
                            children: subHeaderText
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                    PrivacyPolicy: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hd7qA.PrivacyPolicy), {})
                })
            }),
            WeekOneUser: null,
            ManagedUser: null
        })
    });
};
const $23be75dcd9e7ef0a$var$headerCss = null;

});
parcelRegister("g1l9J", function(module, exports) {
$parcel$export(module.exports, "SignupFormWithPaymentSwitcher", function () { return $8b4dbe84079df67e$export$a886c8f74880a22a; });

var $7VQPk = parcelRequire("7VQPk");

var $ff4S3 = parcelRequire("ff4S3");

var $gTogP = parcelRequire("gTogP");

var $g3NOs = parcelRequire("g3NOs");

var $4TzR8 = parcelRequire("4TzR8");
const $8b4dbe84079df67e$export$a886c8f74880a22a = ({ children: children, header: header })=>{
    const { paymentDetailsView: paymentDetailsView } = (0, $ff4S3.useSiteActivationContext)();
    const overlayContent = paymentDetailsView.view === 'payment-required' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTogP.AddPaymentMethodContent), {}) : paymentDetailsView.view === 'payment' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4TzR8.PaymentDetailsContent), {}) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            paymentDetailsView.view === 'site-setup' && header,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3NOs.FormWithPaymentOverlay), {
                paymentDetailsPage: overlayContent,
                fullViewportOverlay: paymentDetailsView.view === 'payment-required',
                children: children
            })
        ]
    });
};

});
parcelRegister("gTogP", function(module, exports) {
$parcel$export(module.exports, "AddPaymentMethodContent", function () { return $5b428da43d85ce50$export$6a315b556cd85f4c; });
/* add-payment-method-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $3RaC6 = parcelRequire("3RaC6");

var $7ZMp9 = parcelRequire("7ZMp9");

var $ff4S3 = parcelRequire("ff4S3");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");
const $5b428da43d85ce50$export$6a315b556cd85f4c = ()=>{
    const { user: user } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { paymentDetailsView: paymentDetailsView, setPaymentDetailsView: setPaymentDetailsView } = (0, $ff4S3.useSiteActivationContext)();
    (0, $1oC0p.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'startRovoDevTrialPaymentBlockingScreen',
            attributes: {
                userId: user?.accountId
            }
        }).fire();
    }, []);
    const adminPaymentLink = paymentDetailsView.view === 'payment-required' ? paymentDetailsView.adminPaymentLink : undefined;
    const handleOpenPaymentMethods = ()=>{
        if (adminPaymentLink) {
            window.open(adminPaymentLink, '_blank');
            setPaymentDetailsView({
                view: 'payment'
            });
            createAnalyticsEvent({
                action: 'clicked',
                eventType: 'ui',
                actionSubject: 'button',
                actionSubjectId: 'openPaymentMethod',
                attributes: {
                    userId: user?.accountId
                }
            }).fire();
        }
    };
    const handleCloseAndGoBack = ()=>{
        setPaymentDetailsView({
            view: 'site-setup'
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12f1fdn _1mouidpf _195g1wug _1rjc1tcg _18zr1tcg _y3gn1e5h"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_1wyb1tcg _k48p1fw0 _vwz4nqt0 _1pfhidpf _6rth1crf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.AddPaymentMethod.Title",
                    defaultMessage: "Add a payment method to start your trial"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syaz7ga5 _1wyb7vkz _vwz4bs82 _1pfhidpf _6rth1tcg _y3gn1h6o"
                ]),
                style: {
                    "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.AddPaymentMethod.Intro",
                    defaultMessage: "We couldn't find a payment method for your site, a billing admin must add one before you start a trial."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _yv0ewxkt _zulp7vkz _6rthzwfg"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc7vkz _18zr7vkz _2rkoftgi _bfhkg7ng _19it1rfy"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                        "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": true,
                            className: (0, $2jatx.default)([
                                "_1e0c116y _6rthftgi _syaz5hrz"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($5b428da43d85ce50$var$ShieldIcon, {})
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _1wybdlk8 _k48pni7l _6rth1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "BxpSignup.AddPaymentMethod.NoChargeTitle",
                                defaultMessage: "No charge until trial ends"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _vwz4bs82 _1mouidpf _195gidpf _syaz7ga5"
                            ]),
                            style: {
                                "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "BxpSignup.AddPaymentMethod.NoChargeBody",
                                defaultMessage: "There's no charge today, billing doesn't begin until the end of your trial."
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybf6fq _k48pni7l _1pfhidpf _6rth7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.AddPaymentMethod.HowToTitle",
                    defaultMessage: "How to add a payment method"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("ol", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _1mouidpf _195gidpf _1rjcidpf _18zridpf _1e0c1txw _2lx21bp4 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp7vkz _4cvr1y6m"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1o9zidpf _1bsb1f4h _4t3i1f4h _2rko1ssb _bfhk5hrz _syaz1afi _1wybdlk8 _k48pni7l _1e0c116y _4cvr1h6o _1bah1h6o"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step1Title",
                                            defaultMessage: "Go to payment methods in Atlassian Administration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _6rth1crf _195gidpf _1wybdlk8 _vwz4bs82 _syaz7ga5"
                                        ]),
                                        style: {
                                            "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "BxpSignup.AddPaymentMethod.Step1Body",
                                                defaultMessage: "Billing admin role required to add payment methods."
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                                                href: "https://support.atlassian.com/subscriptions-and-billing/docs/understand-billing-administration/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "BxpSignup.AddPaymentMethod.ReadAboutPermissions",
                                                    defaultMessage: "Read about permissions"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                                        appearance: "primary",
                                        onClick: handleOpenPaymentMethods,
                                        iconAfter: /*#__PURE__*/ (0, $7VQPk.jsx)($5b428da43d85ce50$var$ExternalLinkIcon, {}),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.OpenPaymentMethods",
                                            defaultMessage: "Open payment methods"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp7vkz _4cvr1y6m"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1o9zidpf _1bsb1f4h _4t3i1f4h _2rko1ssb _bfhk5hrz _syaz1afi _1wybdlk8 _k48pni7l _1e0c116y _4cvr1h6o _1bah1h6o"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step2Title",
                                            defaultMessage: "Enter your billing details"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _6rth1crf _195gidpf _1wybdlk8 _vwz4bs82 _syaz7ga5"
                                        ]),
                                        style: {
                                            "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step2Body",
                                            defaultMessage: "Add a billing address and payment method. We accept credit cards and PayPal."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp7vkz _4cvr1y6m"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1o9zidpf _1bsb1f4h _4t3i1f4h _2rko1ssb _bfhk5hrz _syaz1afi _1wybdlk8 _k48pni7l _1e0c116y _4cvr1h6o _1bah1h6o"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: "3"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step3Title",
                                            defaultMessage: "Close the payment methods tab"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _6rth1crf _195gidpf _1wybdlk8 _vwz4bs82 _syaz7ga5"
                                        ]),
                                        style: {
                                            "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step3Body",
                                            defaultMessage: "When you're done, close the payment methods window and return here."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp7vkz _4cvr1y6m"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1o9zidpf _1bsb1f4h _4t3i1f4h _2rko1ssb _bfhk5hrz _syaz1afi _1wybdlk8 _k48pni7l _1e0c116y _4cvr1h6o _1bah1h6o"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: "4"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step4Title",
                                            defaultMessage: "Return and set up your trial"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _6rth1crf _195gidpf _1wybdlk8 _vwz4bs82 _syaz7ga5"
                                        ]),
                                        style: {
                                            "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.Step4Body",
                                            defaultMessage: "After adding a payment method, return to where you started and set up your trial again."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                                        appearance: "default",
                                        onClick: handleCloseAndGoBack,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "BxpSignup.AddPaymentMethod.CloseAndGoBack",
                                            defaultMessage: "Close and go back"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $5b428da43d85ce50$var$ShieldIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
        })
    });
// TODO: https://softwareteams.atlassian.net/browse/JOLT-2177
// const ClockIcon = () => (
//     <svg
//         width="24"
//         height="24"
//         viewBox="0 0 24 24"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         aria-hidden
//     >
//         <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
//         <path
//             d="M12 6v6l4 2"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//         />
//     </svg>
// );
const $5b428da43d85ce50$var$ExternalLinkIcon = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M12 8.67V12a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1h3.33M9.33 2h4v4M14 2l-6 6",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const $5b428da43d85ce50$var$containerCss = null;
const $5b428da43d85ce50$var$titleCss = null;
const $5b428da43d85ce50$var$introCss = null;
const $5b428da43d85ce50$var$cardsCss = null;
const $5b428da43d85ce50$var$cardCss = null;
const $5b428da43d85ce50$var$iconWrapperCss = null;
const $5b428da43d85ce50$var$cardTitleCss = null;
const $5b428da43d85ce50$var$cardBodyCss = null;
const $5b428da43d85ce50$var$sectionTitleCss = null;
const $5b428da43d85ce50$var$stepsListCss = null;
const $5b428da43d85ce50$var$stepCss = null;
const $5b428da43d85ce50$var$stepNumberCss = null;
const $5b428da43d85ce50$var$stepBodyCss = null;

});

parcelRegister("g3NOs", function(module, exports) {
$parcel$export(module.exports, "FormWithPaymentOverlay", function () { return $9b22fa89651dce27$export$c80bdd1e111954c8; });
/* payment-details.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $9b22fa89651dce27$export$c80bdd1e111954c8 = ({ children: children, paymentDetailsPage: paymentDetailsPage, fullViewportOverlay: fullViewportOverlay })=>{
    const overlayContent = paymentDetailsPage ?? null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            overlayContent && fullViewportOverlay && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1pbykb7n _1e0c1txw _2lx21bp4 _4cvr1h6o _bfhk1afi",
                    "_kqsw1n9t _1pbydx66"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: overlayContent
            }),
            overlayContent && !fullViewportOverlay && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1pbykb7n _1e0c1txw _2lx21bp4 _4cvr1h6o _bfhk1afi"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: overlayContent
            })
        ]
    });
};
const $9b22fa89651dce27$var$wrapperCss = null;
const $9b22fa89651dce27$var$overlayCss = null;
const $9b22fa89651dce27$var$overlayFullViewportCss = null;

});

parcelRegister("4TzR8", function(module, exports) {
$parcel$export(module.exports, "PaymentDetailsContent", function () { return $2360af0775e2e577$export$1feca48d465e8223; });
/* payment-details-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $ff4S3 = parcelRequire("ff4S3");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $fqwey = parcelRequire("fqwey");
const $2360af0775e2e577$export$1feca48d465e8223 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { setPaymentDetailsView: setPaymentDetailsView, activateSite: activateSite, isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $ff4S3.useSiteActivationContext)();
    const handleSubmit = ()=>{
        createAnalyticsEvent({
            event: 'clicked',
            eventComponent: 'button',
            eventName: 'bxp.signup.paymentDetailsSubmit'
        }).fire('signup');
        const privacyPolicy = document.getElementById('privacy-policy-text')?.innerHTML || '';
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    const isLoading = isSubmitting || hasSubmitted;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fqwey.PaymentDetailsHeading), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syaz7ga5 _1wyb7vkz _k48p1nn1 _vwz4bs82 _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _y3gn1h6o"
                ]),
                style: {
                    "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.PaymentDetailsSubtitle",
                    defaultMessage: "to start a Rovo Dev 30 day free trial"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulp7vkz _1bah1h6o _ca0q1crf _u5f31crf _n3td1crf _19bv1crf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        variant: "secondary",
                        onClick: ()=>setPaymentDetailsView({
                                view: 'site-setup'
                            }),
                        isDisabled: isLoading,
                        className: (0, $2jatx.default)([
                            "_1wybf6fq _4t3i4vtr _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.PaymentDetailsBack",
                            defaultMessage: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        variant: "primary",
                        onClick: handleSubmit,
                        isLoading: isLoading,
                        isDisabled: isLoading,
                        className: (0, $2jatx.default)([
                            "_1wybf6fq _4t3i4vtr _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.PaymentDetailsSubmit",
                            defaultMessage: "I've added my payment details"
                        })
                    })
                ]
            })
        ]
    });
};
const $2360af0775e2e577$var$buttonCss = null;
const $2360af0775e2e577$var$subtitleCss = null;
const $2360af0775e2e577$var$actionsCss = null;

});
parcelRegister("fqwey", function(module, exports) {
$parcel$export(module.exports, "PaymentDetailsHeading", function () { return $21ece009ec06e5e3$export$ff0b8b48c176b583; });
/* payment-details-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $21ece009ec06e5e3$export$ff0b8b48c176b583 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
        className: (0, $2jatx.default)([
            "_1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpSignup.PaymentDetailsHeading",
            defaultMessage: "Add your payment details",
            values: {
                scribbleSpan: $21ece009ec06e5e3$var$scribbleSpan
            }
        })
    });
};
const $21ece009ec06e5e3$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $2jatx.default)([
                    "_lswuuol8 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $21ece009ec06e5e3$var$accentImageCss = null;
const $21ece009ec06e5e3$var$headingCss = null;
const $21ece009ec06e5e3$var$scribbleSpanCss = null;

});



parcelRegister("hd7qA", function(module, exports) {
$parcel$export(module.exports, "PrivacyPolicy", function () { return $94542feaff314314$export$f37ec6636ba46d53; });
/* privacy-policy.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $94542feaff314314$export$f37ec6636ba46d53 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybw1gv"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("b", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "signup-page.rovo-dev-privacy-policy.title",
                        defaultMessage: "Rovo Dev Standard - 30-day trial, then $20 USD per user per month"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "signup-page.rovo-dev-privacy-policy.agreement-terms",
                    // TODO: https://softwareteams.atlassian.net/browse/JOLT-2177
                    // defaultMessage="By selecting <b>Agree and start now</b>, you agree to the <customerAgreementLink>Atlassian Customer Agreement</customerAgreementLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. At the end of your trial, billing begins and renews automatically. Cancel anytime."
                    defaultMessage: "By selecting <b>Agree and start now</b>, you agree to the <customerAgreementLink>Atlassian Customer Agreement</customerAgreementLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. At the end of your trial, billing begins and renews automatically.",
                    values: {
                        customerAgreementLink: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: "https://www.atlassian.com/legal/atlassian-customer-agreement",
                                className: (0, $2jatx.default)([
                                    "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: chunks
                            }),
                        privacyPolicyLink: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                className: (0, $2jatx.default)([
                                    "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: chunks
                            }),
                        b: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("b", {
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "signup-page.rovo-dev-privacy-policy.mcp-information",
                    defaultMessage: "Rovo Dev CLI and Rovo Dev in IDE may not be available while on free trial. Rovo Dev allows users to connect and send data to Third-Party Products and data sources through model context protocol (MCP). <mcpLink>Read about MCP and your responsibilities</mcpLink>",
                    values: {
                        mcpLink: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: "https://support.atlassian.com/rovo/docs/rovo-dev-and-model-context-protocol-mcp/",
                                className: (0, $2jatx.default)([
                                    "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: chunks
                            })
                    }
                })
            })
        ]
    });
const $94542feaff314314$var$privacyPolicyCss = null;
const $94542feaff314314$var$linkCss = null;

});

parcelRegister("6mUhM", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return $0bb60b9169624abe$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $0bb60b9169624abe$export$f8a24991e7eb3d8f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpSignup.accountCreation.cobrandedHeader",
        defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with {productName}",
        values: {
            scribbleSpan: $0bb60b9169624abe$var$ScribbleSpan,
            productName: 'Rovo Dev'
        }
    });
};
const $0bb60b9169624abe$var$ScribbleSpan = (children)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $2jatx.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a",
                    "_lswu81oq"
                ]),
                style: {
                    "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
};
const $0bb60b9169624abe$var$accentImageCss = null;
const $0bb60b9169624abe$var$greenThemeCss = null;
const $0bb60b9169624abe$var$scribbleSpanCss = null;

});


parcelRegister("64a2R", function(module, exports) {
$parcel$export(module.exports, "LoggedInDevAIFreeNewUser", function () { return $e697b76ad962e168$export$141fa8e8d9747294; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $8AXar = parcelRequire("8AXar");

var $lBvZp = parcelRequire("lBvZp");

var $ka4Xu = parcelRequire("ka4Xu");

var $69SrI = parcelRequire("69SrI");

var $kr3TE = parcelRequire("kr3TE");

var $g1l9J = parcelRequire("g1l9J");

var $hd7qA = parcelRequire("hd7qA");
const $e697b76ad962e168$export$141fa8e8d9747294 = ()=>{
    const intl = (0, $8e22h.default)();
    const subHeaderText = intl.formatMessage({
        id: 'siteActivation.loggedInDevAI.newUser',
        defaultMessage: 'Sites are the shared space where people organize teams, work, and projects.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                NewUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1l9J.SignupFormWithPaymentSwitcher), {
                    header: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kr3TE.CreateASiteHeading), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: subHeaderText
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {
                        PrivacyPolicy: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hd7qA.PrivacyPolicy), {})
                    })
                })
            })
        })
    });
};
const $e697b76ad962e168$var$containerCss = null;
const $e697b76ad962e168$var$headerGroupCss = null;
const $e697b76ad962e168$var$headerCss = null;
const $e697b76ad962e168$var$accentImageSpanCss = null;

});
parcelRegister("kr3TE", function(module, exports) {
$parcel$export(module.exports, "CreateASiteHeading", function () { return $0033831aac059bf3$export$579c0fd7de5e1861; });
/* create-a-site-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $0033831aac059bf3$export$579c0fd7de5e1861 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
        defaultMessage: `Create a <accentImage>site</accentImage>`,
        values: {
            accentImage: $0033831aac059bf3$var$accentImage
        }
    });
};
const $0033831aac059bf3$var$accentImage = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 57 52",
                className: (0, $2jatx.default)([
                    "_lswuh727 _4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                    })
                ]
            })
        ]
    });
const $0033831aac059bf3$var$accentImageCss = null;
const $0033831aac059bf3$var$scribbleSpanCss = null;

});



parcelRegister("8Oqaw", function(module, exports) {
$parcel$export(module.exports, "LoggedInRovoDevStandard", function () { return $6bc8a76fcddb5269$export$f2f71ed77d151e3c; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $8enZj = parcelRequire("8enZj");

var $emctP = parcelRequire("emctP");
const $6bc8a76fcddb5269$export$f2f71ed77d151e3c = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === (0, $2WL8B.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emctP.LoggedInRovoDevStandardNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8enZj.LoggedInRovoDevStandardExistingSitesUser), {});
    return null;
};

});
parcelRegister("8enZj", function(module, exports) {
$parcel$export(module.exports, "LoggedInRovoDevStandardExistingSitesUser", function () { return $f1f56a223dccabe9$export$ef5b160f88db9ed5; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8AXar = parcelRequire("8AXar");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $69SrI = parcelRequire("69SrI");

var $g1l9J = parcelRequire("g1l9J");

var $hd7qA = parcelRequire("hd7qA");

var $6mUhM = parcelRequire("6mUhM");
const $f1f56a223dccabe9$var$headerCss = null;
const $f1f56a223dccabe9$export$ef5b160f88db9ed5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
            ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1l9J.SignupFormWithPaymentSwitcher), {
                header: /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6mUhM.WelcomeBackHeading), {})
                }),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                    PrivacyPolicy: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hd7qA.PrivacyPolicy), {})
                })
            }),
            WeekOneUser: null,
            ManagedUser: null
        })
    });
};

});

parcelRegister("emctP", function(module, exports) {
$parcel$export(module.exports, "LoggedInRovoDevStandardNewUser", function () { return $f12440e1e945c7c2$export$72fdccb67e0f2e54; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $8AXar = parcelRequire("8AXar");

var $lBvZp = parcelRequire("lBvZp");

var $ka4Xu = parcelRequire("ka4Xu");

var $69SrI = parcelRequire("69SrI");

var $kr3TE = parcelRequire("kr3TE");

var $g1l9J = parcelRequire("g1l9J");

var $hd7qA = parcelRequire("hd7qA");
const $f12440e1e945c7c2$export$72fdccb67e0f2e54 = ()=>{
    const intl = (0, $8e22h.default)();
    const subHeaderText = intl.formatMessage({
        id: 'siteActivation.loggedInRovoDev.newUser',
        defaultMessage: 'Sites are the shared space where people organize teams, work, and projects.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                NewUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1l9J.SignupFormWithPaymentSwitcher), {
                    header: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kr3TE.CreateASiteHeading), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: subHeaderText
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {
                        PrivacyPolicy: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hd7qA.PrivacyPolicy), {})
                    })
                })
            })
        })
    });
};
const $f12440e1e945c7c2$var$containerCss = null;
const $f12440e1e945c7c2$var$headerGroupCss = null;
const $f12440e1e945c7c2$var$headerCss = null;
const $f12440e1e945c7c2$var$accentImageSpanCss = null;

});



parcelRegister("6f7YY", function(module, exports) {
$parcel$export(module.exports, "LoggedOutDevAI", function () { return $e60d1103b5fce23c$export$b64aab519f10993d; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $6Umue = parcelRequire("6Umue");

var $4dJ8v = parcelRequire("4dJ8v");
const $e60d1103b5fce23c$export$b64aab519f10993d = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    if (edition === 'free' && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).enableRovoDevBetaSignup)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Umue.LoggedOutDevAIFree), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4dJ8v.LoggedOutRovoDevStandard), {});
};

});
parcelRegister("6Umue", function(module, exports) {
$parcel$export(module.exports, "LoggedOutDevAIFree", function () { return $e33b1a41c536eb77$export$5a6527b3000ce977; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $8AXar = parcelRequire("8AXar");

var $69SrI = parcelRequire("69SrI");

var $fvoZ8 = parcelRequire("fvoZ8");
const $e33b1a41c536eb77$export$5a6527b3000ce977 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedHeading), {
                productName: "Rovo Dev Agents"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {})
        ]
    });
};

});

parcelRegister("4dJ8v", function(module, exports) {
$parcel$export(module.exports, "LoggedOutRovoDevStandard", function () { return $0ff58a1353ffbecc$export$f7ebb395035df183; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $8AXar = parcelRequire("8AXar");

var $69SrI = parcelRequire("69SrI");

var $ih2CW = parcelRequire("ih2CW");
const $0ff58a1353ffbecc$export$f7ebb395035df183 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8AXar.SignupBackgroundLayout), {
        theme: "green",
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69SrI.RovoDevAgentsLogo), {}),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ih2CW.RovoDevGetStartedHeading), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {})
        ]
    });
};

});
parcelRegister("ih2CW", function(module, exports) {
$parcel$export(module.exports, "RovoDevGetStartedHeading", function () { return $8b32b8f24e149dc5$export$33e42523b1dd3db9; });
/* get-started-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $8b32b8f24e149dc5$export$33e42523b1dd3db9 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32b8f24e149dc5$export$a8a3e93435678ff9, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpSignup.accountCreation.cobrandedHeader",
            defaultMessage: "Get <scribbleSpan>started</scribbleSpan> with {productName}",
            values: {
                scribbleSpan: $8b32b8f24e149dc5$var$scribbleSpan,
                productName: 'Rovo Dev'
            }
        })
    });
};
const $8b32b8f24e149dc5$export$a8a3e93435678ff9 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
        className: (0, $2jatx.default)([
            "_syaz1pfd _ect41vau _1wybzwfg _k48p1fw0 _vwz410nf _19pkbh6h _2hwxidpf _otyrbh6h _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
        },
        children: children
    });
const $8b32b8f24e149dc5$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $2jatx.default)([
                    "_lswu81oq _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                style: {
                    "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $8b32b8f24e149dc5$var$accentImageCss = null;
const $8b32b8f24e149dc5$var$scribbleSpanCss = null;
const $8b32b8f24e149dc5$var$h1Css = null;

});




parcelRegister("kUuAX", function(module, exports) {
$parcel$export(module.exports, "JiraSignup", function () { return $257a23f226d3e3db$export$661f9d14ec25fc6f; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $lqqMV = parcelRequire("lqqMV");

var $ipRho = parcelRequire("ipRho");
const $257a23f226d3e3db$export$661f9d14ec25fc6f = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqqMV.LoggedInJira), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRho.LoggedOutJira), {});
};

});
parcelRegister("lqqMV", function(module, exports) {
$parcel$export(module.exports, "LoggedInJira", function () { return $7802de7dcccfd0a8$export$61be21d8bd17cf0f; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $aP1WZ = parcelRequire("aP1WZ");

var $hMxHZ = parcelRequire("hMxHZ");

var $c5Hx1 = parcelRequire("c5Hx1");
const $7802de7dcccfd0a8$export$61be21d8bd17cf0f = ()=>{
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c5Hx1.LoggedInJiraStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hMxHZ.LoggedInJiraPremium), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aP1WZ.LoggedInJiraFree), {});
};

});
parcelRegister("aP1WZ", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraFree", function () { return $90f769d14ed95eb5$export$846fc313de86b008; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $gXWBk = parcelRequire("gXWBk");

var $9O22s = parcelRequire("9O22s");

var $lHM7H = parcelRequire("lHM7H");

var $2MqHY = parcelRequire("2MqHY");
const $90f769d14ed95eb5$export$846fc313de86b008 = ()=>{
    const cohort = (0, $2WL8B.useCohort)(true);
    if (cohort === 'current-product-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lHM7H.CurrentProductUser), {});
    if (cohort === 'current-product-joinable-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9O22s.CurrentProductJoinableUser), {});
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXWBk.LoggedInJiraNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2MqHY.LoggedInJiraFreeExistingSitesUser), {});
    return null;
};

});
parcelRegister("gXWBk", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraNewUser", function () { return $b6aa3bd8c75e3f00$export$c91a3c7dfb3c7a1d; });
/* logged-in-jira-new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $izdHQ = parcelRequire("izdHQ");

var $ahLPp = parcelRequire("ahLPp");

var $dpXXQ = parcelRequire("dpXXQ");
const $b6aa3bd8c75e3f00$export$c91a3c7dfb3c7a1d = ()=>{
    const subheading = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.loggedInJira.newUser",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                        main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahLPp.CreateASiteText), {}),
                        sub: subheading
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                        useContactExpandCohortLogic: true
                    })
                ]
            })
        })
    });
};
const $b6aa3bd8c75e3f00$var$containerCss = null;

});
parcelRegister("ahLPp", function(module, exports) {
$parcel$export(module.exports, "CreateASiteText", function () { return $3b74c22c053eca2f$export$889b1d1d627bb1ec; });
$parcel$export(module.exports, "CreateASiteHeading", function () { return $3b74c22c053eca2f$export$579c0fd7de5e1861; });
/* create-a-site-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $3b74c22c053eca2f$export$889b1d1d627bb1ec = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
        defaultMessage: "Create a <accentImage>site</accentImage>",
        values: {
            accentImage: $3b74c22c053eca2f$var$accentImage
        }
    });
const $3b74c22c053eca2f$export$579c0fd7de5e1861 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_syazi7uo"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($3b74c22c053eca2f$export$889b1d1d627bb1ec, {})
    });
};
const $3b74c22c053eca2f$var$accentImage = (children)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 57 52",
                className: (0, $2jatx.default)([
                    "_lswuh727 _4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                    })
                ]
            })
        ]
    });
const $3b74c22c053eca2f$var$accentImageCss = null;
const $3b74c22c053eca2f$var$scribbleSpanCss = null;
const $3b74c22c053eca2f$var$headingCss = null;

});


parcelRegister("9O22s", function(module, exports) {
$parcel$export(module.exports, "CurrentProductJoinableUser", function () { return $094e81908f9ecb1d$export$805d233848710db8; });
/* current-product-joinable-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $bGrkd = parcelRequire("bGrkd");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $3rmYt = parcelRequire("3rmYt");

var $emciF = parcelRequire("emciF");
const $094e81908f9ecb1d$export$805d233848710db8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3rmYt.JoinableSitesText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};
const $094e81908f9ecb1d$var$containerCss = null;

});

parcelRegister("lHM7H", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $1787b7c30c772485$export$ef5a5fe6477555d4; });
/* current-product-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $dRayu = parcelRequire("dRayu");

var $emciF = parcelRequire("emciF");
const $1787b7c30c772485$export$ef5a5fe6477555d4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRayu.ReturnToProductText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};
const $1787b7c30c772485$var$containerCss = null;

});

parcelRegister("2MqHY", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraFreeExistingSitesUser", function () { return $23884054efdfec4f$export$ebdf57151e82cc8b; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $izdHQ = parcelRequire("izdHQ");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $23884054efdfec4f$export$ebdf57151e82cc8b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp19bv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                        main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                        sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForTenUsersText), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
                ]
            })
        })
    });
};
const $23884054efdfec4f$var$containerCss = null;

});


parcelRegister("hMxHZ", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraPremium", function () { return $8c558617e038bbdb$export$6a2883bc58010609; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $gXWBk = parcelRequire("gXWBk");

var $gjOVd = parcelRequire("gjOVd");

var $5WvqS = parcelRequire("5WvqS");

var $cPR2f = parcelRequire("cPR2f");

var $g3Cdk = parcelRequire("g3Cdk");
const $8c558617e038bbdb$export$6a2883bc58010609 = ()=>{
    const useContactExpandCohortLogic = (0, $2WL8B.useIsJiraContactCompanyExpandEligible)();
    const isStandardToPremiumUpgradeEligible = (0, $2WL8B.useIsStandardToPremiumUpgradeEligible)();
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    if (cohort === (0, $2WL8B.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXWBk.LoggedInJiraNewUser), {});
    if (isStandardToPremiumUpgradeEligible) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3Cdk.LoggedInJiraPremiumUpgradeEligibleUser), {});
    if (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3Cdk.LoggedInJiraPremiumUpgradeEligibleUser), {});
    if (useContactExpandCohortLogic) {
        if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5WvqS.CurrentProductUser), {});
        if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gjOVd.CurrentProductJoinableUser), {});
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXWBk.LoggedInJiraNewUser), {});
    }
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cPR2f.LoggedInJiraPremiumExistingUser), {});
    return null;
};

});
parcelRegister("gjOVd", function(module, exports) {
$parcel$export(module.exports, "CurrentProductJoinableUser", function () { return $8f8ef1d4953571df$export$805d233848710db8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bmQmF = parcelRequire("bmQmF");
const $8f8ef1d4953571df$export$805d233848710db8 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bmQmF.LoggedInJiraBlueWaveTemplateCurrentProductJoinableUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("bmQmF", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraBlueWaveTemplateCurrentProductJoinableUser", function () { return $027d22e6bb654369$export$5f92106e4b4638b3; });
/* logged-in-blue-wave-template-jira-current-product-joinable-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $3lcPU = parcelRequire("3lcPU");

var $bGrkd = parcelRequire("bGrkd");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $3kG7c = parcelRequire("3kG7c");
const $027d22e6bb654369$export$5f92106e4b4638b3 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kG7c.SquareVisaCiscoPfizer), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira',
            defaultMessage: 'Trusted by over 65,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI',
            defaultMessage: 'Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png',
                alt: ''
            }
        }),
        showAtlassianLogo: false,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    useContactExpandCohortLogic: true,
                    CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {})
                })
            ]
        })
    });
};
const $027d22e6bb654369$var$containerCss = null;
const $027d22e6bb654369$var$siteActivationHeadingCss = null;

});
parcelRegister("3kG7c", function(module, exports) {
$parcel$export(module.exports, "SquareVisaCiscoPfizer", function () { return $9be3a0a95f5af1f3$export$5467876c6586ede6; });

var $7VQPk = parcelRequire("7VQPk");
const $9be3a0a95f5af1f3$export$5467876c6586ede6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.74,21.7a.49.49,0,0,1-.48.48h-3.4a.48.48,0,0,1-.48-.48V18.3a.48.48,0,0,1,.48-.48h3.4a.49.49,0,0,1,.48.48Zm2.91,2.54a.85.85,0,0,1-.85.85H12.31a.86.86,0,0,1-.85-.85V15.76a.86.86,0,0,1,.85-.85H20.8a.85.85,0,0,1,.85.85ZM21.89,12H11.22a2.67,2.67,0,0,0-2.66,2.67V25.33A2.67,2.67,0,0,0,11.22,28H21.89a2.67,2.67,0,0,0,2.66-2.67V14.67A2.66,2.66,0,0,0,21.89,12"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32,25.25a3.54,3.54,0,0,1-2.5-1,3,3,0,0,1-.89-2.1h1a2,2,0,0,0,.61,1.42,2.59,2.59,0,0,0,1.82.72h0A2.28,2.28,0,0,0,34.4,22.2c0-.86-.48-1.55-2.81-2.08a4.23,4.23,0,0,1-2-.93,2.34,2.34,0,0,1-.67-1.78,2.88,2.88,0,0,1,3-2.73,3.19,3.19,0,0,1,2.11.77,2.57,2.57,0,0,1,.9,1.95H34a1.92,1.92,0,0,0-2-1.76,2,2,0,0,0-2.05,1.77c0,.88.3,1.39,1.94,1.77s3.55,1.08,3.55,3a2.9,2.9,0,0,1-1,2.18,3.57,3.57,0,0,1-2.38.87Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.42,18.44a3,3,0,1,0,2.91,3,2.94,2.94,0,0,0-2.91-3M43.28,28V23.78h0a3.33,3.33,0,0,1-2.83,1.45,3.81,3.81,0,1,1,0-7.62,3.29,3.29,0,0,1,2.83,1.46h0V17.8h.92V28Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.54,18.44a3,3,0,1,0,2.9,3,2.94,2.94,0,0,0-2.9-3m2.85,6.61V23.78h0a3.35,3.35,0,0,1-2.82,1.45,3.81,3.81,0,1,1,0-7.62,3.24,3.24,0,0,1,2.82,1.46h0V17.8h.92v7.25Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.1,20.81v4.24h-.93V17.8h.93v1h0a2.07,2.07,0,0,1,2-1.23v1a2.09,2.09,0,0,0-2.07,2.22"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M70.33,18.44a2.87,2.87,0,0,0-2.83,2.48h5.66a2.88,2.88,0,0,0-2.83-2.48m3.78,3.32H67.5a2.88,2.88,0,0,0,2.82,2.63,2.75,2.75,0,0,0,2.6-1.71h1a3.79,3.79,0,1,1-3.58-5.07,3.86,3.86,0,0,1,3.8,3.89c0,.09,0,.17,0,.26"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M51.41,25.06V23.93h0a2.48,2.48,0,0,1-2.33,1.31,3.14,3.14,0,0,1-2.51-1.09,3.76,3.76,0,0,1-.64-2.35v-4h.93v4c0,1.51.55,2.62,2.22,2.62a2.06,2.06,0,0,0,1.54-.59,2.75,2.75,0,0,0,.76-2.19V17.77h.94v7.29Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M189.66,28.3v1.51l.11,0a9.44,9.44,0,0,0,1.05.14,7.22,7.22,0,0,0,.93,0,4.19,4.19,0,0,0,.87-.17,2.38,2.38,0,0,0,.9-.48,1.81,1.81,0,0,0,.53-.75,2.1,2.1,0,0,0,0-1.52,1.82,1.82,0,0,0-.47-.66,2.08,2.08,0,0,0-.69-.4l-1.15-.42a.69.69,0,0,1-.31-.3.37.37,0,0,1,0-.34.41.41,0,0,1,.07-.11l.12-.09,0,0a1.48,1.48,0,0,1,.41-.12,2.48,2.48,0,0,1,.72,0,6,6,0,0,1,.85.15h.06V23.38l-.11,0a8.15,8.15,0,0,0-.86-.16,4.27,4.27,0,0,0-1.13,0,2.43,2.43,0,0,0-1.3.52,1.71,1.71,0,0,0-.55.77,2,2,0,0,0,0,1.42,1.51,1.51,0,0,0,.4.6,2.08,2.08,0,0,0,.51.37,3.17,3.17,0,0,0,.79.31l.27.09.13,0h0a1.13,1.13,0,0,1,.36.22.78.78,0,0,1,.16.24.57.57,0,0,1,0,.26.57.57,0,0,1-.26.31,1.41,1.41,0,0,1-.44.14,3.76,3.76,0,0,1-.67,0,6.42,6.42,0,0,1-.88-.12l-.46-.1-.05,0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M183.46,29.76V28l0,0a3.21,3.21,0,0,1-1.26.32,1.9,1.9,0,0,1-1.28-.38,1.6,1.6,0,0,1-.55-.78,1.82,1.82,0,0,1,0-1.06,1.65,1.65,0,0,1,.56-.9,1.77,1.77,0,0,1,.89-.38,2.88,2.88,0,0,1,1.68.31l0,0V23.41l-.08,0a4.57,4.57,0,0,0-1.6-.2,3.68,3.68,0,0,0-1.43.32,3.34,3.34,0,0,0-1.17.91,3.51,3.51,0,0,0-.06,4.27,3.33,3.33,0,0,0,1.86,1.2,4.27,4.27,0,0,0,2.35-.09l.13,0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("polyline", {
                points: "187.41 29.88 187.41 23.29 185.75 23.29 185.75 29.88 187.41 29.88"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M175,18a.86.86,0,0,0,.26.55.82.82,0,0,0,1.38-.55V16.17a.85.85,0,0,0-.25-.56.81.81,0,0,0-.57-.23.83.83,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M179.57,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V13.9a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M184.09,19.64a.84.84,0,0,0,.26.54.82.82,0,0,0,1.12,0,.79.79,0,0,0,.26-.54V10.79a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56v8.85"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M188.64,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V13.9a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.81.81,0,0,0-.57.23.77.77,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M193.16,18a.82.82,0,0,0,.82.77.84.84,0,0,0,.83-.77V16.17a.82.82,0,0,0-.26-.56.79.79,0,0,0-.57-.23.83.83,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M197.71,18a.78.78,0,0,0,.26.55.82.82,0,0,0,.56.22.82.82,0,0,0,.82-.77V13.9a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.79.79,0,0,0-.57.23.77.77,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M202.23,19.64a.84.84,0,0,0,.26.54.82.82,0,0,0,1.12,0,.79.79,0,0,0,.26-.54V10.79a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56v8.85"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M206.77,18a.82.82,0,0,0,1.64,0V13.9a.85.85,0,0,0-.25-.56.82.82,0,0,0-1.14,0,.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M211.3,18a.82.82,0,0,0,1.38.55.86.86,0,0,0,.26-.55V16.17a.85.85,0,0,0-.25-.56.83.83,0,0,0-.57-.23.81.81,0,0,0-.57.23.85.85,0,0,0-.25.56V18"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M200.81,29.76V28l0,0a3.31,3.31,0,0,1-1.27.32,1.86,1.86,0,0,1-1.27-.38,1.62,1.62,0,0,1-.56-.78,2,2,0,0,1,0-1.06,1.61,1.61,0,0,1,.57-.9,1.7,1.7,0,0,1,.89-.38,2.85,2.85,0,0,1,1.67.31l0,0V23.41l-.08,0a4.57,4.57,0,0,0-1.6-.2,3.72,3.72,0,0,0-1.43.32,3.22,3.22,0,0,0-1.16.91,3.5,3.5,0,0,0-.07,4.27,3.36,3.36,0,0,0,1.86,1.2,4.27,4.27,0,0,0,2.35-.09l.13,0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M202.56,26.58a3.47,3.47,0,0,0,1.32,2.67,3.42,3.42,0,0,0,2.89.66,3.37,3.37,0,0,0,1.11-6.22,3.48,3.48,0,0,0-5.32,2.89M205,25.23a1.73,1.73,0,0,1,2.16,2.71,1.72,1.72,0,0,1-2.43-.27,1.74,1.74,0,0,1,.27-2.44"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M279.19,18.75a3.23,3.23,0,0,0-1.14,1.83,3.25,3.25,0,0,0,2.09-.6,1.5,1.5,0,0,0,.68-1.13c0-.19-.12-.49-.65-.49a1.83,1.83,0,0,0-1,.38m-21.36-3.62-1.2,4.41c1.76,0,2.86-.3,3.4-2,.45-1.42.27-2.37-1.82-2.37Zm13,2.35h5.5c-.63,2.1-3.61,3.78-4.45,5.37h3.48L275,24.2h-5.65c0-2.12,3.57-4.58,4.25-5.62h-3.08Zm17.24-.12c1.22,0,1.41.73,1.41,1.29a1.05,1.05,0,0,1-1,1.11h0a.85.85,0,0,1-.66-.23.82.82,0,0,1-.24-.54c0-.18-.08-.36-.3-.4a1,1,0,0,0-.82.3,3.84,3.84,0,0,0-.88,1.3,6.92,6.92,0,0,0-.33.86l-.88,3.16h-2.21l1.8-6.72h2.16l-.39,1.35A3.73,3.73,0,0,1,288,17.36m-12.28,4.46a4.67,4.67,0,0,1,4.55-4.5c1.16,0,2.17.55,2.17,1.47a2.65,2.65,0,0,1-1.92,2.31,7.67,7.67,0,0,1-2.65.38,2.57,2.57,0,0,0,0,.48,1.25,1.25,0,0,0,1.3,1.2h0a3.47,3.47,0,0,0,2.12-1.06l.39,1a4.3,4.3,0,0,1-1,.8,4.5,4.5,0,0,1-2.1.49,2.57,2.57,0,0,1-2.82-2.6m-19.87-7.7h2.58c3.95,0,4.23,2,3.91,3.45-.43,1.77-1.5,3-6,3-.45,1.65-.84,3.08-1,3.6h-2.22c.4-1.5,2.73-10.07,2.73-10.07M275.24,8a37.34,37.34,0,0,0-7.46.78C257.32,11,249.6,17.09,249.6,22.92a6.68,6.68,0,0,0,.14,1.33c.76,3.62,4.55,6.19,9.82,7.23,1.11-4.28,3.67-14.1,3.67-14.1a12,12,0,0,1,1.28-3.53,4.06,4.06,0,0,1,3.14-2.12,4.51,4.51,0,0,1,2.62.48,1.38,1.38,0,0,1,.69,1.32A1.37,1.37,0,0,1,269.55,15a1.06,1.06,0,0,1-1.13-1v-.09c0-.57.33-.65.33-1.07,0-.22-.2-.55-.74-.47a2.18,2.18,0,0,0-1.58,1.55,8.17,8.17,0,0,0-.32,1l-.66,2.56h4.36c-.57,2.06-1.54,5.72-1.81,6.72h-2.2l1.5-5.62h-2.15L261.7,31.81a29,29,0,0,0,3.36.19h.13a35.75,35.75,0,0,0,7.29-.78C283,29,291,22.85,291,17a6.21,6.21,0,0,0-.13-1.29c-1-4.79-7.52-7.72-15.63-7.72Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M112.17,12.89l-6,14.26h-3.9L99.36,15.77a1.56,1.56,0,0,0-.88-1.25,15.37,15.37,0,0,0-3.64-1.21l.09-.42h6.28a1.73,1.73,0,0,1,1.7,1.46l1.55,8.24,3.84-9.7h3.87m15.27,9.6c0-3.76-5.2-4-5.16-5.65,0-.51.49-1.05,1.56-1.19a6.93,6.93,0,0,1,3.63.64l.65-3a10,10,0,0,0-3.45-.63c-3.64,0-6.21,1.94-6.23,4.71,0,2.06,1.83,3.2,3.23,3.88s1.92,1.15,1.91,1.77c0,1-1.14,1.38-2.2,1.4a7.7,7.7,0,0,1-3.79-.9l-.67,3.12a11.12,11.12,0,0,0,4.1.76c3.88,0,6.41-1.91,6.42-4.88m9.63,4.66h3.41l-3-14.26h-3.15a1.68,1.68,0,0,0-1.57,1l-5.53,13.21h3.87l.77-2.13h4.73Zm-4.12-5,1.94-5.36L136,22.1Zm-15.51-9.21-3,14.26H110.7l3-14.26Z"
            })
        ]
    });

});



parcelRegister("5WvqS", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $5f41157808af1ee2$export$ef5a5fe6477555d4; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6vzQe = parcelRequire("6vzQe");
const $5f41157808af1ee2$export$ef5a5fe6477555d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6vzQe.LoggedInJiraBlueWaveTemplateCurrentProductUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("6vzQe", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraBlueWaveTemplateCurrentProductUser", function () { return $b212cff919ebe109$export$ab7d1380fd7cbb01; });
/* logged-in-blue-wave-template-jira-current-product-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $3lcPU = parcelRequire("3lcPU");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $3kG7c = parcelRequire("3kG7c");
const $b212cff919ebe109$export$ab7d1380fd7cbb01 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kG7c.SquareVisaCiscoPfizer), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira',
            defaultMessage: 'Trusted by over 65,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI',
            defaultMessage: 'Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png',
                alt: ''
            }
        }),
        showAtlassianLogo: false,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    useContactExpandCohortLogic: true,
                    CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {})
                })
            ]
        })
    });
};
const $b212cff919ebe109$var$containerCss = null;
const $b212cff919ebe109$var$siteActivationHeadingCss = null;

});


parcelRegister("cPR2f", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraPremiumExistingUser", function () { return $1a5a69c601332f44$export$59403246109877db; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4HNWS = parcelRequire("4HNWS");
const $1a5a69c601332f44$export$59403246109877db = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4HNWS.LoggedInJiraBlueWaveTemplateExistingUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("4HNWS", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraBlueWaveTemplateExistingUser", function () { return $6770c3563db88cf2$export$15d703e99d473a81; });
/* logged-in-blue-wave-template-jira-existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $3lcPU = parcelRequire("3lcPU");

var $33py5 = parcelRequire("33py5");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $4hd0c = parcelRequire("4hd0c");

var $e9I0Z = parcelRequire("e9I0Z");

var $9Zmgh = parcelRequire("9Zmgh");

var $3kG7c = parcelRequire("3kG7c");
const $6770c3563db88cf2$export$15d703e99d473a81 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name, email: email } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kG7c.SquareVisaCiscoPfizer), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira',
            defaultMessage: 'Trusted by over 65,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI',
            defaultMessage: 'Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png',
                alt: ''
            }
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hd0c.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Zmgh.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_84yz1wa3 _eeia15se _5pvqc4v4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $6770c3563db88cf2$var$containerCss = null;
const $6770c3563db88cf2$var$siteActivationHeadingCss = null;
const $6770c3563db88cf2$var$spacingSyles = null;
const $6770c3563db88cf2$var$sitePickerCss = null;

});


parcelRegister("g3Cdk", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraPremiumUpgradeEligibleUser", function () { return $8c84b4e3894cfefe$export$c4bff09cf0f8d30d; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $lDmjg = parcelRequire("lDmjg");

var $6e3tU = parcelRequire("6e3tU");

var $aUEBX = parcelRequire("aUEBX");

var $lP7A9 = parcelRequire("lP7A9");

var $hhijw = parcelRequire("hhijw");
const $8c84b4e3894cfefe$export$c4bff09cf0f8d30d = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const valueProps = [
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDmjg))), {
                color: (0, $lP7A9.default)('color.icon.brand'),
                label: "Atlassian Intelligence"
            }),
            heading: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title',
                defaultMessage: 'Atlassian Intelligence (AI)'
            }),
            body: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body',
                defaultMessage: 'AI-powered features to help teams create value faster'
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aUEBX))), {
                color: (0, $lP7A9.default)('color.icon.brand'),
                label: "Timeline"
            }),
            heading: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title',
                defaultMessage: 'Advanced planning'
            }),
            body: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body',
                defaultMessage: 'Plan work and track progress across multiple teams and projects'
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
                color: (0, $lP7A9.default)('color.icon.brand'),
                label: "Comment"
            }),
            heading: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title',
                defaultMessage: 'Premium support'
            }),
            body: formatMessage({
                id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body',
                defaultMessage: "Get 24/7 support from Atlassian's team of experts"
            })
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhijw.LoggedInJiraWhiteTemplateUpgradeEligibleUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        }),
        textHeading: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle',
            defaultMessage: 'Upgrade to the Premium plan'
        }),
        textBody: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody',
            defaultMessage: 'Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime.'
        }),
        valuePropsHeading: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro',
            defaultMessage: 'The Premium plan also includes:'
        }),
        valueProps: valueProps
    });
};

});
parcelRegister("lDmjg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbfe8bb9d03b059a$var$_react = $fbfe8bb9d03b059a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $fbfe8bb9d03b059a$var$_baseNew = $fbfe8bb9d03b059a$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $fbfe8bb9d03b059a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fbfe8bb9d03b059a$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $fbfe8bb9d03b059a$var$_react.default.createElement($fbfe8bb9d03b059a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$fbfe8bb9d03b059a$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $fbfe8bb9d03b059a$var$_default = module.exports.default = $fbfe8bb9d03b059a$var$AtlassianIntelligenceIcon;

});

parcelRegister("hhijw", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraWhiteTemplateUpgradeEligibleUser", function () { return $d184f3ef438de3c6$export$957409ddf7533d80; });
/* logged-in-jira-upgrade-eligible-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $acjlx = parcelRequire("acjlx");

var $2HR6E = parcelRequire("2HR6E");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $4hd0c = parcelRequire("4hd0c");

var $e9I0Z = parcelRequire("e9I0Z");

var $3SMzf = parcelRequire("3SMzf");

var $kzyzK = parcelRequire("kzyzK");
const $d184f3ef438de3c6$export$957409ddf7533d80 = (props)=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name, email: email } } = (0, $7GVWk.useUserContext)();
    // Upgradeable Standard Sites Experiment
    const existingSites = (0, $kzyzK.useGetExistingSites)();
    const siteActivationContent = existingSites ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {
        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3SMzf.SubmitButtonMessageNext), {})
    }) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $acjlx.WhiteTemplate), {
        ...props,
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "brand",
                size: "xlarge"
            }, "jira")
        ],
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hd0c.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    existingSites: existingSites,
                    UpgradeEligibleUser: siteActivationContent,
                    CurrentProductUser: siteActivationContent,
                    WeekOneUser: siteActivationContent ?? null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $d184f3ef438de3c6$var$containerCss = null;
const $d184f3ef438de3c6$var$siteActivationHeadingCss = null;
const $d184f3ef438de3c6$var$spacingStyles = null;

});
parcelRegister("acjlx", function(module, exports) {
$parcel$export(module.exports, "WhiteTemplate", function () { return $98c4fed3d5e38977$export$f12ff8acd4482ce4; });
/* white-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5YGzb = parcelRequire("5YGzb");

var $kbpa7 = parcelRequire("kbpa7");
const $98c4fed3d5e38977$export$f12ff8acd4482ce4 = ({ children: children, productEditionText: productEditionText, productLogos: productLogos, textBody: textBody, textHeading: textHeading, valueProps: valueProps, valuePropsHeading: valuePropsHeading })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpckbl _1q51gktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1xdi1ule _1ii71ule _l9z01osq _4x201osq _1ytiidpf _6q26idpf _7yhb1wug _gncu1wug _1bdkidpf _ujqdidpf _24rc1wug _t7bl1wug"
                        ]),
                        children: productLogos
                    }),
                    productEditionText && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect41vau _1wybgktf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: productEditionText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp14no _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _p12f15kq _1bsb1osq _1lp71gnb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1afi _1e0c1txw _2lx21bp4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1osq _1bsbc1vo _1bah1yb4 _zs121wa3 _11ur1wa3 _1o7p7vkz _1rnl7vkz _epkxftgi _zg7p130s _1j96zwfg _jvmrzwfg _k0mszwfg _1b7pzwfg"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: [
                            children,
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bah1h6o _6rthidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                                    appearance: "brand",
                                    size: "xsmall"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _zulp7vkz _1wafvbgk"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: textHeading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: textBody
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: valuePropsHeading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                className: (0, $2jatx.default)([
                                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: valueProps.map(({ icon: icon, heading: heading, body: body }, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _6rth1crf _zulp7vkz"
                                        ]),
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                        className: (0, $2jatx.default)([
                                                            "_ect4z4z1 _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                        ]),
                                                        style: {
                                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                        },
                                                        children: heading
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        className: (0, $2jatx.default)([
                                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                        ]),
                                                        children: body
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $98c4fed3d5e38977$var$atlassianLogoCss = null;
const $98c4fed3d5e38977$var$containerCss = null;
const $98c4fed3d5e38977$var$contentColumnCss = null;
const $98c4fed3d5e38977$var$formColumnCss = null;
const $98c4fed3d5e38977$var$headerCss = null;
const $98c4fed3d5e38977$var$mainCss = null;
const $98c4fed3d5e38977$var$productEditionTextCss = null;
const $98c4fed3d5e38977$var$productLogosCss = null;
const $98c4fed3d5e38977$var$textHeadingCss = null;
const $98c4fed3d5e38977$var$textBodyCss = null;
const $98c4fed3d5e38977$var$valuePropsHeadingCss = null;
const $98c4fed3d5e38977$var$valuePropsListCss = null;
const $98c4fed3d5e38977$var$valuePropItemCss = null;
const $98c4fed3d5e38977$var$valuePropItemHeadingCss = null;
const $98c4fed3d5e38977$var$valuePropItemBodyCss = null;

});




parcelRegister("c5Hx1", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraStandard", function () { return $7e8ab1a09dd50ff4$export$4727bb85fea1ea28; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $gXWBk = parcelRequire("gXWBk");

var $2yhFN = parcelRequire("2yhFN");

var $laUUl = parcelRequire("laUUl");

var $y81oN = parcelRequire("y81oN");

var $1DBdS = parcelRequire("1DBdS");
const $7e8ab1a09dd50ff4$export$4727bb85fea1ea28 = ()=>{
    const useContactExpandCohortLogic = (0, $2WL8B.useIsJiraContactCompanyExpandEligible)();
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    if (useContactExpandCohortLogic) {
        if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $laUUl.CurrentProductUser), {});
        if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2yhFN.CurrentProductJoinableUser), {});
        if (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DBdS.LoggedInJiraStandardUpgradeEligibleUser), {});
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXWBk.LoggedInJiraNewUser), {});
    }
    if (cohort === (0, $2WL8B.COHORTS).NEW_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXWBk.LoggedInJiraNewUser), {});
    if (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DBdS.LoggedInJiraStandardUpgradeEligibleUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $y81oN.LoggedInJiraStandardExistingUser), {});
    return null;
};

});
parcelRegister("2yhFN", function(module, exports) {
$parcel$export(module.exports, "CurrentProductJoinableUser", function () { return $050a37c08dfc5f13$export$805d233848710db8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bmQmF = parcelRequire("bmQmF");
const $050a37c08dfc5f13$export$805d233848710db8 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bmQmF.LoggedInJiraBlueWaveTemplateCurrentProductJoinableUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: 'Cloud Standard'
        })
    });
};

});

parcelRegister("laUUl", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $fadc53149b0c0928$export$ef5a5fe6477555d4; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6vzQe = parcelRequire("6vzQe");
const $fadc53149b0c0928$export$ef5a5fe6477555d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6vzQe.LoggedInJiraBlueWaveTemplateCurrentProductUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: 'Cloud Standard'
        })
    });
};

});

parcelRegister("y81oN", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraStandardExistingUser", function () { return $2ef5bf6482fa80be$export$ce18df5e32f27dc8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4HNWS = parcelRequire("4HNWS");
const $2ef5bf6482fa80be$export$ce18df5e32f27dc8 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4HNWS.LoggedInJiraBlueWaveTemplateExistingUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: 'Cloud Standard'
        })
    });
};

});

parcelRegister("1DBdS", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraStandardUpgradeEligibleUser", function () { return $32dfb2d4451935f3$export$af53b4a52fb13e22; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6e3tU = parcelRequire("6e3tU");

var $9QN0F = parcelRequire("9QN0F");

var $dpqQm = parcelRequire("dpqQm");

var $lP7A9 = parcelRequire("lP7A9");

var $hhijw = parcelRequire("hhijw");
const $32dfb2d4451935f3$export$af53b4a52fb13e22 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhijw.LoggedInJiraWhiteTemplateUpgradeEligibleUser), {
        productEditionText: formatMessage({
            id: `WacSignupForm.cloudStandard`,
            defaultMessage: 'Cloud Standard'
        }),
        textHeading: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle',
            defaultMessage: 'Upgrade to the Standard plan'
        }),
        textBody: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeBody',
            defaultMessage: 'Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime.'
        }),
        valuePropsHeading: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro',
            defaultMessage: 'The Standard plan also includes:'
        }),
        valueProps: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QN0F))), {
                    color: (0, $lP7A9.default)('color.icon.brand'),
                    label: "PersonAdd"
                }),
                heading: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title',
                    defaultMessage: 'User roles & permissions'
                }),
                body: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body',
                    defaultMessage: 'Have more control over which users have access to different projects and actions.'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dpqQm))), {
                    color: (0, $lP7A9.default)('color.icon.brand'),
                    label: "PersonAdd"
                }),
                heading: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title',
                    defaultMessage: 'Anonymous access'
                }),
                body: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body',
                    defaultMessage: 'Give secure access to people outside your team.'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
                    color: (0, $lP7A9.default)('color.icon.brand'),
                    label: "Comment"
                }),
                heading: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title',
                    defaultMessage: 'Business hour support'
                }),
                body: formatMessage({
                    id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body',
                    defaultMessage: "Get support from Atlassian\u2019s team of experts."
                })
            }
        ]
    });
};

});
parcelRegister("9QN0F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72befcb0c0e68ebb$var$_react = $72befcb0c0e68ebb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $72befcb0c0e68ebb$var$_baseNew = $72befcb0c0e68ebb$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $72befcb0c0e68ebb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72befcb0c0e68ebb$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72befcb0c0e68ebb$var$_react.default.createElement($72befcb0c0e68ebb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72befcb0c0e68ebb$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72befcb0c0e68ebb$var$_default = module.exports.default = $72befcb0c0e68ebb$var$LockLockedIcon;

});

parcelRegister("dpqQm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c326ebccd6ec650$var$_react = $9c326ebccd6ec650$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9c326ebccd6ec650$var$_baseNew = $9c326ebccd6ec650$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9c326ebccd6ec650$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c326ebccd6ec650$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $9c326ebccd6ec650$var$_react.default.createElement($9c326ebccd6ec650$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$9c326ebccd6ec650$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $9c326ebccd6ec650$var$_default = module.exports.default = $9c326ebccd6ec650$var$PersonAvatarIcon;

});




parcelRegister("ipRho", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJira", function () { return $6a05d15779e9eedb$export$beeaebb3f31e5db2; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $gYyD8 = parcelRequire("gYyD8");

var $K0WXv = parcelRequire("K0WXv");

var $adCIC = parcelRequire("adCIC");
const $6a05d15779e9eedb$export$beeaebb3f31e5db2 = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    if (edition === 'premium') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $K0WXv.LoggedOutJiraPremium), {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $adCIC.LoggedOutJiraStandard), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gYyD8.LoggedOutJiraFree), {});
};

});
parcelRegister("gYyD8", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraFree", function () { return $4bac52bc08a16147$export$f79660ec8d789c11; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");

var $gwyhT = parcelRequire("gwyhT");

var $izdHQ = parcelRequire("izdHQ");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $it3hk = parcelRequire("it3hk");
const $4bac52bc08a16147$export$f79660ec8d789c11 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1565-sign-up-flow-overlay",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
                        productName: "Jira"
                    }),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "signupForm.accountCreation.subHeaderText",
                        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                    experimentKey: "jfind-1185-signup-button-update",
                    group: "Test",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                        Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                        Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}),
                        Submit: null
                    })
                })
            ]
        })
    });
};

});

parcelRegister("K0WXv", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraPremium", function () { return $eddf415ed1b81d94$export$129705c0e8cc4c41; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");

var $gwyhT = parcelRequire("gwyhT");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $it3hk = parcelRequire("it3hk");
const $eddf415ed1b81d94$export$129705c0e8cc4c41 = ()=>{
    const intl = (0, $8e22h.default)();
    const heading2 = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.subheader.jsw.premium',
        defaultMessage: "30-day free trial for unlimited users on the Premium plan \u2014 no credit card needed"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.JiraOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
                    productName: "Jira"
                }),
                sub: heading2
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}),
                Submit: null
            })
        ]
    });
};

});

parcelRegister("adCIC", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraStandard", function () { return $c36f198aff77ed6e$export$3b6cb8cefe40e033; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");

var $gwyhT = parcelRequire("gwyhT");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $it3hk = parcelRequire("it3hk");
const $c36f198aff77ed6e$export$3b6cb8cefe40e033 = ()=>{
    const intl = (0, $8e22h.default)();
    const heading2 = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.subheader.jsw.standard',
        defaultMessage: "14-day free trial for unlimited users on the Standard plan \u2014 no credit card needed"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.JiraOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
                    productName: "Jira"
                }),
                sub: heading2
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}),
                Submit: null
            })
        ]
    });
};

});



parcelRegister("gxozr", function(module, exports) {
$parcel$export(module.exports, "JpdSignup", function () { return $07df521e7ed00e77$export$dc2b102bb1cfa016; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $hxXGw = parcelRequire("hxXGw");

var $kGyJL = parcelRequire("kGyJL");
const $07df521e7ed00e77$export$dc2b102bb1cfa016 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hxXGw.LoggedInJpd), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kGyJL.LoggedOutJpd), {});
};

});
parcelRegister("hxXGw", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpd", function () { return $2d0cc5a551aef300$export$cb2a08d7c43e3ee1; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $5yuBp = parcelRequire("5yuBp");

var $lSXuE = parcelRequire("lSXuE");

var $73jWO = parcelRequire("73jWO");

var $Xicgw = parcelRequire("Xicgw");

var $fyDTl = parcelRequire("fyDTl");
const $2d0cc5a551aef300$export$cb2a08d7c43e3ee1 = ()=>{
    const isMobile = (0, $5yuBp.useIsMobile)();
    return isMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)($2d0cc5a551aef300$var$CohortComponent, {});
};
const $2d0cc5a551aef300$var$CohortComponent = ()=>{
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    const isFree = (0, $2WL8B.useFreeIntent)();
    if (isFree) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73jWO.LoggedInJpdFree), {});
    if (isStandard) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fyDTl.LoggedInJpdStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Xicgw.LoggedInJpdPremium), {});
    // bxpkit catch-all (paid editions if gate is off)
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
};

});
parcelRegister("73jWO", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpdFree", function () { return $6d7a64af76623814$export$e7aa14f55abb6efc; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $1VLGB = parcelRequire("1VLGB");

var $ao3ZK = parcelRequire("ao3ZK");
const $6d7a64af76623814$export$e7aa14f55abb6efc = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ao3ZK.LoggedInJpdNewUser), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1VLGB.LoggedInJpdExistingUser), {});
};

});
parcelRegister("1VLGB", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpdExistingUser", function () { return $d3b824bd9ed863d7$export$e7519de7d50e16c8; });
/* existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $d3b824bd9ed863d7$export$e7519de7d50e16c8 = ()=>{
    const { ref: ref } = (0, $jKShK.useInView)();
    const isLoggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d3b824bd9ed863d7$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d3b824bd9ed863d7$var$Content, {})
        })
    });
};
const $d3b824bd9ed863d7$var$Content = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SitesAreSharedSpacesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
                className: (0, $2jatx.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: 'JiraSoftwarePageTemplate.loggedInHero.recatcha',
                    defaultMessage: 'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.'
                })
            })
        ]
    });
};
const $d3b824bd9ed863d7$var$footerCss = null;

});

parcelRegister("ao3ZK", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpdNewUser", function () { return $5f350927100ab1c0$export$cee9af0ba2f2061c; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $ahLPp = parcelRequire("ahLPp");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");
const $5f350927100ab1c0$export$cee9af0ba2f2061c = ()=>{
    const { ref: ref } = (0, $jKShK.useInView)();
    const isLoggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($5f350927100ab1c0$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($5f350927100ab1c0$var$Content, {})
        })
    });
};
const $5f350927100ab1c0$var$Content = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahLPp.CreateASiteText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SitesAreSharedSpacesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
                className: (0, $2jatx.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: 'JiraSoftwarePageTemplate.loggedInHero.recatcha',
                    defaultMessage: 'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.'
                })
            })
        ]
    });
};
const $5f350927100ab1c0$var$footerCss = null;

});


parcelRegister("Xicgw", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpdPremium", function () { return $42684c18531dba99$export$d6179757c2706927; });
/* logged-in-jpd-premium.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $gwyhT = parcelRequire("gwyhT");

var $2HR6E = parcelRequire("2HR6E");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $3SMzf = parcelRequire("3SMzf");

var $emciF = parcelRequire("emciF");

var $kzyzK = parcelRequire("kzyzK");

var $ao3ZK = parcelRequire("ao3ZK");
const $42684c18531dba99$export$d6179757c2706927 = ()=>{
    const { ref: ref } = (0, $jKShK.useInView)();
    const cohort = (0, $2WL8B.useCohort)();
    const isLoggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    // Upgradeable Standard Sites Experiment
    const existingSites = (0, $kzyzK.useGetExistingSites)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ao3ZK.LoggedInJpdNewUser), {});
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($42684c18531dba99$var$Content, {
                existingSites: existingSites
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($42684c18531dba99$var$Content, {
                existingSites: existingSites
            })
        })
    });
};
const $42684c18531dba99$var$Content = ({ existingSites: existingSites })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const siteActivationContent = existingSites ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {
        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3SMzf.SubmitButtonMessageNext), {})
    }) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SitesAreSharedSpacesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                existingSites: existingSites,
                UpgradeEligibleUser: siteActivationContent,
                CurrentProductUser: siteActivationContent,
                WeekOneUser: siteActivationContent ?? null
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
                className: (0, $2jatx.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: 'JiraSoftwarePageTemplate.loggedInHero.recatcha',
                    defaultMessage: 'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.'
                })
            })
        ]
    });
};
const $42684c18531dba99$var$footerCss = null;

});

parcelRegister("fyDTl", function(module, exports) {
$parcel$export(module.exports, "LoggedInJpdStandard", function () { return $ac82d823d14e5f4c$export$f9e002478e7e9ef9; });
/* logged-in-jpd-standard.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");

var $ao3ZK = parcelRequire("ao3ZK");
const $ac82d823d14e5f4c$export$f9e002478e7e9ef9 = ()=>{
    const { ref: ref } = (0, $jKShK.useInView)();
    const cohort = (0, $2WL8B.useCohort)();
    const isLoggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ao3ZK.LoggedInJpdNewUser), {});
    if (isLoggedInHasJira) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JiraOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($ac82d823d14e5f4c$var$Content, {})
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JPDOverlayTemplate), {
            size: "sm",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($ac82d823d14e5f4c$var$Content, {})
        })
    });
};
const $ac82d823d14e5f4c$var$Content = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SitesAreSharedSpacesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
                className: (0, $2jatx.default)([
                    "_1wyb1crf _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect48q0o"
                ]),
                children: formatMessage({
                    id: 'JiraSoftwarePageTemplate.loggedInHero.recatcha',
                    defaultMessage: 'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.'
                })
            })
        ]
    });
};
const $ac82d823d14e5f4c$var$footerCss = null;

});


parcelRegister("kGyJL", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJpd", function () { return $692f6a1d74dcc173$export$965e0701e24dde42; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $jKShK = parcelRequire("jKShK");

var $6KUQg = parcelRequire("6KUQg");

var $gwyhT = parcelRequire("gwyhT");

var $2WL8B = parcelRequire("2WL8B");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $it3hk = parcelRequire("it3hk");
const $692f6a1d74dcc173$export$965e0701e24dde42 = ()=>{
    const { ref: ref } = (0, $jKShK.useInView)();
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    if (isStandard || isPremium) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($692f6a1d74dcc173$var$LoggedOutJpdStandardPremium, {})
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($692f6a1d74dcc173$var$LoggedOutJpdFree, {})
    });
};
const $692f6a1d74dcc173$var$LoggedOutJpdFree = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.JPDOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.JPDGetStartedText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForThreeCreatorsText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });
};
const $692f6a1d74dcc173$var$LoggedOutJpdStandardPremium = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.JPDOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.JPDGetStartedText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeToGetStartedText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });
};

});


parcelRegister("j6bad", function(module, exports) {
$parcel$export(module.exports, "JsmSignup", function () { return $47663e3095d4383d$export$892d03ae6ccca3f6; });

var $7VQPk = parcelRequire("7VQPk");

var $fcO7r = parcelRequire("fcO7r");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $ds3R2 = parcelRequire("ds3R2");

var $8GrNC = parcelRequire("8GrNC");

var $4Xs5t = parcelRequire("4Xs5t");
const $47663e3095d4383d$export$892d03ae6ccca3f6 = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn }, edition: edition } = (0, $7GVWk.useUserContext)();
    const isUpgradeEligible = (0, $2WL8B.useIsUpgradeEligible)();
    const shouldRedirect = (0, $ds3R2.handleSignupRouteRedirects)({
        // Hardcoding since we don't need extra check for JSM product
        product: (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT,
        bundle: 'jira-service-management',
        isUpgradeEligible: isUpgradeEligible,
        edition: edition
    });
    if (shouldRedirect) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GrNC.LoggedInJsm), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Xs5t.LoggedOutJsm), {});
};

});
parcelRegister("ds3R2", function(module, exports) {
$parcel$export(module.exports, "handleSignupRouteRedirects", function () { return $b33031fbdb6e9e52$export$4dcbeef19755f6bf; });

var $fcO7r = parcelRequire("fcO7r");

var $kNE9Z = parcelRequire("kNE9Z");
const $b33031fbdb6e9e52$export$6f9ec0d20516a75 = [
    'jira-service-desk-jira-software-confluence',
    'confluence-jira-service-desk',
    'confluence-jira-service-management',
    'jira-service-desk-confluence',
    'jira-service-management-confluence',
    'jira-software-jira-service-management',
    'jira-service-management-jira-software',
    'jira-service-management-jira-software-confluence',
    'jira-software-jira-service-management-confluence'
];
const $b33031fbdb6e9e52$export$94b45cafcfd2e8aa = [
    'opsgenie'
];
const $b33031fbdb6e9e52$export$ddac0a273149d68b = [
    'confluence-jira-software',
    'jira-software-confluence',
    'jira-software-confluence-compass',
    'jira-core-confluence'
];
const $b33031fbdb6e9e52$export$98613fe78bf40c7a = [
    'fabric'
];
const $b33031fbdb6e9e52$export$4dcbeef19755f6bf = ({ product: product, bundle: bundle, isUpgradeEligible: isUpgradeEligible, edition: edition })=>{
    const townsquareRedirectionURL = 'https://community.atlassian.com/t5/Atlas-Group-articles/Atlas-is-evolving/ba-p/2686154';
    const productParamRedirect = ()=>{
        const productBundleMap = {
            loom: 'loom',
            'com.atlassian.bitbucket': 'bitbucket',
            opsgenie: 'opsgenie',
            compass: 'compass',
            statuspage: 'statuspage'
        };
        const bundleKey = productBundleMap[product];
        if (bundleKey && bundle !== bundleKey) {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', bundleKey);
                currentUrl.searchParams.delete('product');
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === 'atlassian-whiteboard') {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('product', 'confluence.ondemand');
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === 'townsquare') {
            if (typeof window.location.assign === 'function') window.location.assign(townsquareRedirectionURL);
            return true;
        }
        return false;
    };
    if (product && productParamRedirect()) return true;
    const bundleParamRedirect = ()=>{
        const isJswRedirectBundle = bundle === 'avocado' || bundle === 'jira-ops' || bundle === 'devops';
        const isBitbucketRedirectBundle = bundle === 'jira-software-bitbucket' || bundle === 'bitbucket-jira-software';
        if (isJswRedirectBundle || isBitbucketRedirectBundle) {
            const redirectBundle = isJswRedirectBundle ? 'jira-software' : 'bitbucket';
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', redirectBundle);
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if ($b33031fbdb6e9e52$export$98613fe78bf40c7a.includes(bundle)) {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', 'confluence');
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        const isTeamCentralBundle = bundle === 'team-central' || bundle === 'atlas';
        if (isTeamCentralBundle) {
            if (typeof window.location.assign === 'function') window.location.assign(townsquareRedirectionURL);
            return true;
        }
        return false;
    };
    if (bundle && bundleParamRedirect()) return true;
    const collectionRedirection = ()=>{
        if ((product === (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT || bundle === 'jira-service-management' || bundle === 'jira-service-desk') && (edition === 'free' || isUpgradeEligible === false)) {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', 'service-collection');
                currentUrl.searchParams.set('primaryCollectionProduct', (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT);
                currentUrl.searchParams.delete('product');
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (collectionRedirection()) return true;
    const serviceCollectionBundleRedirection = ()=>{
        if ($b33031fbdb6e9e52$export$6f9ec0d20516a75.includes(bundle) || (0, $kNE9Z.isProduction)() && $b33031fbdb6e9e52$export$94b45cafcfd2e8aa.includes(bundle)) {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', 'service-collection');
                currentUrl.searchParams.set('primaryCollectionProduct', (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT);
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (serviceCollectionBundleRedirection()) return true;
    const teamworkCollectionBundleRedirection = ()=>{
        if ($b33031fbdb6e9e52$export$ddac0a273149d68b.includes(bundle)) {
            if (typeof window.location.assign === 'function') {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('bundle', 'teamwork-collection');
                currentUrl.searchParams.delete('product');
                currentUrl.searchParams.delete('developer');
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (teamworkCollectionBundleRedirection()) return true;
    return false;
};

});

parcelRegister("8GrNC", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsm", function () { return $29b0118268c5a1d7$export$d3f772aa4c0e5318; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $lSXuE = parcelRequire("lSXuE");

var $jCaob = parcelRequire("jCaob");

var $hOtJq = parcelRequire("hOtJq");

var $3A3ZD = parcelRequire("3A3ZD");
const $29b0118268c5a1d7$export$d3f772aa4c0e5318 = ()=>{
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    const isFree = (0, $2WL8B.useFreeIntent)();
    const isUpgradeEligible = (0, $2WL8B.useIsUpgradeEligible)();
    if (isPremium && !isUpgradeEligible) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hOtJq.LoggedInJsmPremium), {});
    if (isStandard && !isUpgradeEligible) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3A3ZD.LoggedInJsmStandard), {});
    if (isFree) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jCaob.LoggedInJsmFree), {});
    // bxpkit catch-all
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
};

});
parcelRegister("jCaob", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsmFree", function () { return $6615ecec80c3878e$export$c5178f55d7b323c7; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2WL8B = parcelRequire("2WL8B");

var $5udIk = parcelRequire("5udIk");

var $7wMPN = parcelRequire("7wMPN");
const $6615ecec80c3878e$export$c5178f55d7b323c7 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7wMPN.LoggedInJsmNewUser), {});
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5udIk.LoggedInJsmExistingUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudFree',
            defaultMessage: 'Cloud Free'
        })
    });
    return null;
};

});
parcelRegister("5udIk", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsmExistingUser", function () { return $1fe3561a29c4e095$export$d95bbf4914d0e368; });
/* existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $33py5 = parcelRequire("33py5");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $4hd0c = parcelRequire("4hd0c");

var $e9I0Z = parcelRequire("e9I0Z");

var $9Zmgh = parcelRequire("9Zmgh");

var $31ZYY = parcelRequire("31ZYY");
const $1fe3561a29c4e095$export$d95bbf4914d0e368 = ({ productEditionText: productEditionText })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($1fe3561a29c4e095$export$c20c1b72868f8509, {
        productEditionText: productEditionText || ''
    });
};
const $1fe3561a29c4e095$export$c20c1b72868f8509 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name, email: email } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $31ZYY.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hd0c.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Zmgh.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_84yz1wa3 _eeia15se"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $1fe3561a29c4e095$var$containerCss = null;
const $1fe3561a29c4e095$var$siteActivationHeadingCss = null;
const $1fe3561a29c4e095$var$sitePickerCss = null;
const $1fe3561a29c4e095$var$spacingSyles = null;

});
parcelRegister("31ZYY", function(module, exports) {
$parcel$export(module.exports, "BlueWaveTemplateJsm", function () { return $5a10ced28d5ab22b$export$5795842de5478b35; });
/* blue-wave-template-jsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $3lcPU = parcelRequire("3lcPU");

var $hnmMQ = parcelRequire("hnmMQ");

var $7sC16 = parcelRequire("7sC16");
const $5a10ced28d5ab22b$export$5795842de5478b35 = ({ productEditionText: productEditionText, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3lcPU.BlueWaveTemplate), {
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sC16.VerizonSquareDominosTwitter), {}),
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD',
            defaultMessage: 'Powering high-velocity service teams'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD',
            defaultMessage: 'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly'
        }).split('{newline}'),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraServiceManagementLogo), {
                appearance: "inverse",
                size: "xlarge"
            }, "jsm")
        ],
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg',
                alt: ''
            }
        }),
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulpftgi"
            ]),
            children: children
        })
    });
};
const $5a10ced28d5ab22b$var$containerCss = null;

});
parcelRegister("7sC16", function(module, exports) {
$parcel$export(module.exports, "VerizonSquareDominosTwitter", function () { return $54fc67dd54f44a46$export$330cb7105f47bc90; });

var $7VQPk = parcelRequire("7VQPk");
const $54fc67dd54f44a46$export$330cb7105f47bc90 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 300 40",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M105.17 22a.5.5 0 0 1-.51.5h-3.57a.5.5 0 0 1-.51-.5v-3.5a.51.51 0 0 1 .51-.5h3.57a.51.51 0 0 1 .51.5V22Zm3.06 2.63a.88.88 0 0 1-.89.87H98.4a.88.88 0 0 1-.89-.87v-8.76a.88.88 0 0 1 .89-.87h8.94a.88.88 0 0 1 .89.87Zm.26-12.63H97.26a2.79 2.79 0 0 0-2.81 2.75v11a2.79 2.79 0 0 0 2.81 2.75h11.22a2.79 2.79 0 0 0 2.81-2.75v-11a2.79 2.79 0 0 0-2.8-2.75"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.38 26a3.75 3.75 0 0 1-2.62-1 3 3 0 0 1-.94-2.13h1a2 2 0 0 0 .64 1.44 2.74 2.74 0 0 0 1.91.74 2.37 2.37 0 0 0 2.55-2.13c0-.88-.51-1.58-3-2.13a4.33 4.33 0 0 1-2.1-.94 2.34 2.34 0 0 1-.71-1.82 3 3 0 0 1 3.16-2.79 3.4 3.4 0 0 1 2.21.79 2.6 2.6 0 0 1 1 2h-1a2 2 0 0 0-2.15-1.79 2 2 0 0 0-2.15 1.8c0 .9.31 1.42 2 1.81s3.71 1.1 3.72 3.08a2.93 2.93 0 0 1-1.06 2.22 3.86 3.86 0 0 1-2.5.89Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M127.87 18.58a3.09 3.09 0 1 0 3.18 3.1 3.1 3.1 0 0 0-3.18-3.1M131 28.5v-4.37a3.71 3.71 0 0 1-3.1 1.5 4.07 4.07 0 0 1-4.28-4 4.08 4.08 0 0 1 4.28-3.95 3.67 3.67 0 0 1 3.1 1.52v-1.3h1v10.6Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146 18.55a3 3 0 1 0 3.18 3 3.07 3.07 0 0 0-3.18-3m3.12 6.6v-1.27a3.77 3.77 0 0 1-3.12 1.45 4 4 0 0 1-4.28-3.82 4 4 0 0 1 4.28-3.8 3.66 3.66 0 0 1 3.09 1.46V17.9h1v7.25Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M153.1 21v4.35h-1V17.9h1V19a2.26 2.26 0 0 1 2.21-1.27v1A2.17 2.17 0 0 0 153.1 21"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M159.53 18.55a3.09 3.09 0 0 0-3.14 2.45h6.29a3.1 3.1 0 0 0-3.15-2.48m4.2 3.31h-7.34a3.23 3.23 0 0 0 6 .92h1.09a4.22 4.22 0 0 1-4 2.55 4 4 0 0 1-4.2-3.8 4 4 0 0 1 4.19-3.82 4.09 4.09 0 0 1 4.23 3.89v.26"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M139.54 25.15V24a2.5 2.5 0 0 1-2.36 1.34 3.15 3.15 0 0 1-2.54-1.12 3.78 3.78 0 0 1-.65-2.39v-4.12h.94v4.09c0 1.54.56 2.67 2.25 2.67a2.1 2.1 0 0 0 1.57-.6 2.8 2.8 0 0 0 .77-2.23v-3.93h.94v7.44Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M222.22 21.09c-.88-2.16-3.91-1.49-4.74-.1V19.9h-2.63v7.67h2.73v-3.86c0-1.44.29-1.54 1-1.59s1 .05 1 1.59l.05 3.86h2.63v-4c0-.72.15-1.39.88-1.39.88 0 1.08.05 1.08 1.19v4.22H227v-5.68c.1-2.72-3.56-2.78-4.78-.82Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M210.11 19.34a4.12 4.12 0 1 0 3.89 4.12 4 4 0 0 0-3.89-4.12Zm0 5.56a1.45 1.45 0 0 1 0-2.89 1.45 1.45 0 0 1 0 2.89Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M202.7 17.43a5 5 0 0 0-1.66-.51 21 21 0 0 0-2.49-.16h-3v10.81h2.78a24.3 24.3 0 0 0 2.73-.15 6.77 6.77 0 0 0 1.71-.52 6 6 0 0 0 2.1-1.95 5.68 5.68 0 0 0 0-5.56 5.85 5.85 0 0 0-2.17-1.96Zm-.34 6a2.29 2.29 0 0 1-.88.92 2.82 2.82 0 0 1-.69.26 4.21 4.21 0 0 1-1.12.05h-1.12V19.6h1.26a7.11 7.11 0 0 1 1 0 1.6 1.6 0 0 1 .68.25 2.64 2.64 0 0 1 .88.93 3 3 0 0 1 .29 1.28 4.11 4.11 0 0 1-.3 1.4Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M228.22 19.75h2.73v7.77h-2.73z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M250.62 18.21a2.19 2.19 0 0 0-.1-1.39 1.49 1.49 0 0 0-1.36-.93 1.45 1.45 0 0 0-1.47 1.11 1.59 1.59 0 0 0 1 1.9c.19.05.39 0 .24.26a2.87 2.87 0 0 1-.54.56l.29.47c1.21-.64 1.8-1.32 1.94-1.98Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M244.47 19.34a4.12 4.12 0 1 0 3.91 4.12 4 4 0 0 0-3.91-4.12Zm0 5.56a1.4 1.4 0 0 1-1.36-1.44 1.37 1.37 0 1 1 2.73 0 1.41 1.41 0 0 1-1.37 1.44Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M253.7 22.37c-1.37 0-1.27-1-.44-1a3.54 3.54 0 0 1 2.44.77l.88-1.79c-2.4-1.5-6.45-1.29-6.54 1.44 0 1.54 1.07 2.31 3.36 2.57 1.67.21 1.18 1 .25 1.08a4.46 4.46 0 0 1-2.73-.93l-1.18 1.86c3.22 2.16 7 1.18 7.13-1.34.13-1.52-.98-2.71-3.17-2.66Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M234.86 21v-1.1h-2.64v7.67h2.64v-3.86c0-1.28.53-1.54 1.12-1.59s1.27.05 1.27 1.59l.05 3.86h2.63V22c-.04-2.81-4.05-2.81-5.07-1Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M229.59 15.89a1.6 1.6 0 1 0 1.51 1.6 1.57 1.57 0 0 0-1.51-1.6Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "m192.71 15.35-5.09-5.17a.57.57 0 0 0-.83 0l-5.38 5.42 5.92 6 5.38-5.41a.58.58 0 0 0 0-.84Zm-4.41 1.38a1.4 1.4 0 0 1-2 0 1.45 1.45 0 0 1 0-2.07 1.4 1.4 0 0 1 2 0 1.55 1.55 0 0 1 0 2.07Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "m181.07 16-5.44 5.46a.57.57 0 0 0 0 .83l5.09 5.17a.57.57 0 0 0 .83 0l5.39-5.46ZM180 23a1.49 1.49 0 0 1-2 0 1.45 1.45 0 0 1 0-2.07 1.49 1.49 0 0 1 2 0 1.55 1.55 0 0 1 0 2.07Zm2.18 0a1.45 1.45 0 0 1 0-2.07 1.4 1.4 0 0 1 2 0 1.45 1.45 0 0 1 0 2.07 1.4 1.4 0 0 1-2 0Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M292.55 12.42a7.35 7.35 0 0 1-2.77.73 5 5 0 0 0 2.08-2.75 9.8 9.8 0 0 1-3 1.21 4.63 4.63 0 0 0-3.39-1.61 4.88 4.88 0 0 0-4.78 5 6.14 6.14 0 0 0 .15 1.13 13.2 13.2 0 0 1-9.78-5.09 4.66 4.66 0 0 0-.61 2.51 5.14 5.14 0 0 0 2.08 4.12 4.65 4.65 0 0 1-2.15-.57v.09a4.87 4.87 0 0 0 3.85 4.81 5.85 5.85 0 0 1-1.24.16 3.1 3.1 0 0 1-.85-.08 4.85 4.85 0 0 0 4.4 3.47 9.06 9.06 0 0 1-5.94 2.11 5 5 0 0 1-1.15-.09 13.6 13.6 0 0 0 7.31 2.19c8.7 0 13.48-7.51 13.48-14.14v-.57a15 15 0 0 0 2.31-2.63Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "m82.5 10.84-4.18 9-1.59-3.44H75l2.63 5.6H79l5.18-11.13Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.05 12.46h3.4v3h-3.4Zm-26.74 15h3.55l3.85-11.1h-3.4l-2.17 7.13-2.2-7.09H7.45l3.86 11.09Zm12.47-9a2.17 2.17 0 0 1 2.14 2.17H21.4a2.3 2.3 0 0 1 2.38-2.17m.22 6.91a2.51 2.51 0 0 1-2.57-2.47h8c0-2.38-.61-4.29-1.93-5.48a5.23 5.23 0 0 0-3.72-1.34 5.57 5.57 0 0 0-5.66 5.84 5.59 5.59 0 0 0 5.87 5.89 5.79 5.79 0 0 0 3.4-1 4.33 4.33 0 0 0 1.86-2.61H26a2 2 0 0 1-2 1.17m6.22 2.12h3.37V22.4c0-2.31 1.39-3.33 3.51-3h.07v-2.97a1.8 1.8 0 0 0-.69-.09 3.22 3.22 0 0 0-3 1.9h-.07V16.4h-3.24v11.09Zm7.88 0h3.4V16.4h-3.4Zm4.33 0h9.49v-2.66H46.5v-.07L51.63 19v-2.6h-9.25v2.67h5.2v.06l-5.2 5.81v2.55Zm15.48-2.15c-1.6 0-2.45-1.34-2.45-3.37s.85-3.38 2.45-3.38 2.49 1.32 2.49 3.38-.89 3.37-2.49 3.37m0-9.24A5.66 5.66 0 0 0 52 22a5.89 5.89 0 0 0 11.78 0 5.67 5.67 0 0 0-5.88-5.87m6.63 11.39h3.37v-6.2a2.14 2.14 0 0 1 2-2.4c1.17 0 1.77.83 1.77 2v6.58h3.38v-7.24c0-2.45-1.47-4.18-3.85-4.18a3.8 3.8 0 0 0-3.38 1.84h-.07v-1.53h-3.23Z"
            })
        ]
    });

});



parcelRegister("7wMPN", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsmNewUser", function () { return $95d02ed654de2ba5$export$6ffc4367587bf6df; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $8AXar = parcelRequire("8AXar");

var $ka4Xu = parcelRequire("ka4Xu");

var $ahLPp = parcelRequire("ahLPp");
const $95d02ed654de2ba5$export$6ffc4367587bf6df = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($95d02ed654de2ba5$export$c6387527f8ecd8a4, {});
};
const $95d02ed654de2ba5$export$c6387527f8ecd8a4 = ()=>{
    const intl = (0, $8e22h.default)();
    const subHeaderText = intl.formatMessage({
        id: 'siteActivation.loggedInJiraServiceManagement.newUser',
        defaultMessage: 'Sites are the shared space where people organize teams, work, and projects.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "gwp6480-site-activation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
            ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraServiceManagementLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahLPp.CreateASiteHeading), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: subHeaderText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
                ]
            })
        })
    });
};
const $95d02ed654de2ba5$var$containerCss = null;
const $95d02ed654de2ba5$var$headerGroupCss = null;
const $95d02ed654de2ba5$var$headerCss = null;
const $95d02ed654de2ba5$var$accentImageSpanCss = null;

});


parcelRegister("hOtJq", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsmPremium", function () { return $15c8012b74e5fdc7$export$85a8a83bf3efb849; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2WL8B = parcelRequire("2WL8B");

var $ihL7Q = parcelRequire("ihL7Q");

var $5sSB0 = parcelRequire("5sSB0");
const $15c8012b74e5fdc7$export$85a8a83bf3efb849 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5sSB0.LoggedInBlueWaveTemplateJsmNewUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihL7Q.LoggedInBlueWaveTemplateJsmExistingUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
    return null;
};

});
parcelRegister("ihL7Q", function(module, exports) {
$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmExistingUser", function () { return $4e01d4305cda8d0b$export$c20c1b72868f8509; });
/* blue-wave-template-jam-existing-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $33py5 = parcelRequire("33py5");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $4hd0c = parcelRequire("4hd0c");

var $e9I0Z = parcelRequire("e9I0Z");

var $9Zmgh = parcelRequire("9Zmgh");

var $31ZYY = parcelRequire("31ZYY");
const $4e01d4305cda8d0b$export$c20c1b72868f8509 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name, email: email } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $31ZYY.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'BxpUiSignup.nameSite.header',
                        defaultMessage: 'Welcome back, {name}'
                    }, {
                        name: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hd0c.InputEmail), {
                    email: email
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Zmgh.SubmitButtonExistingUser), {}),
                        SitePicker: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_84yz1wa3 _eeia15se"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {})
                        })
                    }),
                    ManagedUser: null,
                    WeekOneUser: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh1crf _6rth1tcg _clfd1crf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
                })
            ]
        })
    });
};
const $4e01d4305cda8d0b$var$containerCss = null;
const $4e01d4305cda8d0b$var$siteActivationHeadingCss = null;
const $4e01d4305cda8d0b$var$sitePickerCss = null;
const $4e01d4305cda8d0b$var$spacingSyles = null;

});

parcelRegister("5sSB0", function(module, exports) {
$parcel$export(module.exports, "LoggedInBlueWaveTemplateJsmNewUser", function () { return $f3fbc2180738fba3$export$2988efabf1be3838; });
/* blue-wave-template-jsm-new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lBvZp = parcelRequire("lBvZp");

var $ka4Xu = parcelRequire("ka4Xu");

var $5AtlP = parcelRequire("5AtlP");

var $7GVWk = parcelRequire("7GVWk");

var $31ZYY = parcelRequire("31ZYY");

var $759Fr = parcelRequire("759Fr");
const $f3fbc2180738fba3$export$2988efabf1be3838 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { user: { name: name } } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $31ZYY.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1tcg _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                    ]),
                    children: name ? formatMessage({
                        id: 'WacSignupForm.personalizedNameSiteMessage',
                        defaultMessage: "Let's name your site, {username}"
                    }, {
                        username: (0, $5AtlP.getFirstName)(name)
                    }) : formatMessage({
                        id: 'JiraSoftwarePageTemplate.loggedInHero.welcomeBack',
                        defaultMessage: 'Welcome back'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _syazl4fm _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    children: formatMessage({
                        id: 'WacSignupForm.inputSiteNameMessage',
                        defaultMessage: 'Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later.'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    NewUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {
                        HelperText: null,
                        SubmitButton: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $759Fr.JsmSubmitButtonNewUser), {})
                    })
                })
            ]
        })
    });
};
const $f3fbc2180738fba3$var$containerCss = null;
const $f3fbc2180738fba3$var$siteActivationHeadingCss = null;
const $f3fbc2180738fba3$var$subheaderCss = null;

});
parcelRegister("759Fr", function(module, exports) {
$parcel$export(module.exports, "JsmSubmitButtonNewUser", function () { return $cd9f1832ccec5241$export$4fca978a8ca5663a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $cd9f1832ccec5241$export$4fca978a8ca5663a = ()=>{
    const intl = (0, $8e22h.default)();
    const submitMessage = intl.formatMessage({
        id: 'bxpSignup.siteExpansion.goToProduct',
        defaultMessage: 'Go to {productName}'
    }, {
        productName: 'Jira Service Management'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("3A3ZD", function(module, exports) {
$parcel$export(module.exports, "LoggedInJsmStandard", function () { return $47c74d62b3f4a391$export$5b9d8332bb5cdf0b; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2WL8B = parcelRequire("2WL8B");

var $lSXuE = parcelRequire("lSXuE");

var $ihL7Q = parcelRequire("ihL7Q");

var $5sSB0 = parcelRequire("5sSB0");
const $47c74d62b3f4a391$export$5b9d8332bb5cdf0b = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const cohort = (0, $2WL8B.useCohort)();
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5sSB0.LoggedInBlueWaveTemplateJsmNewUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudStandard',
            defaultMessage: 'Cloud Standard'
        })
    });
    if (cohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihL7Q.LoggedInBlueWaveTemplateJsmExistingUser), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudStandard',
            defaultMessage: 'Cloud Standard'
        })
    });
    if (cohort) // bxpkit catch-all leaving in for possible restart of experiment: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/signup_trialing_add_payment_ab/results can remove ~July 18th
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
    return null;
};

});


parcelRegister("4Xs5t", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJsm", function () { return $9d8c2eb53676b726$export$da6f22575c61fffe; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $hWAtd = parcelRequire("hWAtd");

var $cPc7X = parcelRequire("cPc7X");

var $gn9TS = parcelRequire("gn9TS");
const $9d8c2eb53676b726$export$da6f22575c61fffe = ()=>{
    const isStandard = (0, $2WL8B.useStandardIntent)();
    const isPremium = (0, $2WL8B.usePremiumIntent)();
    if (isStandard) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn9TS.LoggedOutJsmStandard), {});
    if (isPremium) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cPc7X.LoggedOutJsmPremium), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hWAtd.LoggedOutJsmFree), {});
};

});
parcelRegister("hWAtd", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJsmFree", function () { return $a34923e7ace1cced$export$9512eb7977daf8ee; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $9PHXj = parcelRequire("9PHXj");
const $a34923e7ace1cced$export$9512eb7977daf8ee = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const heading1 = formatMessage({
        id: 'BxpUiSignup.SignupForm.header',
        defaultMessage: 'Get started with {product}'
    }, {
        product: 'Jira Service Management'
    });
    const heading2 = formatMessage({
        id: 'BxpUiSignup.SignupForm.subheaderJSM',
        defaultMessage: 'Free for up to 3 agents'
    });
    const helpText = formatMessage({
        id: 'BxpUiSignup.SignupForm.workCallout',
        defaultMessage: 'Find teammates, plus keep work and life separate by using your work email.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9PHXj.WhiteScreenLayout), {
        heading1: heading1,
        heading2: heading2,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
            Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9PHXj.WhiteScreenInput), {
                helpText: helpText
            }),
            Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9PHXj.WhiteScreenSocial), {}),
            Submit: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9PHXj.WhiteScreenSubmit), {})
        })
    });
};

});
parcelRegister("9PHXj", function(module, exports) {
$parcel$export(module.exports, "WhiteScreenLayout", function () { return $6abd25ba22b29657$export$81a1d5d9eb57e161; });
$parcel$export(module.exports, "WhiteScreenInput", function () { return $6abd25ba22b29657$export$958c6e6c3dbbc908; });
$parcel$export(module.exports, "WhiteScreenSocial", function () { return $6abd25ba22b29657$export$82ce61f0ce1a82ca; });
$parcel$export(module.exports, "WhiteScreenSubmit", function () { return $6abd25ba22b29657$export$56ac6208f24b9547; });
/* white-screen-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5YGzb = parcelRequire("5YGzb");
var $6A2DX = parcelRequire("6A2DX");

var $irRyj = parcelRequire("irRyj");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $7GVWk = parcelRequire("7GVWk");
const $6abd25ba22b29657$export$81a1d5d9eb57e161 = ({ children: children, heading1: heading1, heading2: heading2 })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyboxwj _1bah1yb4 _1tke1us8 _ca0q1k8s _u5f31j6v _n3td1k8s _19bv1j6v _15y110j7"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syazazsu _16jlkb7n _1o9zkb7n _i0dlf1ug _p12f1f23"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($6abd25ba22b29657$var$ProductLogo, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_syazi7uo _ect41qje _y3gn1h6o _1wybahaf _k48pni7l _vwz41btq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _15flidpf _1d2w78gw _1svyidpf _seov78gw"
                        ]),
                        children: heading1
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_syazi7uo _ect41qje _y3gn1h6o _1wyb1kw7 _k48p4jg8 _19pk1kwk _2hwxidpf _otyrviql _18u0idpf"
                        ]),
                        children: heading2
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pk1k8s _2hwx1wug _otyr1k8s _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};
const $6abd25ba22b29657$export$958c6e6c3dbbc908 = ({ helpText: helpText })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11ur1l7b _1yihtpi8 _w3o7fvs5 _17rnfvs5"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {
            helpText: helpText
        })
    });
const $6abd25ba22b29657$export$82ce61f0ce1a82ca = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_stfgidpf _zs121l7b _qmrb1yxe"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {})
    });
const $6abd25ba22b29657$export$56ac6208f24b9547 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_zs121l7b _1sg8fvs5 _1o7pdlk8 _d4lf1ylp _1gfli2wt _yhjmi2wt _1gqni2wt _11lvi2wt"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {})
    });
const $6abd25ba22b29657$var$ProductLogo = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        let logo;
        if (product?.name === 'jira') logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
            appearance: "brand",
            size: "large"
        });
        if (product?.name === 'confluence') logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceLogo), {
            appearance: "brand",
            size: "large"
        });
        if (product?.name === 'jira-servicedesk') logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraServiceManagementLogo), {
            appearance: "brand",
            size: "large"
        });
        if (product?.name === 'loom') logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomLogo), {
            appearance: "brand",
            size: "large"
        });
        if (logo) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bah1h6o _6rth1k92"
            ]),
            children: logo
        });
        return null;
    }, [
        product?.name
    ]);
};
const $6abd25ba22b29657$var$container = null;
const $6abd25ba22b29657$var$footer = null;
const $6abd25ba22b29657$var$headingStyles = {
    color: "var(--ds-text, #292A2E)",
    fontFamily: 'var(--atlassian-recommended-system-fonts)',
    // needed to override index.css
    textAlign: 'center'
};
const $6abd25ba22b29657$var$heading1Css = null;
const $6abd25ba22b29657$var$heading2Css = null;
const $6abd25ba22b29657$var$inputCss = null;
const $6abd25ba22b29657$var$logoContainerCss = null;
const $6abd25ba22b29657$var$socialCss = null;
const $6abd25ba22b29657$var$submitCss = null;
const $6abd25ba22b29657$var$wrapper = null;

});


parcelRegister("cPc7X", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJsmPremium", function () { return $b5efcef697387625$export$906416d448322e8e; });

var $7VQPk = parcelRequire("7VQPk");

var $7GioK = parcelRequire("7GioK");

var $8e22h = parcelRequire("8e22h");
const $b5efcef697387625$export$906416d448322e8e = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GioK.LoggedOutBlueWaveTemplateJsm), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudPremium',
            defaultMessage: 'Cloud Premium'
        })
    });
};

});
parcelRegister("7GioK", function(module, exports) {
$parcel$export(module.exports, "LoggedOutBlueWaveTemplateJsm", function () { return $491f57f7249043e2$export$8eb2074aaa908b62; });
/* logged-out-blue-wave-template-jsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $4qMMD = parcelRequire("4qMMD");

var $e9I0Z = parcelRequire("e9I0Z");

var $31ZYY = parcelRequire("31ZYY");
const $491f57f7249043e2$export$8eb2074aaa908b62 = ({ productEditionText: productEditionText })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $31ZYY.BlueWaveTemplateJsm), {
        productEditionText: productEditionText,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_1wyb14no _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: formatMessage({
                            id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading',
                            defaultMessage: 'Start now'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: formatMessage({
                            id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard',
                            defaultMessage: '7-day free trial for up to 10,000 users'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_85i588uy"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Login: null,
                    Separator: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {
                                separatorText: formatMessage({
                                    id: 'WacSignupForm.socialSignUpOrSignUpWith',
                                    defaultMessage: 'Or sign up with'
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $491f57f7249043e2$var$accountCreationHeadingCss = null;
const $491f57f7249043e2$var$accountCreationSubHeadingCss = null;
const $491f57f7249043e2$var$spacingCss = null;

});


parcelRegister("gn9TS", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJsmStandard", function () { return $b8af19e04296c7da$export$8a8cbd91c0868d1e; });

var $7VQPk = parcelRequire("7VQPk");

var $7GioK = parcelRequire("7GioK");

var $8e22h = parcelRequire("8e22h");
const $b8af19e04296c7da$export$8a8cbd91c0868d1e = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GioK.LoggedOutBlueWaveTemplateJsm), {
        productEditionText: formatMessage({
            id: 'WacSignupHeader.cloudStandard',
            defaultMessage: 'Cloud Standard'
        })
    });
};

});



parcelRegister("d8Fm9", function(module, exports) {
$parcel$export(module.exports, "LoomSignup", function () { return $b11ab4984c59db94$export$6434524c946a590a; });

var $7VQPk = parcelRequire("7VQPk");

var $7GVWk = parcelRequire("7GVWk");

var $18rqR = parcelRequire("18rqR");

var $h9kQO = parcelRequire("h9kQO");
const $b11ab4984c59db94$export$6434524c946a590a = ()=>{
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $18rqR.LoggedInLoom), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h9kQO.LoggedOutLoom), {});
};

});
parcelRegister("18rqR", function(module, exports) {
$parcel$export(module.exports, "LoggedInLoom", function () { return $d36daba28d9cd930$export$5f854ca694ed32ca; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $hfzfc = parcelRequire("hfzfc");

var $4X0dO = parcelRequire("4X0dO");

var $5yuBp = parcelRequire("5yuBp");

var $lSXuE = parcelRequire("lSXuE");

var $lBq55 = parcelRequire("lBq55");

var $4Q2WU = parcelRequire("4Q2WU");
const $d36daba28d9cd930$export$5f854ca694ed32ca = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    const isMobile = (0, $5yuBp.useIsMobile)(800);
    // Cohort not resolved yet (profile request in progress)
    if (cohort === undefined) return null;
    // BAU (unchanged by this experiment): new-user and existing-sites users
    // already receive the lofi Loom-backdrop experience on master, so they are
    // excluded from the experiment and always keep it. Mobile always falls back
    // to the default signup.
    if (isMobile) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
    if (cohort === 'new-user') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Q2WU.LoggedInLoomNewUser), {});
    const isPreviouslyExcludedCohort = cohort === 'managed-user' || cohort === 'week-one-user' || cohort === 'upgrade-eligible-user';
    // loom-logged-in-signup-parity: the experiment only toggles the lofi
    // experience for cohorts that previously fell back to the default signup
    // (managed-user, week-one-user, upgrade-eligible-user). Treatment shows the
    // lofi Loom-backdrop form; control preserves BAU (the default signup).
    if (isPreviouslyExcludedCohort) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfzfc.ExperimentView), {
        experiment: (0, $4X0dO.experiments).loomLoggedInSignupParity,
        render: (isEnabled)=>isEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBq55.LoggedInLoomExistingSitesUser), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {})
    });
    // All other (existing-sites) users already receive lofi on master (BAU).
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBq55.LoggedInLoomExistingSitesUser), {});
};

});
parcelRegister("lBq55", function(module, exports) {
$parcel$export(module.exports, "LoggedInLoomExistingSitesUser", function () { return $ec926cae51bf6c09$export$ef5a50e54c66f1ac; });
/* existing-sites-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $bGrkd = parcelRequire("bGrkd");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $dpXXQ = parcelRequire("dpXXQ");

var $3rmYt = parcelRequire("3rmYt");

var $dRayu = parcelRequire("dRayu");

var $emciF = parcelRequire("emciF");
const $ec926cae51bf6c09$export$ef5a50e54c66f1ac = ()=>{
    const cohort = (0, $2WL8B.useCohort)(true);
    const subHeading = cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3rmYt.JoinableSitesText), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRayu.ReturnToProductText), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                    sub: subHeading
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                    CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
};
const $ec926cae51bf6c09$var$containerCss = null;

});

parcelRegister("4Q2WU", function(module, exports) {
$parcel$export(module.exports, "LoggedInLoomNewUser", function () { return $a800efa6b15d53ba$export$7cdf426318d1c62; });
/* new-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $ahLPp = parcelRequire("ahLPp");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");
const $a800efa6b15d53ba$export$7cdf426318d1c62 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.LoomOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp19bv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                    main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahLPp.CreateASiteText), {}),
                    sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SitesAreSharedSpacesText), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                    useContactExpandCohortLogic: true
                })
            ]
        })
    });
const $a800efa6b15d53ba$var$containerCss = null;

});


parcelRegister("h9kQO", function(module, exports) {
$parcel$export(module.exports, "LoggedOutLoom", function () { return $ad869a6f5497c121$export$cbbf580c671cecaf; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $gwyhT = parcelRequire("gwyhT");

var $dpXXQ = parcelRequire("dpXXQ");

var $it3hk = parcelRequire("it3hk");

var $fvoZ8 = parcelRequire("fvoZ8");

var $eccoL = parcelRequire("eccoL");
const $ad869a6f5497c121$export$cbbf580c671cecaf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.LoomOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
                    productName: "Loom"
                }),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForTenUsersText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Submit: null
            })
        ]
    });
};

});


parcelRegister("g57i2", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionSignup", function () { return $14e76e690a9c4e63$export$ab2edc20582a9660; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $km2Yn = parcelRequire("km2Yn");

var $5CuSw = parcelRequire("5CuSw");

var $f6ctC = parcelRequire("f6ctC");

var $lCuGA = parcelRequire("lCuGA");
const $14e76e690a9c4e63$export$ab2edc20582a9660 = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    const loggedOut = (0, $2WL8B.useLoggedOut)();
    if (loggedOut) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f6ctC.LoggedOut), {});
    if (!cohort) return null;
    switch(cohort){
        case (0, $2WL8B.COHORTS).MANAGED_USER:
        case (0, $2WL8B.COHORTS).WEEK_ONE_USER:
        case (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $km2Yn.CurrentProductUser), {});
        case (0, $2WL8B.COHORTS).NEW_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lCuGA.NewUser), {});
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5CuSw.ExistingUser), {});
    }
};

});
parcelRegister("km2Yn", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $702fa5bbd8c5d25c$export$ef5a5fe6477555d4; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $702fa5bbd8c5d25c$var$CurrentProductUserContent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.PickUpWhereYouLeftOffText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {})
            })
        ]
    });
};
const $702fa5bbd8c5d25c$export$ef5a5fe6477555d4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JSMOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($702fa5bbd8c5d25c$var$CurrentProductUserContent, {})
    });

});

parcelRegister("5CuSw", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $0c55d988fe6889a5$export$706672462bf25099; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $0c55d988fe6889a5$var$ExistingUserContent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.YourPlanIncludesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
        ]
    });
};
const $0c55d988fe6889a5$export$706672462bf25099 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JSMOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0c55d988fe6889a5$var$ExistingUserContent, {})
    });

});

parcelRegister("f6ctC", function(module, exports) {
$parcel$export(module.exports, "LoggedOut", function () { return $6ee3cb126125d991$export$98c2fc75a8b753f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $lJMiD = parcelRequire("lJMiD");

var $gwyhT = parcelRequire("gwyhT");

var $aL4Vn = parcelRequire("aL4Vn");

var $gZgIU = parcelRequire("gZgIU");

var $iPPTB = parcelRequire("iPPTB");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $it3hk = parcelRequire("it3hk");
const $6ee3cb126125d991$var$LoggedOutContent = ()=>{
    const intl = (0, $8e22h.default)();
    const isJsmCrossflow = (0, $aL4Vn.useIsJsmCrossflow)();
    const headingMain = isJsmCrossflow ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.JSMCrossflowGetStartedText), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.JSMGetStartedText), {});
    const atlassianAccountLoginText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.existingAtlassianAccount',
        defaultMessage: 'Already have an Atlassian account? <logInLink>Log in</logInLink>'
    }, {
        logInLink: (text)=>$6ee3cb126125d991$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: headingMain,
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.YourPlanIncludesText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $it3hk.InputSubmitButton), {}),
                Submit: null,
                Login: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {
                    loginText: atlassianAccountLoginText
                }),
                identityCobranding: isJsmCrossflow ? 'wac--service-collection-jsm-cobranding' : 'wac--service-collection-cobranding'
            })
        ]
    });
};
const $6ee3cb126125d991$export$98c2fc75a8b753f = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JSMOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6ee3cb126125d991$var$LoggedOutContent, {})
    });
const $6ee3cb126125d991$var$logInLink = (text, location1)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $gZgIU.getLoginUrl)(location1)
    });

});

parcelRegister("lCuGA", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $62fdde3db70b367c$export$17cbb676e2e98676; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $69EgE = parcelRequire("69EgE");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");
const $62fdde3db70b367c$var$NewUserContent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69EgE.CreateAWorkspaceText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.WorkspacesAreWhereText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
        ]
    });
};
const $62fdde3db70b367c$export$17cbb676e2e98676 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwyhT.JSMOverlayTemplate), {
        size: "sm",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($62fdde3db70b367c$var$NewUserContent, {})
    });

});


parcelRegister("03fSi", function(module, exports) {
$parcel$export(module.exports, "StatuspageSignup", function () { return $5dfdff2813dac5f2$export$7f1b9f5370fc62f2; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $lSXuE = parcelRequire("lSXuE");

var $dFV4r = parcelRequire("dFV4r");
const $5dfdff2813dac5f2$export$7f1b9f5370fc62f2 = ()=>{
    const loggedOut = (0, $2WL8B.useLoggedOut)();
    if (loggedOut) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dFV4r.LoggedOut), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSXuE.SignupDefault), {});
};

});
parcelRegister("dFV4r", function(module, exports) {
$parcel$export(module.exports, "LoggedOut", function () { return $82825269ed60b084$export$98c2fc75a8b753f; });
/* logged-out.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $6KUQg = parcelRequire("6KUQg");

var $3lcPU = parcelRequire("3lcPU");

var $2WL8B = parcelRequire("2WL8B");

var $hnmMQ = parcelRequire("hnmMQ");

var $e9I0Z = parcelRequire("e9I0Z");

var $eccoL = parcelRequire("eccoL");

var $3kG7c = parcelRequire("3kG7c");
const $82825269ed60b084$export$98c2fc75a8b753f = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const standard = (0, $2WL8B.useStandardIntent)();
    const premium = (0, $2WL8B.usePremiumIntent)();
    const productEditionText = premium ? formatMessage({
        id: 'WacSignupHeader.cloudPremium',
        defaultMessage: 'Cloud Premium'
    }) : standard ? formatMessage({
        id: 'WacSignupHeader.cloudStandard',
        defaultMessage: 'Cloud Standard'
    }) : formatMessage({
        id: 'WacSignupHeader.cloudFree',
        defaultMessage: 'Cloud Free'
    });
    const headingText = premium || standard ? formatMessage({
        id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard',
        defaultMessage: 'Start now'
    }) : formatMessage({
        id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFree',
        defaultMessage: 'Get started'
    });
    const subHeadingText = premium || standard ? formatMessage({
        id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard',
        defaultMessage: '7-day free trial for up to 10,000 users'
    }) : formatMessage({
        id: 'WacSignupForm.freeAndNoCreditCardNeeded',
        defaultMessage: 'Free for up to 10 users. No credit card needed.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $3lcPU.BlueWaveTemplate), {
        productEditionText: productEditionText,
        illustration: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
                alt: ''
            }
        }),
        socialProofLogos: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kG7c.SquareVisaCiscoPfizer), {}),
        productLogos: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.StatuspageLogo), {
                size: "xlarge",
                appearance: "inverse"
            }, "statuspage")
        ],
        tagline: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText',
            defaultMessage: 'Trusted by over 65,000 teams worldwide'
        }),
        valueProps: formatMessage({
            id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeStatuspage',
            defaultMessage: 'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available'
        }).replace(/\n/g, '{newline}') // replace all newlines with a placeholder so we can split on it
        .replace(/&rsquo;/g, "\u2019") // replace the &rsquo; with an actual apostrophe
        .split('{newline}'),
        showAtlassianLogo: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybviql _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.SubHeading), {
                children: subHeadingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                Login: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e9I0Z.NoCreditCardRequired), {})
            })
        ]
    });
};
const $82825269ed60b084$var$headingCss = null;

});


parcelRegister("pdokA", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionSignup", function () { return $c00541bebfe0a6e6$export$37596ea992b819a; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $4p6Km = parcelRequire("4p6Km");

var $2F2Wy = parcelRequire("2F2Wy");

var $9jXD4 = parcelRequire("9jXD4");

var $2wyUC = parcelRequire("2wyUC");

var $3vat2 = parcelRequire("3vat2");

var $7gLca = parcelRequire("7gLca");
const $c00541bebfe0a6e6$export$37596ea992b819a = ()=>{
    const cohort = (0, $2WL8B.useCohort)();
    const loggedOut = (0, $2WL8B.useLoggedOut)();
    if (loggedOut) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7gLca.LoggedOut), {});
    if (!cohort) return null;
    switch(cohort){
        case (0, $2WL8B.COHORTS).MANAGED_USER:
        case (0, $2WL8B.COHORTS).WEEK_ONE_USER:
        case (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2F2Wy.CurrentProductUser), {});
        case (0, $2WL8B.COHORTS).CROSSFLOW_ELIGIBLE_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4p6Km.CrossflowEligibleUser), {});
        case (0, $2WL8B.COHORTS).UPLIFT_ELIGIBLE_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3vat2.UpliftEligibleUser), {});
        case (0, $2WL8B.COHORTS).NEW_USER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2wyUC.NewUser), {});
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jXD4.ExistingUser), {});
    }
};

});
parcelRegister("4p6Km", function(module, exports) {
$parcel$export(module.exports, "CrossflowEligibleUser", function () { return $3d29fee830d11a5a$export$dd75b010f23330e6; });
/* crossflow-eligible-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $44ez8 = parcelRequire("44ez8");

var $9yKAb = parcelRequire("9yKAb");

var $gwyhT = parcelRequire("gwyhT");

var $fMbfG = parcelRequire("fMbfG");

var $ff4S3 = parcelRequire("ff4S3");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $lqyi6 = parcelRequire("lqyi6");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $dpXXQ = parcelRequire("dpXXQ");

var $hun51 = parcelRequire("hun51");

var $lP6sl = parcelRequire("lP6sl");

const $3d29fee830d11a5a$var$TwcXflowModal = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("691GG")).then(({ TwcXflowModal: TwcXflowModal })=>({
            default: TwcXflowModal
        })));
const $3d29fee830d11a5a$export$dd75b010f23330e6 = ()=>{
    const [cloudId, setCloudId] = (0, $1oC0p.useState)(null);
    const location = (0, $1ka2O.useLocation)();
    const shouldOpenCrossflow = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).twcg1930TwcWacHomepage) && new URLSearchParams(location.search).has('openTwcXflowModal');
    const { locale: locale } = (0, $8e22h.default)();
    const headingText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.teamworkCollection.uplift.heading",
        defaultMessage: "Switch your site to Teamwork Collection"
    });
    if (cloudId) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $44ez8.TwcBackground), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($3d29fee830d11a5a$var$TwcXflowModal, {
                cloudId: cloudId,
                locale: locale,
                onClose: ()=>setCloudId(null),
                onComplete: ()=>window.location.assign((0, $lP6sl.getLoomTwcWelcomeUrl)(cloudId, {
                        skipUpgrade: true
                    })),
                sourceComponent: (0, $9yKAb.SOURCE_COMPONENT).WAC,
                sourceContext: (0, $9yKAb.SOURCE_CONTEXT).WAC_HOMEPAGE_TWC_OFFER,
                testId: "wac-twc-xflow-modal"
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                CrossflowEligibleUser: shouldOpenCrossflow ? /*#__PURE__*/ (0, $7VQPk.jsx)($3d29fee830d11a5a$var$CrossflowXflowPicker, {
                    onSelectSite: setCloudId
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hun51.SwitchYourSiteMessage), {})
            })
        ]
    });
};
const $3d29fee830d11a5a$var$CrossflowXflowPicker = ({ onSelectSite: onSelectSite })=>{
    const { sitePickerValue: sitePickerValue } = (0, $ff4S3.useSiteActivationContext)();
    const crossflowEligibleSites = (0, $2WL8B.useCrossflowEligibleSites)();
    const onSubmit = (event)=>{
        event.preventDefault();
        if (sitePickerValue) onSelectSite(sitePickerValue.cloudId);
    };
    if (!crossflowEligibleSites.length) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hun51.SwitchYourSiteMessage), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: onSubmit,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fMbfG.Dropdown), {
                sites: crossflowEligibleSites
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                type: "submit",
                className: (0, $2jatx.default)([
                    "_p12fglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "siteActivation.nameSiteNewUser.continueButton",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
const $3d29fee830d11a5a$var$formCss = null;
const $3d29fee830d11a5a$var$buttonCss = null;

});
parcelRegister("9yKAb", function(module, exports) {
$parcel$export(module.exports, "SOURCE_COMPONENT", function () { return $6f5b6c5da7722251$export$bc4310477dcd6b19; });
$parcel$export(module.exports, "SOURCE_CONTEXT", function () { return $6f5b6c5da7722251$export$1b7797189cccf3b2; });
var $6f5b6c5da7722251$export$bc4310477dcd6b19 = {
    ATLASSIAN_SWITCHER: 'atlassianSwitcher',
    PROJECT_PAGES: 'project-pages',
    TWC_MARKETING_EMAIL: 'marketingEmail',
    CONFLUENCE_HOME: 'confluenceHome',
    WAC: 'wac',
    STORYBOOK: 'storybook',
    TEST: 'test',
    TWC_XFLOW_CONFLUENCE_TEMPLATE: 'twcg2112ConfluenceTemplateXflow'
};
var $6f5b6c5da7722251$export$1b7797189cccf3b2 = {
    ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
    PROJECT_PAGES: 'project-pages',
    WAC_HOMEPAGE_TWC_OFFER: 'wacHomepageTwcOffer',
    STORYBOOK: 'storybook',
    TEST: 'test',
    // TWC Marketing Email (twc-marketing-email-v2) CTA contexts
    JIRA_PLATFORM_TOP_CTA: 'jiraPlatformTopCta',
    JIRA_PLATFORM_BOTTOM_CTA: 'jiraPlatformBottomCta',
    JIRA_ARTICLE_TOP_CTA: 'jiraArticleTopCta',
    JIRA_ARTICLE_BOTTOM_CTA: 'jiraArticleBottomCta',
    JIRA_DATA_TOP_CTA: 'jiraDataTopCta',
    JIRA_DATA_BOTTOM_CTA: 'jiraDataBottomCta',
    CONFLUENCE_PLATFORM_TOP_CTA: 'confluencePlatformTopCta',
    CONFLUENCE_PLATFORM_BOTTOM_CTA: 'confluencePlatformBottomCta',
    CONFLUENCE_ARTICLE_TOP_CTA: 'confluenceArticleTopCta',
    CONFLUENCE_ARTICLE_BOTTOM_CTA: 'confluenceArticleBottomCta',
    CONFLUENCE_DATA_TOP_CTA: 'confluenceDataTopCta',
    CONFLUENCE_DATA_BOTTOM_CTA: 'confluenceDataBottomCta',
    JIRA_CONF_PLATFORM_TOP_CTA: 'jiraConfPlatformTopCta',
    JIRA_CONF_PLATFORM_BOTTOM_CTA: 'jiraConfPlatformBottomCta',
    JIRA_CONF_ARTICLE_TOP_CTA: 'jiraConfArticleTopCta',
    JIRA_CONF_ARTICLE_BOTTOM_CTA: 'jiraConfArticleBottomCta',
    JIRA_CONF_DATA_TOP_CTA: 'jiraConfDataTopCta',
    JIRA_CONF_DATA_BOTTOM_CTA: 'jiraConfDataBottomCta',
    // TWCG-1794: atlassian-switcher Loom intercept (offer TWC over standalone Loom)
    ATLASSIAN_SWITCHER_LOOM_INTERCEPT: 'atlassianSwitcherLoomIntercept',
    LOOM_MEETINGS_PILL: 'loomMeetingsPill',
    SIDE_NAV_BANNER: 'sideNavBanner',
    PUBLISH_SUCCESS_FLAG: 'publishSuccessFlag',
    SHARE_SUCCESS_FLAG: 'shareSuccessFlag'
};

});

parcelRegister("hun51", function(module, exports) {
$parcel$export(module.exports, "SwitchYourSiteMessage", function () { return $f4f879ae3bf6046a$export$ebcaa81b8b47a3aa; });
/* switch-your-site-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $ff4S3 = parcelRequire("ff4S3");

var $fcO7r = parcelRequire("fcO7r");

var $lqyi6 = parcelRequire("lqyi6");
const $f4f879ae3bf6046a$export$ebcaa81b8b47a3aa = ()=>{
    let homeCtaUrl = 'https://home.atlassian.com';
    const { primaryCollectionProduct: primaryCollectionProduct } = (0, $ff4S3.useSiteActivationContext)();
    if (primaryCollectionProduct === (0, $fcO7r.ProductKey).ROVO) homeCtaUrl = `${homeCtaUrl}/chat`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _6rth14no"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "signup.teamworkCollection.uplift",
                    defaultMessage: "You already have a site that qualifies to switch over to Teamwork Collection. Admins can convert existing sites to Teamwork Collection at Atlassian Administration."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "primary",
                href: homeCtaUrl,
                target: "_self",
                className: (0, $2jatx.default)([
                    "_p12fglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "signup.teamworkCollection.uplift.button",
                    defaultMessage: "Back to Home"
                })
            })
        ]
    });
};
const $f4f879ae3bf6046a$var$contentCss = null;
const $f4f879ae3bf6046a$var$buttonCss = null;

});

parcelRegister("lP6sl", function(module, exports) {
$parcel$export(module.exports, "getLoomTwcWelcomeUrl", function () { return $96f5bc9cb55b085d$export$df1e836f27f78da7; });

var $btgvr = parcelRequire("btgvr");

var $kNE9Z = parcelRequire("kNE9Z");
const $96f5bc9cb55b085d$var$LOOM_TWC_WELCOME_URL = 'https://www.loom.com/twc/welcome';
const $96f5bc9cb55b085d$var$LOOM_TWC_WELCOME_STAGING_URL = 'https://stage.loom.com/twc/welcome';
const $96f5bc9cb55b085d$export$df1e836f27f78da7 = (siteId, { skipUpgrade: skipUpgrade = false } = {})=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($btgvr))).stringifyUrl({
        url: (0, $kNE9Z.isProduction)() ? $96f5bc9cb55b085d$var$LOOM_TWC_WELCOME_URL : $96f5bc9cb55b085d$var$LOOM_TWC_WELCOME_STAGING_URL,
        query: {
            siteId: siteId,
            // query-string serializes null as a valueless parameter (`&skipUpgrade`).
            skipUpgrade: skipUpgrade ? null : undefined
        }
    });
};

});

parcelRegister("691GG", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("41vvP"),
    $eao4m("kY8TR"),
    $eao4m("3HxAa"),
    $eao4m("aitqo"),
    $eao4m("dvKsH"),
    $eao4m("30VzF")
]).then(()=>parcelRequire('gAYGj'));

});


parcelRegister("2F2Wy", function(module, exports) {
$parcel$export(module.exports, "CurrentProductUser", function () { return $cbf3922d326c62b0$export$ef5a5fe6477555d4; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $bs458 = parcelRequire("bs458");

var $jgBbG = parcelRequire("jgBbG");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $cbf3922d326c62b0$export$ef5a5fe6477555d4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.PickUpWhereYouLeftOffText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {
                    ExistingUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {
                        SitePicker: null
                    })
                })
            })
        ]
    });

});

parcelRegister("9jXD4", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $5cc9b7488126a0a0$export$706672462bf25099; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");

var $emciF = parcelRequire("emciF");
const $5cc9b7488126a0a0$export$706672462bf25099 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $emciF.WelcomeBackText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.FreeForTenUsersText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
        ]
    });

});

parcelRegister("2wyUC", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $2a7e2813250bd212$export$17cbb676e2e98676; });

var $7VQPk = parcelRequire("7VQPk");

var $gwyhT = parcelRequire("gwyhT");

var $ka4Xu = parcelRequire("ka4Xu");

var $69EgE = parcelRequire("69EgE");

var $dpXXQ = parcelRequire("dpXXQ");

var $eccoL = parcelRequire("eccoL");
const $2a7e2813250bd212$export$17cbb676e2e98676 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $69EgE.CreateAWorkspaceText), {}),
                sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eccoL.WorkspacesAreWhereText), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {})
        ]
    });

});

parcelRegister("3vat2", function(module, exports) {
$parcel$export(module.exports, "UpliftEligibleUser", function () { return $e4fe09ccbbd08c76$export$43d4ec0de37cd914; });
/* uplift-eligible-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7qFQI = parcelRequire("7qFQI");

var $44ez8 = parcelRequire("44ez8");

var $9yKAb = parcelRequire("9yKAb");

var $iSeHD = parcelRequire("iSeHD");

var $gwyhT = parcelRequire("gwyhT");

var $fMbfG = parcelRequire("fMbfG");

var $ff4S3 = parcelRequire("ff4S3");

var $ka4Xu = parcelRequire("ka4Xu");

var $kNE9Z = parcelRequire("kNE9Z");

var $2WL8B = parcelRequire("2WL8B");

var $5Ntyw = parcelRequire("5Ntyw");

var $lqyi6 = parcelRequire("lqyi6");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $dpXXQ = parcelRequire("dpXXQ");

var $hun51 = parcelRequire("hun51");

var $lP6sl = parcelRequire("lP6sl");

const $e4fe09ccbbd08c76$var$TwcXflowModal = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("691GG")).then(({ TwcXflowModal: TwcXflowModal })=>({
            default: TwcXflowModal
        })));
const $e4fe09ccbbd08c76$export$43d4ec0de37cd914 = ()=>{
    const [xflowModalTarget, setXflowModalTarget] = (0, $1oC0p.useState)(null);
    const { locale: locale } = (0, $8e22h.default)();
    const switchYourSiteText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "signup.teamworkCollection.uplift.heading",
        defaultMessage: "Switch your site to Teamwork Collection"
    });
    if (xflowModalTarget) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $44ez8.TwcBackground), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($e4fe09ccbbd08c76$var$TwcXflowModal, {
                cloudId: xflowModalTarget.cloudId,
                locale: locale,
                onClose: ()=>setXflowModalTarget(null),
                onComplete: ()=>window.location.assign((0, $lP6sl.getLoomTwcWelcomeUrl)(xflowModalTarget.cloudId, {
                        skipUpgrade: true
                    })),
                orgId: xflowModalTarget.orgId,
                sourceComponent: (0, $9yKAb.SOURCE_COMPONENT).WAC,
                sourceContext: (0, $9yKAb.SOURCE_CONTEXT).WAC_HOMEPAGE_TWC_OFFER,
                testId: "wac-twc-xflow-modal"
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
                main: switchYourSiteText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                UpliftEligibleUser: /*#__PURE__*/ (0, $7VQPk.jsx)($e4fe09ccbbd08c76$var$UpliftPicker, {
                    onOpenXflow: setXflowModalTarget
                })
            })
        ]
    });
};
const $e4fe09ccbbd08c76$var$UpliftPicker = ({ onOpenXflow: onOpenXflow })=>{
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const [orgs, setOrgs] = (0, $1oC0p.useState)([]);
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue } = (0, $ff4S3.useSiteActivationContext)();
    const potentiallyUpliftableSites = (0, $2WL8B.useUpliftableSites)();
    const [upliftableSites, setUpliftableSites] = (0, $1oC0p.useState)([]);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const location = (0, $1ka2O.useLocation)();
    const shouldOpenCrossflow = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).twcg1930TwcWacHomepage) && new URLSearchParams(location.search).has('openTwcXflowModal');
    (0, $1oC0p.useEffect)(()=>{
        if (shouldOpenCrossflow && upliftableSites.length > 0 && !upliftableSites.some(({ cloudId: cloudId })=>cloudId === sitePickerValue?.cloudId)) setSitePickerValue(upliftableSites[0]);
    }, [
        setSitePickerValue,
        shouldOpenCrossflow,
        sitePickerValue?.cloudId,
        upliftableSites
    ]);
    const onSubmit = (e)=>{
        e.preventDefault();
        if (!sitePickerValue) return;
        const cloudId = sitePickerValue.cloudId;
        const selectedOrg = orgs.find((org)=>org.organization?.siteIds?.includes(cloudId));
        const orgId = selectedOrg?.organization?.id;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'twcUpliftForm'
        }).fire();
        if (shouldOpenCrossflow) {
            onOpenXflow({
                cloudId: cloudId,
                orgId: orgId
            });
            return;
        }
        const adminHubUrl = (0, $kNE9Z.isProduction)() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
        const upgradeUrl = `${adminHubUrl}/o/${orgId}/atlassian-apps?openAddAppDrawer=TeamworkCollection`;
        window.location.assign(upgradeUrl);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (!potentiallyUpliftableSites) return;
        if (shouldOpenCrossflow) setUpliftableSites(potentiallyUpliftableSites);
        stargateClient.getAccountOrgs({}).then(async ({ accountOrgs: accountOrgs })=>{
            if (!accountOrgs) return;
            const orgIds = accountOrgs.filter(({ isAdmin: isAdmin })=>isAdmin).map(({ id: id })=>id);
            const orgDetails = await Promise.all(orgIds.map((orgId)=>stargateClient.getSignupAccountOrgDetails({
                    orgId: orgId
                })));
            const eligibleCloudIds = orgDetails.flatMap((org)=>org.organization?.siteIds ?? []);
            const eligibleSites = potentiallyUpliftableSites.filter((site)=>eligibleCloudIds.includes(site.cloudId));
            setOrgs(orgDetails);
            if (!shouldOpenCrossflow) setUpliftableSites(eligibleSites);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        stargateClient,
        potentiallyUpliftableSites,
        shouldOpenCrossflow
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (loading || !analyticsClient) return;
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'twcUpliftScreen',
            attributes: {
                eligibleSitesCount: upliftableSites.length
            }
        }).fire();
    }, [
        loading,
        analyticsClient,
        createAnalyticsEvent,
        upliftableSites.length
    ]);
    if (loading) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _1bah1h6o _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
    if (!upliftableSites.length) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hun51.SwitchYourSiteMessage), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: onSubmit,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fMbfG.Dropdown), {
                sites: upliftableSites
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                type: "submit",
                className: (0, $2jatx.default)([
                    "_p12fglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "siteActivation.nameSiteNewUser.continueButton",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
const $e4fe09ccbbd08c76$var$formCss = null;
const $e4fe09ccbbd08c76$var$buttonCss = null;
const $e4fe09ccbbd08c76$var$spinnerContainerCss = null;

});

parcelRegister("7gLca", function(module, exports) {
$parcel$export(module.exports, "LoggedOut", function () { return $f296e07c918bba3b$export$98c2fc75a8b753f; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $gwyhT = parcelRequire("gwyhT");

var $fcO7r = parcelRequire("fcO7r");

var $1ka2O = parcelRequire("1ka2O");

var $fvoZ8 = parcelRequire("fvoZ8");

var $dpXXQ = parcelRequire("dpXXQ");
const $f296e07c918bba3b$export$98c2fc75a8b753f = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const params = new URLSearchParams(location.search);
    const primaryCollectionProduct = params.get('primaryCollectionProduct');
    let heading = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
        main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fvoZ8.GetStartedText), {
            productName: "Teamwork Collection"
        }),
        sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "signup.teamworkCollection.subHeading",
            defaultMessage: "It's free for up to 10 users - no credit card needed."
        })
    });
    if (primaryCollectionProduct === (0, $fcO7r.ProductKey).ROVO) heading = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dpXXQ.Headings), {
        main: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "signup.teamworkCollection.rovoHeading",
            defaultMessage: "Get Teamwork Collection to start using Rovo"
        }),
        sub: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "signup.teamworkCollection.rovoSubHeading",
            defaultMessage: "Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gwyhT.TwcOverlayTemplate), {
        size: "sm",
        children: [
            heading,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {})
        ]
    });
};

});






//# sourceMappingURL=index.783d4204.js.map
